'use strict';
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

const submenuAlign = ({
  name: 'align',
  add(core, targetElement) {
    const context = core.context;
    context.align = {
      _alignList: null,
      currentAlign: ''
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    let listUl = listDiv.querySelector('ul');
    /** add event listeners */

    listUl.addEventListener('click', this.pickup.bind(core));
    context.align._alignList = listUl.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null, listUl = null;
  },
  setSubmenu() {
    const lang = this.lang;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-list-layer';
    // @ts-ignore
    listDiv.innerHTML = '<div class="ke-submenu ke-list-inner ke-list-align">' + '   <ul class="ke-list-basic">' + '       <li><button type="button" class="ke-btn-list ke-btn-align" data-command="justifyleft" data-value="left" title="' + lang.toolbar.alignLeft + '"><span class="ke-icon-align-left"></span>' + lang.toolbar.alignLeft + '</button></li>' + '       <li><button type="button" class="ke-btn-list ke-btn-align" data-command="justifycenter" data-value="center" title="' + lang.toolbar.alignCenter + '"><span class="ke-icon-align-center"></span>' + lang.toolbar.alignCenter + '</button></li>' + '       <li><button type="button" class="ke-btn-list ke-btn-align" data-command="justifyright" data-value="right" title="' + lang.toolbar.alignRight + '"><span class="ke-icon-align-right"></span>' + lang.toolbar.alignRight + '</button></li>' + '       <li><button type="button" class="ke-btn-list ke-btn-align" data-command="justifyfull" data-value="justify" title="' + lang.toolbar.alignJustify + '"><span class="ke-icon-align-justify"></span>' + lang.toolbar.alignJustify + '</button></li>' + '   </ul>' + '</div>';
    return listDiv;
  },
  on() {
    const alignContext = this.context.align;
    const alignList = alignContext._alignList;
    const currentAlign = this.commandMap.ALIGN.getAttribute('data-focus') || 'left';

    if (currentAlign !== alignContext.currentAlign) {
      for (let i = 0, len = alignList.length; i < len; i++) {
        if (currentAlign === alignList[i].getAttribute('data-value')) {
          this.util.addClass(alignList[i], 'active');
        } else {
          this.util.removeClass(alignList[i], 'active');
        }
      }

      alignContext.currentAlign = currentAlign;
    }
  },
  pickup(e) {
    e.preventDefault();
    e.stopPropagation();
    let target = e.target;
    let command = null;

    while (!command && !/UL/i.test(target.tagName)) {
      command = target.getAttribute('data-command');
      target = target.parentNode;
    }

    if (!command) { return; }
    this.execCommand(command, false, null);
    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/font.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const font = ({
  name: 'font',
  add(core, targetElement) {
    const context = core.context;
    context.font = {
      _fontList: null,
      currentFont: ''
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    /** add event listeners */

    listDiv.querySelector('.ke-list-font-family').addEventListener('click', this.pickup.bind(core));
    context.font._fontList = listDiv.querySelectorAll('ul li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null;
  },
  setSubmenu() {
    const option = this.context.option;
    const lang = this.lang;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-list-layer';
    let fontInternal;
    let text: string;
    let i: number;
    let len: number;
    const fontList = !option.font ? ['Arial', 'Comic Sans MS', 'Courier New', 'Impact', 'Georgia', 'tahoma', 'Trebuchet MS', 'Verdana'] : option.font;
    // @ts-ignore
    let fontSubmenuHtml = '<div class="ke-submenu ke-list-inner ke-list-font-family">' + '   <ul class="ke-list-basic">' + '       <li><button type="button" class="default_value ke-btn-list" title="' + lang.toolbar.default + '">(' + lang.toolbar.default + ')</button></li>';

    for (i = 0, len = fontList.length; i < len; i++) {
      fontInternal = fontList[i];
      text = fontInternal.split(',')[0];
      fontSubmenuHtml += '<li><button type="button" class="ke-btn-list" data-value="' + fontInternal + '" data-txt="' + text + '" title="' + text + '" style="font-family:' + fontInternal + ';">' + text + '</button></li>';
    }

    fontSubmenuHtml += '   </ul>';
    fontSubmenuHtml += '</div>';
    listDiv.innerHTML = fontSubmenuHtml;
    return listDiv;
  },
  on() {
    const fontContext = this.context.font;
    const fontList = fontContext._fontList;
    const currentFont = this.commandMap.FONT.textContent;

    if (currentFont !== fontContext.currentFont) {
      for (let i = 0, len = fontList.length; i < len; i++) {
        if (currentFont === fontList[i].getAttribute('data-value')) {
          this.util.addClass(fontList[i], 'active');
        } else {
          this.util.removeClass(fontList[i], 'active');
        }
      }

      fontContext.currentFont = currentFont;
    }
  },
  pickup(e) {
    if (!/^BUTTON$/i.test(e.target.tagName)) { return false; }
    e.preventDefault();
    e.stopPropagation();
    const value = e.target.getAttribute('data-value');

    if (value) {
      const newNode = this.util.createElement('SPAN');
      newNode.style.fontFamily = value;
      this.nodeChange(newNode, ['font-family']);
    } else {
      this.nodeChange(null, ['font-family']);
    }

    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/fontSize.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const fontSize = ({
  name: 'fontSize',
  add(core, targetElement) {
    const context = core.context;
    context.fontSize = {
      _sizeList: null,
      currentSize: ''
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    let listUl = listDiv.querySelector('ul');
    /** add event listeners */

    listUl.addEventListener('click', this.pickup.bind(core));
    context.fontSize._sizeList = listUl.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null, listUl = null;
  },
  setSubmenu() {
    const option = this.context.option;
    const lang = this.lang;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-list-layer';
    const sizeList = !option.fontSize ? [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72] : option.fontSize;
    // @ts-ignore
    let submenuListHtml = '<div class="ke-list-inner ke-list-font-size">' + '   <ul class="ke-list-basic">' + '       <li><button type="button" class="default_value ke-btn-list" title="' + lang.toolbar.default + '">(' + lang.toolbar.default + ')</button></li>';

    for (let i = 0, len = sizeList.length; i < len; i++) {
      const size = sizeList[i];
      submenuListHtml += '<li><button type="button" class="ke-btn-list" data-value="' + size + '" title="' + size + '" style="font-size:' + size + 'px;">' + size + '</button></li>';
    }

    // @ts-ignore
    submenuListHtml += '   </ul>' + '</div>';
    listDiv.innerHTML = submenuListHtml;
    return listDiv;
  },
  on() {
    const fontSizeContext = this.context.fontSize;
    const sizeList = fontSizeContext._sizeList;
    const currentSize = (this.commandMap.SIZE.textContent.match(/\d+/) || [''])[0];

    if (currentSize !== fontSizeContext.currentSize) {
      for (let i = 0, len = sizeList.length; i < len; i++) {
        if (currentSize === sizeList[i].getAttribute('data-value')) {
          this.util.addClass(sizeList[i], 'active');
        } else {
          this.util.removeClass(sizeList[i], 'active');
        }
      }

      fontSizeContext.currentSize = currentSize;
    }
  },
  pickup(e) {
    if (!/^BUTTON$/i.test(e.target.tagName)) { return false; }
    e.preventDefault();
    e.stopPropagation();
    const value = e.target.getAttribute('data-value'); // if (value !== this.context.fontSize.currentSize) {}

    if (value) {
      const newNode = this.util.createElement('SPAN');
      newNode.style.fontSize = value + 'px';
      this.nodeChange(newNode, ['font-size']);
    } else {
      this.nodeChange(null, ['font-size']);
    }

    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/modules/colorPicker.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const colorPicker = ({
  name: 'colorPicker',
  add(core) {
    const context = core.context;
    context.colorPicker = {
      colorListHTML: '',
      _colorInput: '',
      _defaultColor: '#000',
      _styleProperty: 'color',
      _currentColor: '',
      _colorList: []
    };
    /** set submenu */

    let listDiv = this.createColorList(core.context.option, core.lang, this._makeColorList);
    /** caching */

    context.colorPicker.colorListHTML = listDiv;
    /** empty memory */

    listDiv = null;
  },
  createColorList(option, lang, makeColor) {
    const colorList = !option.colorList || option.colorList.length === 0 ? ['#ff0000', '#ff5e00', '#ffe400', '#abf200', '#00d8ff', '#0055ff', '#6600ff', '#ff00dd', '#000000', '#ffd8d8', '#fae0d4', '#faf4c0', '#e4f7ba', '#d4f4fa', '#d9e5ff', '#e8d9ff', '#ffd9fa', '#f1f1f1', '#ffa7a7', '#ffc19e', '#faed7d', '#cef279', '#b2ebf4', '#b2ccff', '#d1b2ff', '#ffb2f5', '#bdbdbd', '#f15f5f', '#f29661', '#e5d85c', '#bce55c', '#5cd1e5', '#6699ff', '#a366ff', '#f261df', '#8c8c8c', '#980000', '#993800', '#998a00', '#6b9900', '#008299', '#003399', '#3d0099', '#990085', '#353535', '#670000', '#662500', '#665c00', '#476600', '#005766', '#002266', '#290066', '#660058', '#222222'] : option.colorList;
    let colorArr = [];
    let internalList = '<div class="ke-list-inner">';

    for (let i = 0, len = colorList.length; i < len; i++) {
      if (typeof colorList[i] === 'string') {
        colorArr.push(colorList[i]);
        if (i < len - 1) { continue; }
      }

      if (colorArr.length > 0) {
        internalList += '<div class="ke-selector-color">' + makeColor(colorArr) + '</div>';
        colorArr = [];
      }

      if (typeof colorList[i] === 'object') {
        internalList += '<div class="ke-selector-color">' + makeColor(colorList[i]) + '</div>';
      }
    }

    // @ts-ignore
    internalList += '' + '<form class="ke-submenu-form-group">' + '   <input type="text" maxlength="7" class="_se_color_picker_input" />' + '   <button type="submit" class="ke-btn-primary ke-tooltip _se_color_picker_submit">' + '       <i class="ke-icon-checked"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.submitButton + '</span></span>' + '   </button>' + '   <button type="button" class="ke-btn ke-tooltip _se_color_picker_remove">' + '       <i class="ke-icon-erase"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.removeFormat + '</span></span>' + '   </button>' + '</form>' + '</div>';
    return internalList;
  },
  _makeColorList(colorList) {
    let internalList = '';
    internalList += '<ul class="ke-color-pallet">';

    for (let i = 0, len = colorList.length, color; i < len; i++) {
      color = colorList[i];

      if (typeof color === 'string') {
        // @ts-ignore
        internalList += '<li>' + '   <button type="button" data-value="' + color + '" title="' + color + '" style="background-color:' + color + ';"></button>' + '</li>';
      }
    }

    internalList += '</ul>';
    return internalList;
  },
  init(node, color) {
    const initColorPickerObj = this.plugins.colorPicker;
    let fillColor = color ? color : initColorPickerObj.getColorInNode.call(this, node) || this.context.colorPicker._defaultColor;
    fillColor = initColorPickerObj.isHexColor(fillColor) ? fillColor : initColorPickerObj.rgb2hex(fillColor) || fillColor;
    const colorList = this.context.colorPicker._colorList;

    if (colorList) {
      for (let i = 0, len = colorList.length; i < len; i++) {
        if (fillColor.toLowerCase() === colorList[i].getAttribute('data-value').toLowerCase()) {
          this.util.addClass(colorList[i], 'active');
        } else {
          this.util.removeClass(colorList[i], 'active');
        }
      }
    }

    initColorPickerObj.setInputText.call(this, initColorPickerObj.colorName2hex.call(this, fillColor));
  },
  setCurrentColor(hexColorStr) {
    this.context.colorPicker._currentColor = hexColorStr;
    this.context.colorPicker._colorInput.style.borderColor = hexColorStr;
  },
  setInputText(hexColorStr) {
    hexColorStr = /^#/.test(hexColorStr) ? hexColorStr : '#' + hexColorStr;
    this.context.colorPicker._colorInput.value = hexColorStr;
    this.plugins.colorPicker.setCurrentColor.call(this, hexColorStr);
  },
  getColorInNode(node) {
    let findColor = '';
    const styleProperty = this.context.colorPicker._styleProperty;

    while (node && !this.util.isWysiwygDiv(node) && findColor.length === 0) {
      if (node.nodeType === 1 && node.style[styleProperty]) { findColor = node.style[styleProperty]; }
      node = node.parentNode;
    }

    return findColor;
  },

  /**
   * @description Function to check hex format color
   */
  isHexColor(str: string) {
    return /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(str);
  },

  /**
   * @description Function to convert hex format to a rgb color
   * @param rgb RGB color format
   * @returns A hexadecimal string with # followed by 6 hex digits
   */
  rgb2hex(rgb: string) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i).toString();
    return rgb && rgb.length === 4 ? '#' + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
  },

  /**
   * @description Converts a color name into its hexadecimal string
   * @param colorName The color name, such as 'white', 'green' or others
   * @returns Returns a hex string on success, false on failure
   */
  colorName2hex(colorName: string): string | false {
    if (/^#/.test(colorName)) { return colorName; }
    const temp = this.util.createElement('div');
    temp.style.display = 'none';
    temp.style.color = colorName;

    const colors = window.getComputedStyle(document.body.appendChild(temp)).color.match(/\d+/g).map((a) => {
      return parseInt(a, 10);
    });

    this.util.removeItem(temp);
    // @ts-ignore
    return colors.length >= 3 ? '#' + ((1 << 24) + (colors[0] << 16) + (colors[1] << 8) + colors[2]).toString(16).substr(1) : false;
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/fontColor.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */
const fontColor = ({
  name: 'fontColor',
  add(core, targetElement) {
    core.addModule([colorPicker]);
    const context = core.context;
    context.fontColor = {
      previewEl: null,
      colorInput: null,
      colorList: null
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    context.fontColor.colorInput = listDiv.querySelector('._se_color_picker_input');
    /** add event listeners */

    context.fontColor.colorInput.addEventListener('keyup', this.onChangeInput.bind(core));
    listDiv.querySelector('._se_color_picker_submit').addEventListener('click', this.submit.bind(core));
    listDiv.querySelector('._se_color_picker_remove').addEventListener('click', this.remove.bind(core));
    listDiv.addEventListener('click', this.pickup.bind(core));
    context.fontColor.colorList = listDiv.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null;
  },
  setSubmenu() {
    const colorArea = this.context.colorPicker.colorListHTML;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-list-layer';
    listDiv.innerHTML = colorArea;
    return listDiv;
  },
  on() {
    const contextPicker = this.context.colorPicker;
    const contextFontColor = this.context.fontColor;
    contextPicker._colorInput = contextFontColor.colorInput;
    contextPicker._defaultColor = '#333333';
    contextPicker._styleProperty = 'color';
    contextPicker._colorList = contextFontColor.colorList;
    this.plugins.colorPicker.init.call(this, this.getSelectionNode(), null);
  },
  onChangeInput(e) {
    this.plugins.colorPicker.setCurrentColor.call(this, e.target.value);
  },
  remove() {
    this.nodeChange(null, ['color']);
    this.submenuOff();
    this.focus();
  },
  submit() {
    this.plugins.fontColor.applyColor.call(this, this.context.colorPicker._currentColor);
  },
  pickup(e) {
    e.preventDefault();
    e.stopPropagation();
    this.plugins.fontColor.applyColor.call(this, e.target.getAttribute('data-value'));
  },
  applyColor(color) {
    if (!color) { return; }
    const newNode = this.util.createElement('SPAN');
    newNode.style.color = color;
    this.nodeChange(newNode, ['color']);
    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/hiliteColor.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */



const hiliteColor = ({
  name: 'hiliteColor',
  add(core, targetElement) {
    core.addModule([colorPicker]);
    const context = core.context;
    context.hiliteColor = {
      previewEl: null,
      colorInput: null,
      colorList: null
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    context.hiliteColor.colorInput = listDiv.querySelector('._se_color_picker_input');
    /** add event listeners */

    context.hiliteColor.colorInput.addEventListener('keyup', this.onChangeInput.bind(core));
    listDiv.querySelector('._se_color_picker_submit').addEventListener('click', this.submit.bind(core));
    listDiv.querySelector('._se_color_picker_remove').addEventListener('click', this.remove.bind(core));
    listDiv.addEventListener('click', this.pickup.bind(core));
    context.hiliteColor.colorList = listDiv.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null;
  },
  setSubmenu() {
    const colorArea = this.context.colorPicker.colorListHTML;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-list-layer';
    listDiv.innerHTML = colorArea;
    return listDiv;
  },
  on() {
    const contextPicker = this.context.colorPicker;
    const contextHiliteColor = this.context.hiliteColor;
    contextPicker._colorInput = contextHiliteColor.colorInput;
    contextPicker._defaultColor = '#FFFFFF';
    contextPicker._styleProperty = 'backgroundColor';
    contextPicker._colorList = contextHiliteColor.colorList;
    this.plugins.colorPicker.init.call(this, this.getSelectionNode(), null);
  },
  onChangeInput(e) {
    this.plugins.colorPicker.setCurrentColor.call(this, e.target.value);
  },
  remove() {
    this.nodeChange(null, ['background-color']);
    this.submenuOff();
    this.focus();
  },
  submit() {
    this.plugins.hiliteColor.applyColor.call(this, this.context.colorPicker._currentColor);
  },
  pickup(e) {
    e.preventDefault();
    e.stopPropagation();
    this.plugins.hiliteColor.applyColor.call(this, e.target.getAttribute('data-value'));
  },
  applyColor(color) {
    if (!color) { return; }
    const newNode = this.util.createElement('SPAN');
    newNode.style.backgroundColor = color;
    this.nodeChange(newNode, ['background-color']);
    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/horizontalRule.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const horizontalRule = ({
  name: 'horizontalRule',
  add(core, targetElement) {
    /** set submenu */
    let listDiv = this.setSubmenu.call(core);
    /** add event listeners */

    listDiv.querySelector('ul').addEventListener('click', this.horizontalRulePick.bind(core));
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null;
  },
  setSubmenu() {
    const lang = this.lang;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-list-layer';
    // @ts-ignore
    listDiv.innerHTML = '' + '<div class="ke-list-inner ke-list-line">' + '   <ul class="ke-list-basic">' + '       <li>' + '           <button type="button" class="ke-btn-list btn_line ke-tooltip" data-command="horizontalRule" data-value="solid">' + '               <hr style="border-width: 1px 0 0; border-style: solid none none; border-color: black; border-image: initial; height: 1px;" />' + '               <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.hr_solid + '</span></span>' + '           </button>' + '       </li>' + '       <li>' + '           <button type="button" class="ke-btn-list btn_line ke-tooltip" data-command="horizontalRule" data-value="dotted">' + '               <hr style="border-width: 1px 0 0; border-style: dotted none none; border-color: black; border-image: initial; height: 1px;" />' + '               <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.hr_dotted + '</span></span>' + '           </button>' + '       </li>' + '       <li>' + '           <button type="button" class="ke-btn-list btn_line ke-tooltip" data-command="horizontalRule" data-value="dashed">' + '               <hr style="border-width: 1px 0 0; border-style: dashed none none; border-color: black; border-image: initial; height: 1px;" />' + '               <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.hr_dashed + '</span></span>' + '           </button>' + '       </li>' + '   </ul>' + '</div>';
    return listDiv;
  },
  appendHr(className) {
    const oHr = this.util.createElement('HR');
    oHr.className = className;
    this.focus();
    const oNode = this.insertComponent(oHr);
    this.setRange(oNode, 0, oNode, 0);
  },
  horizontalRulePick(e) {
    e.preventDefault();
    e.stopPropagation();
    let target = e.target;
    let value = null;

    while (!value && !/UL/i.test(target.tagName)) {
      value = target.getAttribute('data-value');
      target = target.parentNode;
    }

    if (!value) { return; }
    this.plugins.horizontalRule.appendHr.call(this, '__se__' + value);
    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/list.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const list = ({
  name: 'list',
  add(core, targetElement) {
    const context = core.context;
    context.list = {
      _list: null,
      currentList: ''
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    let listUl = listDiv.querySelector('ul');
    /** add event listeners */

    listUl.addEventListener('click', this.pickup.bind(core));
    context.list._list = listUl.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null, listUl = null;
  },
  setSubmenu() {
    const lang = this.lang;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-list-layer';
    // @ts-ignore
    listDiv.innerHTML = '' + '<div class="ke-list-inner">' + '   <ul class="ke-list-basic">' + '       <li><button type="button" class="ke-btn-list ke-tooltip" data-command="OL">' + '           <i class="ke-icon-list-number"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.orderList + '</span></span>' + '       </button></li>' + '       <li><button type="button" class="ke-btn-list ke-tooltip" data-command="UL">' + '           <i class="ke-icon-list-bullets"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.unorderList + '</span></span>' + '       </button></li>' + '   </ul>' + '</div>';
    return listDiv;
  },
  on() {
    const listContext = this.context.list;
    const listContextList = listContext._list;
    const currentList = this.commandMap.LI.getAttribute('data-focus') || '';

    if (currentList !== listContext.currentList) {
      for (let i = 0, len = listContextList.length; i < len; i++) {
        if (currentList === listContextList[i].getAttribute('data-command')) {
          this.util.addClass(listContextList[i], 'active');
        } else {
          this.util.removeClass(listContextList[i], 'active');
        }
      }

      listContext.currentList = currentList;
    }
  },
  pickup(e) {
    e.preventDefault();
    e.stopPropagation();
    let target = e.target;
    let command = '';

    while (!command && !/^UL$/i.test(target.tagName)) {
      command = target.getAttribute('data-command');
      target = target.parentNode;
    }

    if (!command) { return; }
    const selectedFormsts = this.getSelectedElementsAndComponents();
    if (!selectedFormsts || selectedFormsts.length === 0) { return; }
    let isRemove = true;
    let edgeFirst = null;
    let edgeLast = null; // merge

    const firstSel = selectedFormsts[0];
    const lastSel = selectedFormsts[selectedFormsts.length - 1];
    let topEl = (this.util.isListCell(firstSel) || this.util.isComponent(firstSel)) && !firstSel.previousElementSibling ? firstSel.parentNode.previousElementSibling : firstSel.previousElementSibling;
    let bottomEl = (this.util.isListCell(lastSel) || this.util.isComponent(lastSel)) && !lastSel.nextElementSibling ? lastSel.parentNode.nextElementSibling : lastSel.nextElementSibling;

    for (let i = 0, len = selectedFormsts.length; i < len; i++) {
      if (!this.util.isList(this.util.getRangeFormatElement(selectedFormsts[i], function(current) {
        return this.getRangeFormatElement(current) && current !== selectedFormsts[i];
      }.bind(this.util)))) {
        isRemove = false;
        break;
      }
    }

    if (isRemove && (!topEl || command !== topEl.tagName) && (!bottomEl || command !== bottomEl.tagName)) {
      const currentFormat = this.util.getRangeFormatElement(this.getSelectionNode());
      const cancel = currentFormat && currentFormat.tagName === command;
      let rangeArr;
      let tempList;

      const passComponent = function(current) {
        return !this.isComponent(current);
      }.bind(this.util);

      if (!cancel) { tempList = this.util.createElement(command); }

      for (let i = 0, len = selectedFormsts.length, r, o; i < len; i++) {
        o = this.util.getRangeFormatElement(selectedFormsts[i], passComponent);
        if (!o || !this.util.isList(o)) { continue; }

        if (!r) {
          r = o;
          rangeArr = {
            r,
            f: [this.util.getParentElement(selectedFormsts[i], 'LI')]
          };
        } else {
          if (r !== o) {
            const edge = this.detachRangeFormatElement(rangeArr.r, rangeArr.f, tempList, false, true);
            if (!edgeFirst) { edgeFirst = edge; }
            if (!cancel) { tempList = this.util.createElement(command); }
            r = o;
            rangeArr = {
              r,
              f: [this.util.getParentElement(selectedFormsts[i], 'LI')]
            };
          } else {
            rangeArr.f.push(this.util.getParentElement(selectedFormsts[i], 'LI'));
          }
        }

        if (i === len - 1) {
          edgeLast = this.detachRangeFormatElement(rangeArr.r, rangeArr.f, tempList, false, true);
          if (!edgeFirst) { edgeFirst = edgeLast; }
        }
      }
    } else {
      const topElParent = topEl ? topEl.parentNode : topEl;
      const bottomElParent = bottomEl ? bottomEl.parentNode : bottomEl;
      topEl = topElParent && !this.util.isWysiwygDiv(topElParent) && topElParent.nodeName === command ? topElParent : topEl;
      bottomEl = bottomElParent && !this.util.isWysiwygDiv(bottomElParent) && bottomElParent.nodeName === command ? bottomElParent : bottomEl;
      const mergeTop = topEl && topEl.tagName === command;
      const mergeBottom = bottomEl && bottomEl.tagName === command;
      let internalElseList = mergeTop ? topEl : this.util.createElement(command);
      let firstList = null;
      let lastList = null;
      let topNumber = null;
      let bottomNumber = null;

      const passComponent = function(current) {
        return !this.isComponent(current) && !this.isList(current);
      }.bind(this.util);

      for (let i = 0, len = selectedFormsts.length, newCell, fTag, isCell, next, originParent, nextParent, parentTag, siblingTag, rangeTag; i < len; i++) {
        fTag = selectedFormsts[i];

        if (fTag.childNodes.length === 0 && !this.util.isIgnoreNodeChange(fTag)) {
          this.util.removeItem(fTag);
          continue;
        }

        next = selectedFormsts[i + 1];
        originParent = fTag.parentNode;
        nextParent = next ? next.parentNode : null;
        isCell = this.util.isListCell(fTag);
        rangeTag = this.util.isRangeFormatElement(originParent) ? originParent : null;
        parentTag = isCell && !this.util.isWysiwygDiv(originParent) ? originParent.parentNode : originParent;
        siblingTag = isCell && !this.util.isWysiwygDiv(originParent) ? !next ? originParent : originParent.nextSibling : fTag.nextSibling;
        newCell = this.util.createElement('LI');

        if (this.util.isComponent(fTag)) {
          const isHR = /^HR$/i.test(fTag.nodeName);
          if (!isHR) { newCell.innerHTML = '<br>'; }
          newCell.innerHTML += fTag.outerHTML;
          if (isHR) { newCell.innerHTML += '<br>'; }
        } else {
          newCell.innerHTML = fTag.innerHTML;
        }

        internalElseList.appendChild(newCell);
        if (!next) { lastList = internalElseList; }

        if (!next || parentTag !== nextParent || this.util.isRangeFormatElement(siblingTag)) {
          if (!firstList) { firstList = internalElseList; }

          if ((!mergeTop || !next || parentTag !== nextParent) && !(next && this.util.isList(nextParent) && nextParent === originParent)) {
            if (internalElseList.parentNode !== parentTag) { parentTag.insertBefore(internalElseList, siblingTag); }
          }
        }

        this.util.removeItem(fTag);
        if (mergeTop && topNumber === null) { topNumber = internalElseList.children.length - 1; }

        if (next && this.util.getRangeFormatElement(nextParent, passComponent) !== this.util.getRangeFormatElement(originParent, passComponent)) {
          internalElseList = this.util.createElement(command);
        }

        if (rangeTag && rangeTag.children.length === 0) { this.util.removeItem(rangeTag); }
      }

      if (topNumber) {
        firstList = firstList.children[topNumber];
      }

      if (mergeBottom) {
        bottomNumber = internalElseList.children.length - 1;
        internalElseList.innerHTML += bottomEl.innerHTML;
        lastList = internalElseList.children[bottomNumber];
        this.util.removeItem(bottomEl);
      }

      edgeFirst = edgeLast = this.util.getEdgeChildNodes(firstList.firstChild, lastList.lastChild);
    } // history stack


    this.history.push();

    if (selectedFormsts.length > 1) {
      this.setRange(edgeFirst.sc, 0, edgeLast.ec, edgeLast.ec.textContent.length);
    } else {
      this.setRange(edgeFirst.ec, edgeFirst.ec.textContent.length, edgeLast.ec, edgeLast.ec.textContent.length);
    }

    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/table.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const table = ({
  name: 'table',
  add(core, targetElement) {
    const context = core.context;
    context.table = {
      _element: null,
      _tdElement: null,
      _trElement: null,
      _trElements: null,
      _tableXY: [],
      _maxWidth: true,
      resizeIcon: null,
      resizeText: null,
      headerButton: null,
      mergeButton: null,
      splitButton: null,
      splitMenu: null,
      maxText: core.lang.controller.maxSize,
      minText: core.lang.controller.minSize,
      _physical_cellCnt: 0,
      _logical_cellCnt: 0,
      _rowCnt: 0,
      _rowIndex: 0,
      _physical_cellIndex: 0,
      _logical_cellIndex: 0,
      _current_colSpan: 0,
      _current_rowSpan: 0
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    let tablePicker = listDiv.querySelector('.ke-controller-table-picker');
    context.table.tableHighlight = listDiv.querySelector('.ke-table-size-highlighted');
    context.table.tableUnHighlight = listDiv.querySelector('.ke-table-size-unhighlighted');
    context.table.tableDisplay = listDiv.querySelector('.ke-table-size-display');
    /** set table controller */

    let tableController = this.setController_table.call(core);
    context.table.tableController = tableController;
    context.table.resizeIcon = tableController.querySelector('._se_table_resize > i');
    context.table.resizeText = tableController.querySelector('._se_table_resize > span > span');
    context.table.headerButton = tableController.querySelector('._se_table_header');
    tableController.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    }, false);
    /** set resizing */

    let resizeDiv = this.setController_tableEditor.call(core);
    context.table.resizeDiv = resizeDiv;
    context.table.splitMenu = resizeDiv.querySelector('.ke-btn-group-sub');
    context.table.mergeButton = resizeDiv.querySelector('._se_table_merge_button');
    context.table.splitButton = resizeDiv.querySelector('._se_table_split_button');
    resizeDiv.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    }, false);
    /** add event listeners */

    tablePicker.addEventListener('mousemove', this.onMouseMove_tablePicker.bind(core));
    tablePicker.addEventListener('click', this.appendTable.bind(core));
    resizeDiv.addEventListener('click', this.onClick_tableController.bind(core));
    tableController.addEventListener('click', this.onClick_tableController.bind(core));
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    context.element.relative.appendChild(resizeDiv);
    context.element.relative.appendChild(tableController);
    /** empty memory */

    listDiv = null, tablePicker = null, resizeDiv = null, tableController = null;
  },
  setSubmenu() {
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-submenu ke-selector-table';
    // @ts-ignore
    listDiv.innerHTML = '' + '<div class="ke-table-size">' + '   <div class="ke-table-size-picker ke-controller-table-picker"></div>' + '   <div class="ke-table-size-highlighted"></div>' + '   <div class="ke-table-size-unhighlighted"></div>' + '</div>' + '<div class="ke-table-size-display">1 x 1</div>';
    return listDiv;
  },
  setController_table() {
    const lang = this.lang;
    const tableResize = this.util.createElement('DIV');
    tableResize.className = 'ke-controller ke-controller-table';
    // @ts-ignore
    tableResize.innerHTML = '' + '<div>' + '   <div class="ke-btn-group">' + '       <button type="button" data-command="resize" class="ke-tooltip _se_table_resize">' + '           <i class="ke-icon-expansion"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.maxSize + '</span></span>' + '       </button>' + '       <button type="button" data-command="header" class="ke-tooltip _se_table_header">' + '           <i class="ke-icon-table-header"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.tableHeader + '</span></span>' + '       </button>' + '       <button type="button" data-command="remove" class="ke-tooltip">' + '           <i class="ke-icon-delete"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.remove + '</span></span>' + '       </button>' + '   </div>' + '</div>';
    return tableResize;
  },
  setController_tableEditor() {
    const lang = this.lang;
    const tableResize = this.util.createElement('DIV');
    tableResize.className = 'ke-controller ke-controller-table-cell';
    // @ts-ignore
    tableResize.innerHTML = '' + '<div class="ke-arrow ke-arrow-up"></div>' + '<div>' + '   <div class="ke-btn-group">' + '       <button type="button" data-command="insert" data-value="row" data-option="up" class="ke-tooltip">' + '           <i class="ke-icon-insert-row-above"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.insertRowAbove + '</span></span>' + '       </button>' + '       <button type="button" data-command="insert" data-value="row" data-option="down" class="ke-tooltip">' + '           <i class="ke-icon-insert-row-below"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.insertRowBelow + '</span></span>' + '       </button>' + '       <button type="button" data-command="delete" data-value="row" class="ke-tooltip">' + '           <i class="ke-icon-delete-row"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.deleteRow + '</span></span>' + '       </button>' + '       <button type="button" data-command="merge" class="_se_table_merge_button ke-tooltip" disabled>' + '           <i class="ke-icon-merge-cell"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.mergeCells + '</span></span>' + '       </button>' + '   </div>' + '</div>' + '<div>' + '   <div class="ke-btn-group">' + '     <button type="button" data-command="insert" data-value="cell" data-option="left" class="ke-tooltip">' + '       <i class="ke-icon-insert-column-left"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.insertColumnBefore + '</span></span>' + '       </button>' + '       <button type="button" data-command="insert" data-value="cell" data-option="right" class="ke-tooltip">' + '           <i class="ke-icon-insert-column-right"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.insertColumnAfter + '</span></span>' + '       </button>' + '       <button type="button" data-command="delete" data-value="cell" class="ke-tooltip">' + '           <i class="ke-icon-delete-column"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.deleteColumn + '</span></span>' + '       </button>' + '       <button type="button" data-command="onsplit" class="_se_table_split_button ke-tooltip">' + '           <i class="ke-icon-split-cell"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.splitCells + '</span></span>' + '       </button>' + '       <div class="ke-btn-group-sub keditor-common ke-list-layer">' + '           <div class="ke-list-inner">' + '               <ul class="ke-list-basic">' + '                   <li class="ke-btn-list" data-command="split" data-value="vertical" style="line-height:32px;" title="' + lang.controller.VerticalSplit + '">' + '                   ' + lang.controller.VerticalSplit + '</li>' + '                   <li class="ke-btn-list" data-command="split" data-value="horizontal" style="line-height:32px;" title="' + lang.controller.HorizontalSplit + '">' + '                   ' + lang.controller.HorizontalSplit + '</li>' + '               </ul>' + '           </div>' + '       </div>' + '   </div>' + '</div>';
    return tableResize;
  },
  appendTable() {
    const oTable = this.util.createElement('TABLE');
    const createCells = this.plugins.table.createCells;
    const x = this.context.table._tableXY[0];
    let y = this.context.table._tableXY[1];
    let tableHTML = '<tbody>';

    while (y > 0) {
      tableHTML += '<tr>' + createCells.call(this, 'td', x) + '</tr>';
      --y;
    }

    tableHTML += '</tbody>';
    oTable.innerHTML = tableHTML;
    this.insertComponent(oTable);
    this.focus();
    this.plugins.table.reset_table_picker.call(this);
  },
  createCells(nodeName, cnt, returnElement) {
    nodeName = nodeName.toLowerCase();

    if (!returnElement) {
      let cellsHTML = '';

      while (cnt > 0) {
        cellsHTML += '<' + nodeName + '><br></' + nodeName + '>';
        cnt--;
      }

      return cellsHTML;
    } else {
      const cell = this.util.createElement(nodeName);
      cell.innerHTML = '<br>';
      return cell;
    }
  },
  onMouseMove_tablePicker(e) {
    e.stopPropagation();

    let x = Math.ceil(e.offsetX / 18);

    let y = Math.ceil(e.offsetY / 18);

    x = x < 1 ? 1 : x;
    y = y < 1 ? 1 : y;
    this.context.table.tableHighlight.style.width = x + 'em';
    this.context.table.tableHighlight.style.height = y + 'em';
    const xu = x < 5 ? 5 : x > 9 ? 10 : x + 1;
    const yu = y < 5 ? 5 : y > 9 ? 10 : y + 1;
    this.context.table.tableUnHighlight.style.width = xu + 'em';
    this.context.table.tableUnHighlight.style.height = yu + 'em';
    this.util.changeTxt(this.context.table.tableDisplay, x + ' x ' + y);
    this.context.table._tableXY = [x, y];
  },
  reset_table_picker() {
    if (!this.context.table.tableHighlight) { return; }
    const highlight = this.context.table.tableHighlight.style;
    const unHighlight = this.context.table.tableUnHighlight.style;
    highlight.width = '1em';
    highlight.height = '1em';
    unHighlight.width = '5em';
    unHighlight.height = '5em';
    this.util.changeTxt(this.context.table.tableDisplay, '1 x 1');
    this.submenuOff();
  },
  init() {
    const contextTable = this.context.table;
    const tablePlugin = this.plugins.table;

    tablePlugin._removeEvents.call(this);

    if (tablePlugin._selectedTable) {
      const selectedCells = tablePlugin._selectedTable.querySelectorAll('.ke-table-selected-cell');

      for (let i = 0, len = selectedCells.length; i < len; i++) {
        this.util.removeClass(selectedCells[i], 'ke-table-selected-cell');
      }
    }

    tablePlugin._toggleEditor.call(this, true);

    contextTable._element = null;
    contextTable._tdElement = null;
    contextTable._trElement = null;
    contextTable._trElements = null;
    contextTable._tableXY = [];
    contextTable._maxWidth = true;
    contextTable._physical_cellCnt = 0;
    contextTable._logical_cellCnt = 0;
    contextTable._rowCnt = 0;
    contextTable._rowIndex = 0;
    contextTable._physical_cellIndex = 0;
    contextTable._logical_cellIndex = 0;
    contextTable._current_colSpan = 0;
    contextTable._current_rowSpan = 0;
    tablePlugin._shift = false;
    tablePlugin._selectedCells = null;
    tablePlugin._selectedTable = null;
    tablePlugin._ref = null;
    tablePlugin._fixedCell = null;
    tablePlugin._selectedCell = null;
    tablePlugin._fixedCellName = null;
  },

  /** table edit controller */
  call_controller_tableEdit(tdElement) {
    const contextTable = this.context.table;
    const tablePlugin = this.plugins.table;
    const tableController = contextTable.tableController;
    tablePlugin.setPositionControllerDiv.call(this, tdElement, tablePlugin._shift);
    const tableElement = contextTable._element;
    const offset = this.util.getOffset(tableElement, this.context.element.wysiwygFrame);
    contextTable._maxWidth = !tableElement.style.width || tableElement.style.width === '100%';
    tablePlugin.resizeTable.call(this);
    tableController.style.left = offset.left + 'px';
    tableController.style.display = 'block';
    tableController.style.top = offset.top - tableController.offsetHeight - 2 + 'px';
    if (!tablePlugin._shift) { this.controllersOn(contextTable.resizeDiv, tableController, tablePlugin.init.bind(this)); }
  },
  setPositionControllerDiv(tdElement, reset) {
    const contextTable = this.context.table;
    const resizeDiv = contextTable.resizeDiv;
    this.plugins.table.setCellInfo.call(this, tdElement, reset);
    resizeDiv.style.display = 'block';
    const offset = this.util.getOffset(tdElement, this.context.element.wysiwygFrame);
    resizeDiv.style.left = offset.left - this.context.element.wysiwygFrame.scrollLeft + 'px';
    resizeDiv.style.top = offset.top + tdElement.offsetHeight + 12 + 'px';
    const overLeft = this.context.element.wysiwygFrame.offsetWidth - (resizeDiv.offsetLeft + resizeDiv.offsetWidth);

    if (overLeft < 0) {
      resizeDiv.style.left = resizeDiv.offsetLeft + overLeft + 'px';
      resizeDiv.firstElementChild.style.left = 20 - overLeft + 'px';
    } else {
      resizeDiv.firstElementChild.style.left = '20px';
    }
  },
  setCellInfo(tdElement, reset) {
    const contextTable = this.context.table;
    const cellInfoTable = contextTable._element = this.plugins.table._selectedTable || this.util.getParentElement(tdElement, 'TABLE');

    if (/THEAD/i.test(cellInfoTable.firstElementChild.nodeName)) {
      this.util.addClass(contextTable.headerButton, 'active');
    } else {
      this.util.removeClass(contextTable.headerButton, 'active');
    }

    if (reset || contextTable._physical_cellCnt === 0) {
      if (contextTable._tdElement !== tdElement) {
        contextTable._tdElement = tdElement;
        contextTable._trElement = tdElement.parentNode;
      }

      const rows = contextTable._trElements = cellInfoTable.rows;
      const cellIndex = tdElement.cellIndex;
      let cellCnt = 0;

      for (let i = 0, cells = rows[0].cells, len = rows[0].cells.length; i < len; i++) {
        cellCnt += cells[i].colSpan;
      } // row cnt, row index


      const rowIndex = contextTable._rowIndex = contextTable._trElement.rowIndex;
      contextTable._rowCnt = rows.length; // cell cnt, physical cell index

      contextTable._physical_cellCnt = contextTable._trElement.cells.length;
      contextTable._logical_cellCnt = cellCnt;
      contextTable._physical_cellIndex = cellIndex; // span

      contextTable._current_colSpan = contextTable._tdElement.colSpan - 1;
      // contextTable._current_rowSpan - contextTable._trElement.cells[cellIndex].rowSpan - 1; // find logcal cell index

      let rowSpanArr = [];
      let spanIndex = [];

      for (let i = 0, cells, colSpan; i <= rowIndex; i++) {
        cells = rows[i].cells;
        colSpan = 0;

        for (let c = 0, cLen = cells.length, cell, cs, rs, logcalIndex; c < cLen; c++) {
          cell = cells[c];
          cs = cell.colSpan - 1;
          rs = cell.rowSpan - 1;
          logcalIndex = c + colSpan;

          if (spanIndex.length > 0) {
            for (let r = 0, arr; r < spanIndex.length; r++) {
              arr = spanIndex[r];
              if (arr.row > i) { continue; }

              if (logcalIndex >= arr.index) {
                colSpan += arr.cs;
                logcalIndex += arr.cs;
                arr.rs -= 1;
                arr.row = i + 1;

                if (arr.rs < 1) {
                  spanIndex.splice(r, 1);
                  r--;
                }
              } else if (c === cLen - 1) {
                arr.rs -= 1;
                arr.row = i + 1;

                if (arr.rs < 1) {
                  spanIndex.splice(r, 1);
                  r--;
                }
              }
            }
          } // logcal cell index


          if (i === rowIndex && c === cellIndex) {
            contextTable._logical_cellIndex = logcalIndex;
            break;
          }

          if (rs > 0) {
            rowSpanArr.push({
              index: logcalIndex,
              cs: cs + 1,
              rs,
              row: -1
            });
          }

          colSpan += cs;
        }

        spanIndex = spanIndex.concat(rowSpanArr).sort((a, b) => a.index - b.index);
        rowSpanArr = [];
      }

      rowSpanArr = null;
      spanIndex = null;
    }
  },
  editTable(type, option) {
    const tablePlugin = this.plugins.table;
    const contextTable = this.context.table;
    const editTableElement = contextTable._element;
    const isRow = type === 'row';

    if (isRow) {
      const tableAttr = contextTable._trElement.parentNode;

      if (/^THEAD$/i.test(tableAttr.nodeName)) {
        if (option === 'up') {
          return;
        } else if (!tableAttr.nextElementSibling || !/^TBODY$/i.test(tableAttr.nextElementSibling.nodeName)) {
          editTableElement.innerHTML += (
            '<tbody><tr>' + tablePlugin.createCells.call(this, 'td', contextTable._logical_cellCnt, false) + '</tr></tbody>'
          );
          return;
        }
      }
    } // multi


    if (tablePlugin._ref) {
      const positionCell = contextTable._tdElement;
      const selectedCells = tablePlugin._selectedCells; // multi - row

      if (isRow) {
        // remove row
        if (!option) {
          let row = selectedCells[0].parentNode;
          const removeCells = [selectedCells[0]];

          for (let i = 1, len = selectedCells.length, cell; i < len; i++) {
            cell = selectedCells[i];

            if (row !== cell.parentNode) {
              removeCells.push(cell);
              row = cell.parentNode;
            }
          }

          for (let i = 0, len = removeCells.length; i < len; i++) {
            tablePlugin.setCellInfo.call(this, removeCells[i], true);
            tablePlugin.editRow.call(this, option);
          }
        } else {
          // edit row
          tablePlugin.setCellInfo.call(this, option === 'up' ? selectedCells[0] : selectedCells[selectedCells.length - 1], true);
          tablePlugin.editRow.call(this, option, positionCell);
        }
      } else {
        // multi - cell
        const firstRow = selectedCells[0].parentNode; // remove cell

        if (!option) {
          const removeCells = [selectedCells[0]];

          for (let i = 1, len = selectedCells.length, cell; i < len; i++) {
            cell = selectedCells[i];

            if (firstRow === cell.parentNode) {
              removeCells.push(cell);
            } else {
              break;
            }
          }

          for (let i = 0, len = removeCells.length; i < len; i++) {
            tablePlugin.setCellInfo.call(this, removeCells[i], true);
            tablePlugin.editCell.call(this, option);
          }
        } else {
          // edit cell
          let rightCell = null;

          for (let i = 0, len = selectedCells.length - 1; i < len; i++) {
            if (firstRow !== selectedCells[i + 1].parentNode) {
              rightCell = selectedCells[i];
              break;
            }
          }

          tablePlugin.setCellInfo.call(this, option === 'left' ? selectedCells[0] : rightCell || selectedCells[0], true);
          tablePlugin.editCell.call(this, option, positionCell);
        }
      }

      if (!option) { tablePlugin.init.call(this); }
    } else {
        tablePlugin[isRow ? 'editRow' : 'editCell'].call(this, option);
      } // after remove


    if (!option) {
      const children = editTableElement.children;

      for (let i = 0; i < children.length; i++) {
        if (children[i].children.length === 0) {
          this.util.removeItem(children[i]);
          i--;
        }
      }

      if (editTableElement.children.length === 0) { this.util.removeItem(editTableElement); }
    }
  },
  editRow(option, positionResetElement) {
    const contextTable = this.context.table;
    const remove = !option;
    const up = option === 'up';
    const originRowIndex = contextTable._rowIndex;
    const rowIndex = remove || up ? originRowIndex : originRowIndex + contextTable._current_rowSpan + 1;
    const sign = remove ? -1 : 1;
    const rows = contextTable._trElements;
    let cellCnt = contextTable._logical_cellCnt;

    for (let i = 0, len = originRowIndex + (remove ? -1 : 0), cell; i <= len; i++) {
      cell = rows[i].cells;
      if (cell.length === 0) { return; }

      for (let c = 0, cLen = cell.length, rs, cs; c < cLen; c++) {
        rs = cell[c].rowSpan;
        cs = cell[c].colSpan;
        if (rs < 2 && cs < 2) { continue; }

        if (rs + i > rowIndex && rowIndex > i) {
          cell[c].rowSpan = rs + sign;
          cellCnt -= cs;
        }
      }
    }

    if (remove) {
      const next = rows[originRowIndex + 1];

      if (next) {
        const spanCells = [];
        let cells = rows[originRowIndex].cells;
        let colSpan = 0;

        for (let i = 0, len = cells.length, cell, logcalIndex; i < len; i++) {
          cell = cells[i];
          logcalIndex = i + colSpan;
          colSpan += cell.colSpan - 1;

          if (cell.rowSpan > 1) {
            cell.rowSpan -= 1;
            spanCells.push({
              cell: cell.cloneNode(false),
              index: logcalIndex
            });
          }
        }

        if (spanCells.length > 0) {
          let spanCell = spanCells.shift();
          cells = next.cells;
          colSpan = 0;

          for (let i = 0, len = cells.length, cell, logcalIndex; i < len; i++) {
            cell = cells[i];
            logcalIndex = i + colSpan;
            colSpan += cell.colSpan - 1;

            if (logcalIndex >= spanCell.index) {
              i--, colSpan--;
              colSpan += spanCell.cell.colSpan - 1;
              next.insertBefore(spanCell.cell, cell);
              spanCell = spanCells.shift();
              if (!spanCell) { break; }
            }
          }

          if (spanCell) {
            next.appendChild(spanCell.cell);

            for (let i = 0, len = spanCells.length; i < len; i++) {
              next.appendChild(spanCells[i].cell);
            }
          }
        }
      }

      contextTable._element.deleteRow(rowIndex);
    } else {
      const newRow = contextTable._element.insertRow(rowIndex);

      newRow.innerHTML = this.plugins.table.createCells.call(this, 'td', cellCnt, false);
    }

    if (!remove) {
      this.plugins.table.setPositionControllerDiv.call(this, positionResetElement || contextTable._tdElement, true);
    } else {
      this.controllersOff();
    }
  },
  editCell(option, positionResetElement) {
    const contextTable = this.context.table;
    const util = this.util;
    const remove = !option;
    const left = option === 'left';
    const colSpan = contextTable._current_colSpan;
    const cellIndex = remove || left ? contextTable._logical_cellIndex : contextTable._logical_cellIndex + colSpan + 1;
    const rows = contextTable._trElements;
    let rowSpanArr = [];
    let spanIndex = [];
    let passCell = 0;
    const removeCell = [];
    const removeSpanArr = [];

    for (let i = 0, len = contextTable._rowCnt, row, insertIndex, cells, newCell, applySpan, cellColSpan; i < len; i++) {
      row = rows[i];
      insertIndex = cellIndex;
      applySpan = false;
      cells = row.cells;
      cellColSpan = 0;

      for (let c = 0, cell, cLen = cells.length, rs, cs, removeIndex; c < cLen; c++) {
        cell = cells[c];
        if (!cell) { break; }
        rs = cell.rowSpan - 1;
        cs = cell.colSpan - 1;

        if (!remove) {
          if (c >= insertIndex) { break; }

          if (cs > 0) {
            if (passCell < 1 && cs + c >= insertIndex) {
              cell.colSpan += 1;
              insertIndex = null;
              passCell = rs + 1;
              break;
            }

            insertIndex -= cs;
          }

          if (!applySpan) {
            for (let r = 0, arr; r < spanIndex.length; r++) {
              arr = spanIndex[r];
              insertIndex -= arr.cs;
              arr.rs -= 1;

              if (arr.rs < 1) {
                spanIndex.splice(r, 1);
                r--;
              }
            }

            applySpan = true;
          }
        } else {
          removeIndex = c + cellColSpan;

          if (spanIndex.length > 0) {
            const lastCell = !cells[c + 1];

            for (let r = 0, arr; r < spanIndex.length; r++) {
              arr = spanIndex[r];
              if (arr.row > i) { continue; }

              if (removeIndex >= arr.index) {
                cellColSpan += arr.cs;
                removeIndex = c + cellColSpan;
                arr.rs -= 1;
                arr.row = i + 1;

                if (arr.rs < 1) {
                  spanIndex.splice(r, 1);
                  r--;
                }
              } else if (lastCell) {
                arr.rs -= 1;
                arr.row = i + 1;

                if (arr.rs < 1) {
                  spanIndex.splice(r, 1);
                  r--;
                }
              }
            }
          }

          if (rs > 0) {
            rowSpanArr.push({
              rs,
              cs: cs + 1,
              index: removeIndex,
              row: -1
            });
          }

          if (removeIndex >= insertIndex && removeIndex + cs <= insertIndex + colSpan) {
            removeCell.push(cell);
          } else if (removeIndex <= insertIndex + colSpan && removeIndex + cs >= insertIndex) {
            cell.colSpan -= util.getOverlapRangeAtIndex(cellIndex, cellIndex + colSpan, removeIndex, removeIndex + cs);
          } else if (rs > 0 && (removeIndex < insertIndex || removeIndex + cs > insertIndex + colSpan)) {
            removeSpanArr.push({
              cell,
              i,
              rs: i + rs
            });
          }

          cellColSpan += cs;
        }
      }

      spanIndex = spanIndex.concat(rowSpanArr).sort((a, b) => a.index - b.index);
      rowSpanArr = [];

      if (!remove) {
        if (passCell > 0) {
          passCell -= 1;
          continue;
        }

        if (insertIndex !== null && cells.length > 0) {
          newCell = this.plugins.table.createCells.call(this, cells[0].nodeName, 0, true);
          newCell = row.insertBefore(newCell, cells[insertIndex]);
        }
      }
    }

    if (remove) {
      let removeFirst;
      let removeEnd;

      for (let r = 0, rLen = removeCell.length, row; r < rLen; r++) {
        row = removeCell[r].parentNode;
        util.removeItem(removeCell[r]);

        if (row.cells.length === 0) {
          if (!removeFirst) { removeFirst = util.getArrayIndex(rows, row); }
          removeEnd = util.getArrayIndex(rows, row);
          util.removeItem(row);
        }
      }

      for (let c = 0, cLen = removeSpanArr.length, rowSpanCell; c < cLen; c++) {
        rowSpanCell = removeSpanArr[c];
        rowSpanCell.cell.rowSpan = util.getOverlapRangeAtIndex(removeFirst, removeEnd, rowSpanCell.i, rowSpanCell.rs);
      }

      this.controllersOff();
    } else {
      this.plugins.table.setPositionControllerDiv.call(this, positionResetElement || contextTable._tdElement, true);
    }
  },
  _closeSplitMenu: null,
  openSplitMenu() {
    this.util.addClass(this.context.table.splitButton, 'on');
    this.context.table.splitMenu.style.display = 'inline-table';

    this.plugins.table._closeSplitMenu = function() {
      this.util.removeClass(this.context.table.splitButton, 'on');
      this.context.table.splitMenu.style.display = 'none';
      this.removeDocEvent('mousedown', this.plugins.table._closeSplitMenu);
      this.plugins.table._closeSplitMenu = null;
    }.bind(this);

    this.addDocEvent('mousedown', this.plugins.table._closeSplitMenu);
  },
  splitCells(direction) {
    const util = this.util;
    const vertical = direction === 'vertical';
    const contextTable = this.context.table;
    const currentCell = contextTable._tdElement;
    const rows = contextTable._trElements;
    const currentRow = contextTable._trElement;
    const index = contextTable._logical_cellIndex;
    const rowIndex = contextTable._rowIndex;
    const newCell = this.plugins.table.createCells.call(this, currentCell.nodeName, 0, true); // vertical

    if (vertical) {
      const currentColSpan = currentCell.colSpan;
      newCell.rowSpan = currentCell.rowSpan; // colspan > 1

      if (currentColSpan > 1) {
        newCell.colSpan = Math.floor(currentColSpan / 2);
        currentCell.colSpan = currentColSpan - newCell.colSpan;
        currentRow.insertBefore(newCell, currentCell.nextElementSibling);
      } else {
        // colspan - 1
        let rowSpanArr = [];
        let spanIndex = [];

        for (let i = 0, len = contextTable._rowCnt, cells, colSpan; i < len; i++) {
          cells = rows[i].cells;
          colSpan = 0;

          for (let c = 0, cLen = cells.length, cell, cs, rs, logcalIndex; c < cLen; c++) {
            cell = cells[c];
            cs = cell.colSpan - 1;
            rs = cell.rowSpan - 1;
            logcalIndex = c + colSpan;

            if (spanIndex.length > 0) {
              for (let r = 0, arr; r < spanIndex.length; r++) {
                arr = spanIndex[r];
                if (arr.row > i) { continue; }

                if (logcalIndex >= arr.index) {
                  colSpan += arr.cs;
                  logcalIndex += arr.cs;
                  arr.rs -= 1;
                  arr.row = i + 1;

                  if (arr.rs < 1) {
                    spanIndex.splice(r, 1);
                    r--;
                  }
                } else if (c === cLen - 1) {
                  arr.rs -= 1;
                  arr.row = i + 1;

                  if (arr.rs < 1) {
                    spanIndex.splice(r, 1);
                    r--;
                  }
                }
              }
            }

            if (logcalIndex <= index && rs > 0) {
              rowSpanArr.push({
                index: logcalIndex,
                cs: cs + 1,
                rs,
                row: -1
              });
            }

            if (cell !== currentCell && logcalIndex <= index && logcalIndex + cs >= index + currentColSpan - 1) {
              cell.colSpan += 1;
              break;
            }

            if (logcalIndex > index) { break; }
            colSpan += cs;
          }

          spanIndex = spanIndex.concat(rowSpanArr).sort((a, b) => a.index - b.index);
          rowSpanArr = [];
        }

        currentRow.insertBefore(newCell, currentCell.nextElementSibling);
      }
    } else {
      // horizontal
      const currentRowSpan = currentCell.rowSpan;
      newCell.colSpan = currentCell.colSpan; // rowspan > 1

      if (currentRowSpan > 1) {
        newCell.rowSpan = Math.floor(currentRowSpan / 2);
        const newRowSpan = currentRowSpan - newCell.rowSpan;
        const rowSpanArr = [];
        const nextRowIndex = util.getArrayIndex(rows, currentRow) + newRowSpan;

        for (let i = 0, cells, colSpan; i < nextRowIndex; i++) {
          cells = rows[i].cells;
          colSpan = 0;

          for (let c = 0, cLen = cells.length, cell, cs, logcalIndex; c < cLen; c++) {
            logcalIndex = c + colSpan;
            if (logcalIndex >= index) { break; }
            cell = cells[c];
            cs = cell.rowSpan - 1;

            if (cs > 0 && cs + i >= nextRowIndex && logcalIndex < index) {
              rowSpanArr.push({
                index: logcalIndex,
                cs: cell.colSpan
              });
            }

            colSpan += cell.colSpan - 1;
          }
        }

        const nextRow = rows[nextRowIndex];
        const nextCells = nextRow.cells;
        let rs = rowSpanArr.shift();

        for (let c = 0, cLen = nextCells.length, colSpan = 0, cell, cs, logcalIndex, insertIndex; c < cLen; c++) {
          logcalIndex = c + colSpan;
          cell = nextCells[c];
          cs = cell.colSpan - 1;
          insertIndex = logcalIndex + cs + 1;

          if (rs && insertIndex >= rs.index) {
            colSpan += rs.cs;
            insertIndex += rs.cs;
            rs = rowSpanArr.shift();
          }

          if (insertIndex >= index || c === cLen - 1) {
            nextRow.insertBefore(newCell, cell.nextElementSibling);
            break;
          }

          colSpan += cs;
        }

        currentCell.rowSpan = newRowSpan;
      } else {
        // rowspan - 1
        newCell.rowSpan = currentCell.rowSpan;
        const newRow = util.createElement('TR');
        newRow.appendChild(newCell);

        let cells;
        for (let i = 0; i < rowIndex; i++) {
          cells = rows[i].cells;
          if (cells.length === 0) { return; }

          for (let c = 0, cLen = cells.length; c < cLen; c++) {
            if (i + cells[c].rowSpan - 1 >= rowIndex) {
              cells[c].rowSpan += 1;
            }
          }
        }

        const physicalIndex = contextTable._physical_cellIndex;
        cells = currentRow.cells;

        for (let c = 0, cLen = cells.length; c < cLen; c++) {
          if (c === physicalIndex) { continue; }
          cells[c].rowSpan += 1;
        }

        currentRow.parentNode.insertBefore(newRow, currentRow.nextElementSibling);
      }
    }

    this.plugins.table.setPositionControllerDiv.call(this, currentCell, true);
  },
  mergeCells() {
    const tablePlugin = this.plugins.table;
    const contextTable = this.context.table;
    const util = this.util;
    const ref = tablePlugin._ref;
    const selectedCells = tablePlugin._selectedCells;
    const mergeCell = selectedCells[0];
    let emptyRowFirst = null;
    let emptyRowLast = null;
    const cs = ref.ce - ref.cs + 1;
    let rs = ref.re - ref.rs + 1;
    let mergeHTML = '';
    let row = null;

    for (let i = 1, len = selectedCells.length, cell, ch; i < len; i++) {
      cell = selectedCells[i];
      if (row !== cell.parentNode) { row = cell.parentNode; }
      ch = cell.children;

      for (let c = 0, cLen = ch.length; c < cLen; c++) {
        if (util.isFormatElement(ch[c]) && util.onlyZeroWidthSpace(ch[c].textContent)) {
          util.removeItem(ch[c]);
        }
      }

      mergeHTML += cell.innerHTML;
      util.removeItem(cell);

      if (row.cells.length === 0) {
        if (!emptyRowFirst) { emptyRowFirst = row; } else { emptyRowLast = row; }
        rs -= 1;
      }
    }

    if (emptyRowFirst) {
      const rows = contextTable._trElements;
      const rowIndexFirst = util.getArrayIndex(rows, emptyRowFirst);
      const rowIndexLast = util.getArrayIndex(rows, emptyRowLast || emptyRowFirst);
      const removeRows = [];

      for (let i = 0, cells; i <= rowIndexLast; i++) {
        cells = rows[i].cells;

        if (cells.length === 0) {
          removeRows.push(rows[i]);
          continue;
        }

        for (let c = 0, cLen = cells.length, cell, rsElement; c < cLen; c++) {
          cell = cells[c];
          rsElement = cell.rowSpan - 1;

          if (rsElement > 0 && i + rsElement >= rowIndexFirst) {
            cell.rowSpan -= util.getOverlapRangeAtIndex(rowIndexFirst, rowIndexLast, i, i + rsElement);
          }
        }
      }

      for (let i = 0, len = removeRows.length; i < len; i++) {
        util.removeItem(removeRows[i]);
      }
    }

    mergeCell.innerHTML += mergeHTML;
    mergeCell.colSpan = cs;
    mergeCell.rowSpan = rs;
    this.controllersOff();
    tablePlugin.setActiveButton.call(this, true, false);
    tablePlugin.call_controller_tableEdit.call(this, mergeCell);
    util.addClass(mergeCell, 'ke-table-selected-cell');
  },
  toggleHeader() {
    const util = this.util;
    const headerButton = this.context.table.headerButton;
    const active = util.hasClass(headerButton, 'active');
    const internalTable = this.context.table._element;

    if (!active) {
      const header = util.createElement('THEAD');
      header.innerHTML = '<tr>' + this.plugins.table.createCells.call(this, 'th', this.context.table._logical_cellCnt, false) + '</tr>';
      internalTable.insertBefore(header, internalTable.firstElementChild);
    } else {
      util.removeItem(internalTable.querySelector('thead'));
    }

    util.toggleClass(headerButton, 'active');

    if (/TH/i.test(this.context.table._tdElement.nodeName)) {
      this.controllersOff();
    } else {
      this.plugins.table.setPositionControllerDiv.call(this, this.context.table._tdElement, false);
    }
  },
  resizeTable() {
    const contextTable = this.context.table;
    const icon = contextTable.resizeIcon;
    const span = contextTable.resizeText;
    let removeClass = 'ke-icon-expansion';
    let addClass = 'ke-icon-reduction';
    let text = contextTable.minText;
    let width = '100%';

    if (!contextTable._maxWidth) {
      removeClass = 'ke-icon-reduction';
      addClass = 'ke-icon-expansion';
      text = contextTable.maxText;
      width = 'auto';
    }

    this.util.removeClass(icon, removeClass);
    this.util.addClass(icon, addClass);
    this.util.changeTxt(span, text);
    contextTable._element.style.width = width;
  },
  setActiveButton(fixedCell, selectedCell) {
    const contextTable = this.context.table;

    if (!selectedCell || fixedCell === selectedCell) {
      contextTable.splitButton.removeAttribute('disabled');
      contextTable.mergeButton.setAttribute('disabled', 'true');
    } else {
      contextTable.splitButton.setAttribute('disabled', 'true');
      contextTable.mergeButton.removeAttribute('disabled');
    }
  },
  // multi selecte
  _bindOnSelect: null,
  _bindOffSelect: null,
  _bindOffShift: null,
  _selectedCells: null,
  _shift: false,
  _fixedCell: null,
  _fixedCellName: null,
  _selectedCell: null,
  _selectedTable: null,
  _ref: null,
  _toggleEditor(enabled) {
    this.context.element.wysiwyg.setAttribute('contenteditable', enabled);
    if (enabled) { this.util.removeClass(this.context.element.wysiwyg, 'ke-disabled'); } else { this.util.addClass(this.context.element.wysiwyg, 'ke-disabled'); }
  },
  _offCellMultiSelect(e) {
    e.stopPropagation();
    const tablePlugin = this.plugins.table;

    if (!tablePlugin._shift) {
      tablePlugin._removeEvents.call(this);

      tablePlugin._toggleEditor.call(this, true);
    } else if (tablePlugin._initBind) {
      this._wd.removeEventListener('touchmove', tablePlugin._initBind);

      tablePlugin._initBind = null;
    }

    if (!tablePlugin._fixedCell || !tablePlugin._selectedTable) { return; }
    tablePlugin.setActiveButton.call(this, tablePlugin._fixedCell, tablePlugin._selectedCell);
    tablePlugin.call_controller_tableEdit.call(this, tablePlugin._selectedCell || tablePlugin._fixedCell);
    tablePlugin._selectedCells = tablePlugin._selectedTable.querySelectorAll('.ke-table-selected-cell');

    if (!tablePlugin._shift) {
      tablePlugin._fixedCell = null;
      tablePlugin._selectedCell = null;
      tablePlugin._fixedCellName = null;
    }

    this._editorRange();

    this.focus();
  },
  _onCellMultiSelect(e) {
    const tablePlugin = this.plugins.table;
    const target = this.util.getParentElement(e.target, this.util.isCell);

    if (tablePlugin._shift) {
      if (target === tablePlugin._fixedCell) { tablePlugin._toggleEditor.call(this, true); } else { tablePlugin._toggleEditor.call(this, false); }
    } else if (!tablePlugin._ref) {
      if (target === tablePlugin._fixedCell) { return; } else { tablePlugin._toggleEditor.call(this, false); }
    }

    if (!target || target === tablePlugin._selectedCell || tablePlugin._fixedCellName !== target.nodeName || tablePlugin._selectedTable !== this.util.getParentElement(target, 'TABLE')) {
      return;
    }

    tablePlugin._selectedCell = target;

    tablePlugin._setMultiCells.call(this, tablePlugin._fixedCell, target);
  },
  _setMultiCells(startCell, endCell) {
    const tablePlugin = this.plugins.table;
    const rows = tablePlugin._selectedTable.rows;
    const util = this.util;

    const selectedCells = tablePlugin._selectedTable.querySelectorAll('.ke-table-selected-cell');

    for (let i = 0, len = selectedCells.length; i < len; i++) {
      util.removeClass(selectedCells[i], 'ke-table-selected-cell');
    }

    if (startCell === endCell) {
      util.addClass(startCell, 'ke-table-selected-cell');
      if (!tablePlugin._shift) { return; }
    }

    let findSelectedCell = true;
    let spanIndex = [];
    let rowSpanArr = [];
    const ref = tablePlugin._ref = {
      _i: 0,
      cs: null,
      ce: null,
      rs: null,
      re: null
    };

    for (let i = 0, len = rows.length, cells, colSpan; i < len; i++) {
      cells = rows[i].cells;
      colSpan = 0;

      for (let c = 0, cLen = cells.length, cell, logcalIndex, cs, rs; c < cLen; c++) {
        cell = cells[c];
        cs = cell.colSpan - 1;
        rs = cell.rowSpan - 1;
        logcalIndex = c + colSpan;

        if (spanIndex.length > 0) {
          for (let r = 0, arr; r < spanIndex.length; r++) {
            arr = spanIndex[r];
            if (arr.row > i) { continue; }

            if (logcalIndex >= arr.index) {
              colSpan += arr.cs;
              logcalIndex += arr.cs;
              arr.rs -= 1;
              arr.row = i + 1;

              if (arr.rs < 1) {
                spanIndex.splice(r, 1);
                r--;
              }
            } else if (c === cLen - 1) {
              arr.rs -= 1;
              arr.row = i + 1;

              if (arr.rs < 1) {
                spanIndex.splice(r, 1);
                r--;
              }
            }
          }
        }

        if (findSelectedCell) {
          if (cell === startCell || cell === endCell) {
            ref.cs = ref.cs !== null && ref.cs < logcalIndex ? ref.cs : logcalIndex;
            ref.ce = ref.ce !== null && ref.ce > logcalIndex + cs ? ref.ce : logcalIndex + cs;
            ref.rs = ref.rs !== null && ref.rs < i ? ref.rs : i;
            ref.re = ref.re !== null && ref.re > i + rs ? ref.re : i + rs;
            ref._i += 1;
          }

          if (ref._i === 2) {
            findSelectedCell = false;
            spanIndex = [];
            rowSpanArr = [];
            i = -1;
            break;
          }
        } else if (util.getOverlapRangeAtIndex(ref.cs, ref.ce, logcalIndex, logcalIndex + cs) && util.getOverlapRangeAtIndex(ref.rs, ref.re, i, i + rs)) {
          const newCs = ref.cs < logcalIndex ? ref.cs : logcalIndex;
          const newCe = ref.ce > logcalIndex + cs ? ref.ce : logcalIndex + cs;
          const newRs = ref.rs < i ? ref.rs : i;
          const newRe = ref.re > i + rs ? ref.re : i + rs;

          if (ref.cs !== newCs || ref.ce !== newCe || ref.rs !== newRs || ref.re !== newRe) {
            ref.cs = newCs;
            ref.ce = newCe;
            ref.rs = newRs;
            ref.re = newRe;
            i = -1;
            spanIndex = [];
            rowSpanArr = [];
            break;
          }

          util.addClass(cell, 'ke-table-selected-cell');
        }

        if (rs > 0) {
          rowSpanArr.push({
            index: logcalIndex,
            cs: cs + 1,
            rs,
            row: -1
          });
        }

        colSpan += cell.colSpan - 1;
      }

      spanIndex = spanIndex.concat(rowSpanArr).sort((a, b) => a.index - b.index);
      rowSpanArr = [];
    }
  },
  _removeEvents() {
    const tablePlugin = this.plugins.table;

    if (tablePlugin._initBind) {
      this._wd.removeEventListener('touchmove', tablePlugin._initBind);

      tablePlugin._initBind = null;
    }

    if (tablePlugin._bindOnSelect) {
      this._wd.removeEventListener('mousedown', tablePlugin._bindOnSelect);

      this._wd.removeEventListener('mousemove', tablePlugin._bindOnSelect);

      tablePlugin._bindOnSelect = null;
    }

    if (tablePlugin._bindOffSelect) {
      this._wd.removeEventListener('mouseup', tablePlugin._bindOffSelect);

      tablePlugin._bindOffSelect = null;
    }

    if (tablePlugin._bindOffShift) {
      this._wd.removeEventListener('keyup', tablePlugin._bindOffShift);

      tablePlugin._bindOffShift = null;
    }
  },
  _initBind: null,
  onTableCellMultiSelect(tdElement, shift) {
    const tablePlugin = this.plugins.table;

    tablePlugin._removeEvents.call(this);

    this.controllersOff();
    tablePlugin._shift = shift;
    tablePlugin._fixedCell = tdElement;
    tablePlugin._fixedCellName = tdElement.nodeName;
    tablePlugin._selectedTable = this.util.getParentElement(tdElement, 'TABLE');

    const selectedCells = tablePlugin._selectedTable.querySelectorAll('.ke-table-selected-cell');

    for (let i = 0, len = selectedCells.length; i < len; i++) {
      this.util.removeClass(selectedCells[i], 'ke-table-selected-cell');
    }

    this.util.addClass(tdElement, 'ke-table-selected-cell');
    tablePlugin._bindOnSelect = tablePlugin._onCellMultiSelect.bind(this);
    tablePlugin._bindOffSelect = tablePlugin._offCellMultiSelect.bind(this);

    if (!shift) {
      this._wd.addEventListener('mousemove', tablePlugin._bindOnSelect, false);
    } else {
      tablePlugin._bindOffShift = function() {
        this.controllersOn(this.context.table.resizeDiv, this.context.table.tableController, this.plugins.table.init.bind(this), this.focus.bind(this));
        if (!tablePlugin._ref) { this.controllersOff(); }
      }.bind(this);

      this._wd.addEventListener('keyup', tablePlugin._bindOffShift, false);

      this._wd.addEventListener('mousedown', tablePlugin._bindOnSelect, false);
    }

    this._wd.addEventListener('mouseup', tablePlugin._bindOffSelect, false);

    tablePlugin._initBind = tablePlugin.init.bind(this);

    this._wd.addEventListener('touchmove', tablePlugin._initBind, false);
  },
  onClick_tableController(e) {
    e.stopPropagation();
    const target = e.target.getAttribute('data-command') ? e.target : e.target.parentNode;
    if (target.getAttribute('disabled')) { return; }
    const command = target.getAttribute('data-command');
    const value = target.getAttribute('data-value');
    const option = target.getAttribute('data-option');

    if (typeof this.plugins.table._closeSplitMenu === 'function') {
      this.plugins.table._closeSplitMenu();

      if (command === 'onsplit') { return; }
    }

    if (!command) { return; }
    e.preventDefault();
    const contextTable = this.context.table;

    switch (command) {
      case 'insert':
      case 'delete':
        this.plugins.table.editTable.call(this, value, option);
        break;

      case 'header':
        this.plugins.table.toggleHeader.call(this);
        break;

      case 'onsplit':
        this.plugins.table.openSplitMenu.call(this);
        break;

      case 'split':
        this.plugins.table.splitCells.call(this, value);
        break;

      case 'merge':
        this.plugins.table.mergeCells.call(this);
        break;

      case 'resize':
        contextTable.resizeDiv.style.display = 'none';
        contextTable._maxWidth = !contextTable._maxWidth;
        this.plugins.table.resizeTable.call(this);
        break;

      case 'remove':
        this.util.removeItem(contextTable._element);
        this.controllersOff();
    }

    this.focus(); // history stack

    this.history.push();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/formatBlock.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const formatBlock = ({
  name: 'formatBlock',
  add(core, targetElement) {
    const context = core.context;
    context.formatBlock = {
      _formatList: null,
      currentFormat: ''
    };
    /** set submenu */

    let listDiv = this.setSubmenu.call(core);
    /** add event listeners */

    listDiv.querySelector('ul').addEventListener('click', this.pickUp.bind(core));
    context.formatBlock._formatList = listDiv.querySelectorAll('li button');
    /** append html */

    targetElement.parentNode.appendChild(listDiv);
    /** empty memory */

    listDiv = null;
  },
  setSubmenu() {
    const option = this.context.option;
    const langToolbar = this.lang.toolbar;
    const listDiv = this.util.createElement('DIV');
    const formatList = !option.formats || option.formats.length === 0 ? ['p', 'div', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'] : option.formats;
    listDiv.className = 'ke-submenu ke-list-layer';
    let list = '<div class="ke-list-inner"><ul class="ke-list-basic ke-list-format">';

    for (let i = 0, len = formatList.length, format, command, title, h, oClass; i < len; i++) {
      if (typeof formatList[i] === 'string') {
        format = formatList[i].toLowerCase();
        command = format === 'pre' || format === 'blockquote' ? 'range' : 'replace';
        h = /^h/.test(format) ? format.match(/\d+/)[0] : '';
        title = langToolbar['tag_' + (h ? 'h' : format)] + h;
        oClass = '';
      } else {
        format = formatList[i].tag.toLowerCase();
        command = 'replace';
        title = formatList[i].title || format;
        oClass = (' class="' + formatList[i].class + '"' || false) + 'data-format="' + command + '"';
      }

      // @ts-ignore
      list += '<li>' + '<button type="button" class="ke-btn-list" data-command="' + command + '" data-value="' + format + '" title="' + title + '">' + '<' + format + oClass + '>' + title + '</' + format + '>' + '</button></li>';
    }

    list += '</ul></div>';
    listDiv.innerHTML = list;
    return listDiv;
  },
  on() {
    const formatContext = this.context.formatBlock;
    const formatList = formatContext._formatList;
    const currentFormat = (this.commandMap.FORMAT.getAttribute('data-focus') || 'P').toLowerCase();

    if (currentFormat !== formatContext.currentFormat) {
      for (let i = 0, len = formatList.length; i < len; i++) {
        if (currentFormat === formatList[i].getAttribute('data-value')) {
          this.util.addClass(formatList[i], 'active');
        } else {
          this.util.removeClass(formatList[i], 'active');
        }
      }

      formatContext.currentFormat = currentFormat;
    }
  },
  pickUp(e) {
    e.preventDefault();
    e.stopPropagation();
    let target = e.target;
    let command = null,
        value = null,
        tag = null;

    while (!command && !/UL/i.test(target.tagName)) {
      command = target.getAttribute('data-command');
      value = target.getAttribute('data-value');

      if (command) {
        tag = target.firstChild;
        break;
      }

      target = target.parentNode;
    }

    if (!command) { return; } // blockquote, pre

    if (command === 'range') {
      const rangeElement = tag.cloneNode(false);
      this.applyRangeFormatElement(rangeElement);
    } else {
        const range = this.getRange();
        const startOffset = range.startOffset;
        const endOffset = range.endOffset;
        let selectedFormsts = this.getSelectedElementsAndComponents();
        if (selectedFormsts.length === 0) { return; }
        let first = selectedFormsts[0];
        let last = selectedFormsts[selectedFormsts.length - 1];
        const firstPath = this.util.getNodePath(range.startContainer, first);
        const lastPath = this.util.getNodePath(range.endContainer, last); // remove list

        let rangeArr = {r: undefined, f: undefined};
        let listFirst = false;
        let listLast = false;

        const passComponent = function(current) {
          return !this.isComponent(current);
        }.bind(this.util);

        for (let i = 0, len = selectedFormsts.length, r, o, lastIndex, isList; i < len; i++) {
          lastIndex = i === len - 1;
          o = this.util.getRangeFormatElement(selectedFormsts[i], passComponent);
          isList = this.util.isList(o);

          if (!r && isList) {
            r = o;
            rangeArr = {
              r,
              f: [this.util.getParentElement(selectedFormsts[i], 'LI')]
            };
            if (i === 0) { listFirst = true; }
          } else if (r && isList) {
            if (r !== o) {
              const edge = this.detachRangeFormatElement(rangeArr.r, rangeArr.f, null, false, true);

              if (listFirst) {
                first = edge.sc;
                listFirst = false;
              }

              if (lastIndex) { last = edge.ec; }

              if (isList) {
                r = o;
                rangeArr = {
                  r,
                  f: [this.util.getParentElement(selectedFormsts[i], 'LI')]
                };
                if (lastIndex) { listLast = true; }
              } else {
                r = null;
              }
            } else {
              rangeArr.f.push(this.util.getParentElement(selectedFormsts[i], 'LI'));
              if (lastIndex) { listLast = true; }
            }
          }

          if (lastIndex && this.util.isList(r)) {
            const edge = this.detachRangeFormatElement(rangeArr.r, rangeArr.f, null, false, true);

            if (listLast || len === 1) {
              last = edge.ec;
              if (listFirst) { first = edge.sc || last; }
            }
          }
        } // change format tag


        this.setRange(this.util.getNodeFromPath(firstPath, first), startOffset, this.util.getNodeFromPath(lastPath, last), endOffset);
        selectedFormsts = this.getSelectedElementsAndComponents();

        for (let i = 0, len = selectedFormsts.length, node, newFormat; i < len; i++) {
          node = selectedFormsts[i];

          if (node.nodeName.toLowerCase() !== value.toLowerCase() && !this.util.isComponent(node)) {
            newFormat = tag.cloneNode(false);
            newFormat.innerHTML = node.innerHTML;
            node.parentNode.insertBefore(newFormat, node);
            this.util.removeItem(node);
          }

          if (i === 0) { first = newFormat || node; }
          if (i === len - 1) { last = newFormat || node; }
          newFormat = null;
        }

        this.setRange(this.util.getNodeFromPath(firstPath, first), startOffset, this.util.getNodeFromPath(lastPath, last), endOffset); // history stack

        this.history.push();
      }

    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/submenu/template.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const template = ({
  name: 'template',
  add(core, targetElement) {
    const context = core.context;
    context.template = {};
    /** set submenu */

    let templateDiv = this.setSubmenu.call(core);
    /** add event listeners */

    templateDiv.querySelector('ul').addEventListener('click', this.pickup.bind(core));
    /** append html */

    targetElement.parentNode.appendChild(templateDiv);
    /** empty memory */

    templateDiv = null;
  },
  setSubmenu() {
    const templateList = this.context.option.templates;
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'ke-list-layer';
    // @ts-ignore
    let list = '<div class="ke-submenu ke-list-inner">' + '   <ul class="ke-list-basic">';

    for (let i = 0, len = templateList.length, t; i < len; i++) {
      t = templateList[i];
      list += '<li><button type="button" class="ke-btn-list" data-value="' + i + '" title="' + t.name + '">' + t.name + '</button></li>';
    }

    list += '   </ul>';
    list += '</div>';
    listDiv.innerHTML = list;
    return listDiv;
  },
  pickup(e) {
    if (!/^BUTTON$/i.test(e.target.tagName)) { return false; }
    e.preventDefault();
    e.stopPropagation();
    const temp = this.context.option.templates[e.target.getAttribute('data-value')];

    if (temp.html) {
      this.setContents(temp.html);
    } else {
      this.submenuOff();
      throw Error('[KEDITOR.template.fail] cause : "templates[i].html not found"');
    }

    this.submenuOff();
  }
});
// CONCATENATED MODULE: ./src/plugins/modules/dialog.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const dialog = ({
  name: 'dialog',
  add(core) {
    const context = core.context;
    context.dialog = {};
    /** dialog */

    let dialogDiv = core.util.createElement('DIV');
    dialogDiv.className = 'ke-dialog keditor-common';
    let dialogBack = core.util.createElement('DIV');
    dialogBack.className = 'ke-dialog-back';
    dialogBack.style.display = 'none';
    let dialogArea = core.util.createElement('DIV');
    dialogArea.className = 'ke-dialog-inner';
    dialogArea.style.display = 'none';
    dialogDiv.appendChild(dialogBack);
    dialogDiv.appendChild(dialogArea);
    context.dialog.modalArea = dialogDiv;
    context.dialog.back = dialogBack;
    context.dialog.modal = dialogArea;
    /** add event listeners */

    context.dialog.modal.addEventListener('click', this.onClickDialog.bind(core));
    /** append html */

    context.element.relative.appendChild(dialogDiv);
    /** empty memory */

    dialogDiv = null, dialogBack = null, dialogArea = null;
  },
  onClickDialog(e) {
    e.stopPropagation();

    if (/ke-dialog-inner/.test(e.target.className) || /close/.test(e.target.getAttribute('data-command'))) {
      this.plugins.dialog.close.call(this);
    }
  },
  open(kind, update) {
    if (this.modalForm) { return false; }

    if (this.plugins.dialog._bindClose) {
      document.removeEventListener('keydown', this.plugins.dialog._bindClose);

      this.plugins.dialog._bindClose = null;
    }

    this.plugins.dialog._bindClose = function(e) {
      if (!/27/.test(e.keyCode)) { return; }
      this.plugins.dialog.close.call(this);
    }.bind(this);

    document.addEventListener('keydown', this.plugins.dialog._bindClose);

    this.context.dialog.updateModal = update;

    if (this.context.option.popupDisplay === 'full') {
      this.context.dialog.modalArea.style.position = 'fixed';
    } else {
      this.context.dialog.modalArea.style.position = 'absolute';
    }

    this.context.dialog.kind = kind;
    this.modalForm = this.context[kind].modal;
    const focusElement = this.context[kind].focusElement;
    if (typeof this.plugins[kind].on === 'function') { this.plugins[kind].on.call(this, update); }
    this.context.dialog.modalArea.style.display = 'block';
    this.context.dialog.back.style.display = 'block';
    this.context.dialog.modal.style.display = 'block';
    this.modalForm.style.display = 'block';
    if (focusElement) { focusElement.focus(); }
  },
  _bindClose: null,
  close() {
    if (this.plugins.dialog._bindClose) {
      document.removeEventListener('keydown', this.plugins.dialog._bindClose);

      this.plugins.dialog._bindClose = null;
    }

    this.modalForm.style.display = 'none';
    this.context.dialog.back.style.display = 'none';
    this.context.dialog.modalArea.style.display = 'none';
    this.modalForm = null;
    this.context.dialog.updateModal = false;
    this.plugins[this.context.dialog.kind].init.call(this);
  }
});
// CONCATENATED MODULE: ./src/plugins/dialog/link.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */



const dialogLinkPlugin = ({
  name: 'link',
  add(core) {
    core.addModule([dialog]);
    const context = core.context;
    context.link = {
      focusElement: null,
      linkNewWindowCheck: null,
      linkAnchorText: null,
      _linkAnchor: null
    };
    /** link dialog */

    let linkDialog = this.setDialog.call(core);
    context.link.modal = linkDialog;
    context.link.focusElement = linkDialog.querySelector('._se_link_url');
    context.link.linkAnchorText = linkDialog.querySelector('._se_link_text');
    context.link.linkNewWindowCheck = linkDialog.querySelector('._se_link_check');
    /** link button */

    let linkButton = this.setController_LinkButton.call(core);
    context.link.linkBtn = linkButton;
    context.link._linkAnchor = null;
    linkButton.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    }, false);
    /** add event listeners */

    linkDialog.querySelector('.ke-btn-primary').addEventListener('click', this.submit.bind(core));
    linkButton.addEventListener('click', this.onClick_linkBtn.bind(core));
    /** append html */

    context.dialog.modal.appendChild(linkDialog);
    context.element.relative.appendChild(linkButton);
    /** empty memory */

    linkDialog = null, linkButton = null;
  },

  /**
   * @description creates a dialog for and returns its HTMLElement
   */
  setDialog() {
    const lang = this.lang;
    const setDialogElem = this.util.createElement('DIV');
    setDialogElem.className = 'ke-dialog-content';
    setDialogElem.style.display = 'none';
    // @ts-ignore
    setDialogElem.innerHTML = '' + '<form class="editor_link">' + '   <div class="ke-dialog-header">' + '       <button type="button" data-command="close" class="close" aria-label="Close" title="' + lang.dialogBox.close + '">' + '           <i aria-hidden="true" data-command="close" class="ke-icon-cancel"></i>' + '       </button>' + '       <span class="ke-modal-title">' + lang.dialogBox.linkBox.title + '</span>' + '   </div>' + '   <div class="ke-dialog-body">' + '       <div class="ke-dialog-form">' + '           <label>' + lang.dialogBox.linkBox.url + '</label>' + '           <input class="ke-input-form _se_link_url" type="text" />' + '       </div>' + '       <div class="ke-dialog-form">' + '           <label>' + lang.dialogBox.linkBox.text + '</label><input class="ke-input-form _se_link_text" type="text" />' + '       </div>' + '       <div class="ke-dialog-form-footer">' + '           <label><input type="checkbox" class="ke-dialog-btn-check _se_link_check" />&nbsp;' + lang.dialogBox.linkBox.newWindowCheck + '</label>' + '       </div>' + '   </div>' + '   <div class="ke-dialog-footer">' + '       <button type="button" data-command="close" class="ke-btn-cancel" aria-label="Close" title="' + lang.dialogBox.close + '"><span data-command="close">' + lang.dialogBox.close + '</span></button>' + '       <button type="submit" class="ke-btn-primary" title="' + lang.dialogBox.submitButton + '"><span>' + lang.dialogBox.submitButton + '</span></button>' + '   </div>' + '</form>';
    return setDialogElem;
  },

  /** modify controller button */
  setController_LinkButton() {
    const lang = this.lang;
    const linkBtn = this.util.createElement('DIV');
    linkBtn.className = 'ke-controller ke-controller-link';
    // @ts-ignore
    linkBtn.innerHTML = '' + '<div class="ke-arrow ke-arrow-up"></div>' + '<div class="link-content"><span><a target="_blank" href=""></a>&nbsp;</span>' + '   <div class="ke-btn-group">' + '       <button type="button" data-command="update" tabindex="-1" class="ke-tooltip">' + '           <i class="ke-icon-edit"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.edit + '</span></span>' + '       </button>' + '       <button type="button" data-command="delete" tabindex="-1" class="ke-tooltip">' + '           <i class="ke-icon-delete"></i>' + '           <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.remove + '</span></span>' + '       </button>' + '   </div>' + '</div>';
    return linkBtn;
  },
  submit(e) {
    this.showLoading();
    e.preventDefault();
    e.stopPropagation();

    const submitAction = function() {
      if (this.context.link.focusElement.value.trim().length === 0) { return false; }
      const contextLink = this.context.link;
      const url = contextLink.focusElement.value;
      const anchor = contextLink.linkAnchorText;
      const anchorText = anchor.value.length === 0 ? url : anchor.value;

      if (!this.context.dialog.updateModal) {
        const oA = this.util.createElement('A');
        oA.href = url;
        oA.textContent = anchorText;
        oA.target = contextLink.linkNewWindowCheck.checked ? '_blank' : '';
        this.insertNode(oA);
        this.setRange(oA.childNodes[0], 0, oA.childNodes[0], oA.textContent.length);
      } else {
        contextLink._linkAnchor.href = url;
        contextLink._linkAnchor.textContent = anchorText;
        contextLink._linkAnchor.target = contextLink.linkNewWindowCheck.checked ? '_blank' : ''; // history stack

        this.history.push(); // set range

        this.setRange(contextLink._linkAnchor.childNodes[0], 0, contextLink._linkAnchor.childNodes[0], contextLink._linkAnchor.textContent.length);
      }

      contextLink.focusElement.value = '';
      contextLink.linkAnchorText.value = '';
    }.bind(this);

    try {
      submitAction();
    } finally {
      this.plugins.dialog.close.call(this);
      this.closeLoading();
      this.focus();
    }

    return false;
  },
  on(update) {
    if (!update) {
      this.context.link.linkAnchorText.value = this.getSelection().toString();
    }
  },
  call_controller_linkButton(selectionATag) {
    this.editLink = this.context.link._linkAnchor = selectionATag;
    const linkBtn = this.context.link.linkBtn;
    const link = linkBtn.querySelector('a');
    link.href = selectionATag.href;
    link.title = selectionATag.textContent;
    link.textContent = selectionATag.textContent;
    const offset = this.util.getOffset(selectionATag, this.context.element.wysiwygFrame);
    linkBtn.style.top = offset.top + selectionATag.offsetHeight + 10 + 'px';
    linkBtn.style.left = offset.left - this.context.element.wysiwygFrame.scrollLeft + 'px';
    linkBtn.style.display = 'block';
    const overLeft = this.context.element.wysiwygFrame.offsetWidth - (linkBtn.offsetLeft + linkBtn.offsetWidth);

    if (overLeft < 0) {
      linkBtn.style.left = linkBtn.offsetLeft + overLeft + 'px';
      linkBtn.firstElementChild.style.left = 20 - overLeft + 'px';
    } else {
      linkBtn.firstElementChild.style.left = '20px';
    }

    this.controllersOn(linkBtn);
  },
  onClick_linkBtn(e) {
    e.stopPropagation();
    const command = e.target.getAttribute('data-command') || e.target.parentNode.getAttribute('data-command');
    if (!command) { return; }
    e.preventDefault();

    if (/update/.test(command)) {
      this.context.link.focusElement.value = this.context.link._linkAnchor.href;
      this.context.link.linkAnchorText.value = this.context.link._linkAnchor.textContent;
      this.context.link.linkNewWindowCheck.checked = /_blank/i.test(this.context.link._linkAnchor.target) ? true : false;
      this.plugins.dialog.open.call(this, 'link', true);
    } else {
      /** delete */
      this.util.removeItem(this.context.link._linkAnchor);
      this.context.link._linkAnchor = null;
      this.focus();
    }

    this.controllersOff(); // history stack

    this.history.push();
  },
  init() {
    const contextLink = this.context.link;
    contextLink.linkBtn.style.display = 'none';
    contextLink._linkAnchor = null;
    contextLink.focusElement.value = '';
    contextLink.linkAnchorText.value = '';
    contextLink.linkNewWindowCheck.checked = false;
  }
});
// CONCATENATED MODULE: ./src/plugins/modules/resizing.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

const resizing = ({
  name: 'resizing',
  add(core) {
    const context = core.context;
    context.resizing = {
      _resizeClientX: 0,
      _resizeClientY: 0,
      _resize_plugin: '',
      _resize_w: 0,
      _resize_h: 0,
      _origin_w: 0,
      _origin_h: 0,
      _rotateVertical: false,
      _resize_direction: '',
      _move_path: null,
      _isChange: false
    };
    /** resize controller, button */

    let resizeDivContainer = this.setController_resize.call(core);
    context.resizing.resizeContainer = resizeDivContainer;
    context.resizing.resizeDiv = resizeDivContainer.querySelector('.ke-modal-resize');
    context.resizing.resizeDot = resizeDivContainer.querySelector('.ke-resize-dot');
    context.resizing.resizeDisplay = resizeDivContainer.querySelector('.ke-resize-display');
    let resizeButton = this.setController_button.call(core);
    context.resizing.resizeButton = resizeButton;
    resizeButton.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    }, false);
    let resizeHandles = context.resizing.resizeHandles = context.resizing.resizeDot.querySelectorAll('span');
    context.resizing.resizeButtonGroup = resizeButton.querySelector('._se_resizing_btn_group');
    context.resizing.alignMenu = resizeButton.querySelector('.ke-resizing-align-list');
    context.resizing.alignMenuList = context.resizing.alignMenu.querySelectorAll('button');
    context.resizing.alignButton = resizeButton.querySelector('._se_resizing_align_button');
    context.resizing.alignButtonIcon = context.resizing.alignButton.querySelector('i');
    context.resizing.captionButton = resizeButton.querySelector('._se_resizing_caption_button');
    /** add event listeners */

    resizeHandles[0].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[1].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[2].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[3].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[4].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[5].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[6].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeHandles[7].addEventListener('mousedown', this.onMouseDownResizeHandle.bind(core));
    resizeButton.addEventListener('click', this.onClickResizeButton.bind(core));
    /** append html */

    context.element.relative.appendChild(resizeDivContainer);
    context.element.relative.appendChild(resizeButton);
    /** empty memory */

    resizeDivContainer = null, resizeButton = null, resizeHandles = null;
  },

  /** resize controller, button (image, iframe) */
  setController_resize() {
    const resizeContainer = this.util.createElement('DIV');
    resizeContainer.className = 'ke-resizing-container';
    resizeContainer.style.display = 'none';
    // @ts-ignore
    resizeContainer.innerHTML = '<div class="ke-modal-resize">' + '   <div class="ke-resize-display"></div>' + '</div>' + '<div class="ke-resize-dot">' + '   <span class="tl"></span>' + '   <span class="tr"></span>' + '   <span class="bl"></span>' + '   <span class="br"></span>' + '   <span class="lw"></span>' + '   <span class="th"></span>' + '   <span class="rw"></span>' + '   <span class="bh"></span>' + '</div>';
    return resizeContainer;
  },
  setController_button() {
    const lang = this.lang;
    const resizeButton = this.util.createElement('DIV');
    resizeButton.className = 'ke-controller ke-controller-resizing';
    // @ts-ignore
    resizeButton.innerHTML = '<div class="ke-arrow ke-arrow-up"></div>' + '<div class="ke-btn-group _se_resizing_btn_group">' + '   <button type="button" data-command="percent" data-value="1" class="ke-tooltip">' + '       <span>100%</span>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.resize100 + '</span></span>' + '   </button>' + '   <button type="button" data-command="percent" data-value="0.75" class="ke-tooltip">' + '       <span>75%</span>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.resize75 + '</span></span>' + '   </button>' + '   <button type="button" data-command="percent" data-value="0.5" class="ke-tooltip">' + '       <span>50%</span>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.resize50 + '</span></span>' + '   </button>' + '   <button type="button" data-command="percent" data-value="0.25" class="ke-tooltip">' + '       <span>25%</span>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.resize25 + '</span></span>' + '   </button>' + '   <button type="button" data-command="rotate" data-value="-90" class="ke-tooltip">' + '       <i class="ke-icon-rotate-left"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.rotateLeft + '</span></span>' + '   </button>' + '   <button type="button" data-command="rotate" data-value="90" class="ke-tooltip">' + '       <i class="ke-icon-rotate-right"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.rotateRight + '</span></span>' + '   </button>' + '</div>' + '<div class="ke-btn-group">' + '   <button type="button" data-command="mirror" data-value="h" class="ke-tooltip">' + '       <i class="ke-icon-mirror-horizontal"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.mirrorHorizontal + '</span></span>' + '   </button>' + '   <button type="button" data-command="mirror" data-value="v" class="ke-tooltip">' + '       <i class="ke-icon-mirror-vertical"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.mirrorVertical + '</span></span>' + '   </button>' + '   <button type="button" data-command="onalign" class="ke-tooltip _se_resizing_align_button">' + '       <i class="ke-icon-align-justify"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.toolbar.align + '</span></span>' + '   </button>' + '   <div class="ke-btn-group-sub keditor-common ke-list-layer ke-resizing-align-list">' + '       <div class="ke-list-inner">' + '           <ul class="ke-list-basic">' + '               <li><button type="button" class="ke-btn-list ke-tooltip" data-command="align" data-value="basic">' + '                   <i class="ke-icon-align-justify"></i>' + '                   <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.basic + '</span></span>' + '               </button></li>' + '               <li><button type="button" class="ke-btn-list ke-tooltip" data-command="align" data-value="left">' + '                   <i class="ke-icon-align-left"></i>' + '                   <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.left + '</span></span>' + '               </button></li>' + '               <li><button type="button" class="ke-btn-list ke-tooltip" data-command="align" data-value="center">' + '                   <i class="ke-icon-align-center"></i>' + '                   <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.center + '</span></span>' + '               </button></li>' + '               <li><button type="button" class="ke-btn-list ke-tooltip" data-command="align" data-value="right">' + '                   <i class="ke-icon-align-right"></i>' + '                   <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.right + '</span></span>' + '               </button></li>' + '           </ul>' + '       </div>' + '   </div>' + '   <button type="button" data-command="caption" class="ke-tooltip _se_resizing_caption_button">' + '       <i class="ke-icon-caption"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.caption + '</span></span>' + '   </button>' + '   <button type="button" data-command="revert" class="ke-tooltip">' + '       <i class="ke-icon-revert"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.dialogBox.revertButton + '</span></span>' + '   </button>' + '   <button type="button" data-command="update" class="ke-tooltip">' + '       <i class="ke-icon-modify"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.edit + '</span></span>' + '   </button>' + '   <button type="button" data-command="delete" class="ke-tooltip">' + '       <i class="ke-icon-delete"></i>' + '       <span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + lang.controller.remove + '</span></span>' + '   </button>' + '</div>';
    return resizeButton;
  },
  call_controller_resize(targetElement, plugin) {
    const contextResizing = this.context.resizing;
    contextResizing._resize_plugin = plugin;
    const resizeContainer = contextResizing.resizeContainer;
    const resizeDiv = contextResizing.resizeDiv;
    const offset = this.util.getOffset(targetElement, this.context.element.wysiwygFrame);
    const isVertical = contextResizing._rotateVertical = /^(90|270)$/.test(Math.abs(targetElement.getAttribute('data-rotate')).toString());
    const w = isVertical ? targetElement.offsetHeight : targetElement.offsetWidth;
    const h = isVertical ? targetElement.offsetWidth : targetElement.offsetHeight;
    const t = offset.top;
    const l = offset.left - this.context.element.wysiwygFrame.scrollLeft;
    resizeContainer.style.top = t + 'px';
    resizeContainer.style.left = l + 'px';
    resizeContainer.style.width = w + 'px';
    resizeContainer.style.height = h + 'px';
    resizeDiv.style.top = '0px';
    resizeDiv.style.left = '0px';
    resizeDiv.style.width = w + 'px';
    resizeDiv.style.height = h + 'px';
    let align = targetElement.getAttribute('data-align') || 'basic';
    align = align === 'none' ? 'basic' : align;
    this.util.changeTxt(contextResizing.resizeDisplay, this.lang.dialogBox[align] + ' (' + w + ' x ' + h + ')');
    const resizeDisplay = this.context[plugin]._resizing ? 'flex' : 'none';
    const resizeHandles = contextResizing.resizeHandles;
    contextResizing.resizeButtonGroup.style.display = resizeDisplay;

    for (let i = 0, len = resizeHandles.length; i < len; i++) {
      resizeHandles[i].style.display = resizeDisplay;
    } // align icon


    const alignList = contextResizing.alignMenuList;
    this.util.removeClass(contextResizing.alignButtonIcon, 'ke-icon-align\\-[a-z]+');
    this.util.addClass(contextResizing.alignButtonIcon, 'ke-icon-align-' + (align === 'basic' ? 'justify' : align));

    for (let i = 0, len = alignList.length; i < len; i++) {
      if (alignList[i].getAttribute('data-value') === align) { this.util.addClass(alignList[i], 'on'); } else { this.util.removeClass(alignList[i], 'on'); }
    } // caption active


    if (this.util.getChildElement(targetElement.parentNode, 'figcaption')) {
      this.util.addClass(contextResizing.captionButton, 'active');
      this.context[plugin]._captionChecked = true;
    } else {
      this.util.removeClass(contextResizing.captionButton, 'active');
      this.context[plugin]._captionChecked = false;
    }

    this._resizingName = plugin;
    this.controllersOn(contextResizing.resizeContainer, contextResizing.resizeButton); // button group

    const overLeft = this.context.element.wysiwygFrame.offsetWidth - l - contextResizing.resizeButton.offsetWidth;
    contextResizing.resizeButton.style.top = h + t + 60 + 'px';
    contextResizing.resizeButton.style.left = l + (overLeft < 0 ? overLeft : 0) + 'px';

    if (overLeft < 0) {
      contextResizing.resizeButton.firstElementChild.style.left = 20 - overLeft + 'px';
    } else {
      contextResizing.resizeButton.firstElementChild.style.left = '20px';
    }

    contextResizing._resize_w = w;
    contextResizing._resize_h = h;
    const originSize = (targetElement.getAttribute('origin-size') || '').split(',');
    contextResizing._origin_w = originSize[0] || targetElement.naturalWidth;
    contextResizing._origin_h = originSize[1] || targetElement.naturalHeight;
    return {
      w,
      h,
      t,
      l
    };
  },
  _closeAlignMenu: null,
  openAlignMenu() {
    this.util.addClass(this.context.resizing.alignButton, 'on');
    this.context.resizing.alignMenu.style.display = 'inline-table';

    this.plugins.resizing._closeAlignMenu = function() {
      this.util.removeClass(this.context.resizing.alignButton, 'on');
      this.context.resizing.alignMenu.style.display = 'none';
      this.removeDocEvent('mousedown', this.plugins.resizing._closeAlignMenu);
      this.plugins.resizing._closeAlignMenu = null;
    }.bind(this);

    this.addDocEvent('mousedown', this.plugins.resizing._closeAlignMenu);
  },
  create_caption() {
    const caption = this.util.createElement('FIGCAPTION');
    caption.setAttribute('contenteditable', true);
    caption.innerHTML = '<div>' + this.lang.dialogBox.caption + '</div>';
    return caption;
  },
  set_cover(element) {
    const cover = this.util.createElement('FIGURE');
    cover.appendChild(element);
    return cover;
  },
  set_container(cover, className) {
    const container = this.util.createElement('DIV');
    container.className = 'ke-component ' + className;
    container.setAttribute('contenteditable', false);
    container.appendChild(cover);
    return container;
  },
  onClickResizeButton(e) {
    e.stopPropagation();
    const target = e.target;
    const command = target.getAttribute('data-command') || target.parentNode.getAttribute('data-command');
    if (!command) { return; }
    const value = target.getAttribute('data-value') || target.parentNode.getAttribute('data-value');
    const pluginName = this.context.resizing._resize_plugin;
    const currentContext = this.context[pluginName];
    const contextEl = currentContext._element;
    const contextPlugin = this.plugins[pluginName];
    e.preventDefault();

    if (typeof this.plugins.resizing._closeAlignMenu === 'function') {
      this.plugins.resizing._closeAlignMenu();

      if (command === 'onalign') { return; }
    }

    switch (command) {
      case 'percent':
        this.plugins.resizing.resetTransform.call(this, contextEl);
        contextPlugin.setPercentSize.call(this, value * 100 + '%', 'auto');
        contextPlugin.onModifyMode.call(this, contextEl, this.plugins.resizing.call_controller_resize.call(this, contextEl, pluginName));
        break;

      case 'mirror':
        const r = contextEl.getAttribute('data-rotate') || '0';
        let x = contextEl.getAttribute('data-rotateX') || '';
        let y = contextEl.getAttribute('data-rotateY') || '';

        if (value === 'h' && !this.context.resizing._rotateVertical || value === 'v' && this.context.resizing._rotateVertical) {
          y = y ? '' : '180';
        } else {
          x = x ? '' : '180';
        }

        contextEl.setAttribute('data-rotateX', x);
        contextEl.setAttribute('data-rotateY', y);

        this.plugins.resizing._setTransForm(contextEl, r, x, y);

        break;

      case 'rotate':
        const contextResizing = this.context.resizing;
        const slope = contextEl.getAttribute('data-rotate') * 1 + value * 1;
        const deg = Math.abs(slope) >= 360 ? 0 : slope;
        contextEl.setAttribute('data-rotate', deg);
        contextResizing._rotateVertical = /^(90|270)$/.test(Math.abs(deg).toString());
        this.plugins.resizing.setTransformSize.call(this, contextEl, null, null);
        contextPlugin.onModifyMode.call(this, contextEl, this.plugins.resizing.call_controller_resize.call(this, contextEl, contextResizing._resize_plugin));
        break;

      case 'onalign':
        this.plugins.resizing.openAlignMenu.call(this);
        break;

      case 'align':
        const alignValue = value === 'basic' ? 'none' : value;

        if (alignValue && 'none' !== alignValue) {
          currentContext._cover.style.margin = 'auto';
        } else {
          currentContext._cover.style.margin = '0';
        }

        this.util.removeClass(currentContext._container, currentContext._floatClassRegExp);
        this.util.addClass(currentContext._container, '__se__float-' + alignValue);
        contextEl.setAttribute('data-align', alignValue);
        contextPlugin.onModifyMode.call(this, contextEl, this.plugins.resizing.call_controller_resize.call(this, contextEl, pluginName));
        break;

      case 'caption':
        const caption = !currentContext._captionChecked;
        contextPlugin.openModify.call(this, true);
        currentContext._captionChecked = currentContext.captionCheckEl.checked = caption;

        if (pluginName === 'image') {
          contextPlugin.update_image.call(this, false, false);
        } else if (pluginName === 'video') {
          this.context.dialog.updateModal = true;
          contextPlugin.submitAction.call(this);
        }

        if (caption) {
          const captionText = this.util.getChildElement(currentContext._caption, (current) => current.nodeType === 3);

          if (!captionText) {
            currentContext._caption.focus();
          } else {
            this.setRange(captionText, 0, captionText, captionText.textContent.length);
          }

          this.controllersOff();
        } else {
          contextPlugin.onModifyMode.call(this, contextEl, this.plugins.resizing.call_controller_resize.call(this, contextEl, pluginName));
          contextPlugin.openModify.call(this, true);
        }

        break;

      case 'revert':
        if (contextPlugin.setAutoSize) {
          contextPlugin.setAutoSize.call(this);
        } else {
          contextPlugin.resetAlign.call(this);
          this.plugins.resizing.resetTransform.call(this, contextEl);
        }

        contextPlugin.onModifyMode.call(this, contextEl, this.plugins.resizing.call_controller_resize.call(this, contextEl, pluginName));
        break;

      case 'update':
        contextPlugin.openModify.call(this);
        this.controllersOff();
        break;

      case 'delete':
        contextPlugin.destroy.call(this);
        break;
    } // history stack


    this.history.push();
  },
  resetTransform(element) {
    const originSize = (element.getAttribute('data-origin') || '').split(',');
    this.context.resizing._rotateVertical = false;
    element.style.transform = '';
    element.style.transformOrigin = '';
    element.setAttribute('data-rotate', '');
    element.setAttribute('data-rotateX', '');
    element.setAttribute('data-rotateY', '');
    element.style.width = originSize[0] ? originSize[0] + 'px' : 'auto';
    element.style.height = originSize[1] ? originSize[1] + 'px' : '';
    this.plugins.resizing.setTransformSize.call(this, element, null, null);
  },
  setTransformSize(element, width, height) {
    const cover = this.util.getParentElement(element, 'FIGURE');
    const isVertical = this.context.resizing._rotateVertical;
    const deg = element.getAttribute('data-rotate') * 1;
    const offsetW = width || element.offsetWidth;
    const offsetH = height || element.offsetHeight;
    const w = isVertical ? offsetH : offsetW;
    const h = isVertical ? offsetW : offsetH;

    this.plugins[this.context.resizing._resize_plugin].cancelPercentAttr.call(this);

    this.plugins[this.context.resizing._resize_plugin].setSize.call(this, offsetW, offsetH);

    cover.style.width = w + 'px';
    cover.style.height = this.context[this.context.resizing._resize_plugin]._caption ? '' : h + 'px';
    let transOrigin = '';

    if (isVertical) {
      const transW = offsetW / 2 + 'px ' + offsetW / 2 + 'px 0';
      const transH = offsetH / 2 + 'px ' + offsetH / 2 + 'px 0';
      transOrigin = deg === 90 || deg === -270 ? transH : transW;
    }

    element.style.transformOrigin = transOrigin;

    this.plugins.resizing._setTransForm(element, deg.toString(), element.getAttribute('data-rotateX') || '', element.getAttribute('data-rotateY') || '');

    this.plugins.resizing._setCaptionPosition.call(this, element, this.util.getChildElement(this.util.getParentElement(element, 'FIGURE'), 'FIGCAPTION'));
  },
  _setTransForm(element, r, x, y) {
    let width = (element.offsetWidth - element.offsetHeight) * (/-/.test(r) ? 1 : -1);
    let translate = '';

    if (/[1-9]/.test(r) && (x || y)) {
      translate = x ? 'Y' : 'X';

      switch (r) {
        case '90':
          translate = x && y ? 'X' : y ? translate : '';
          break;

        case '270':
          width *= -1;
          translate = x && y ? 'Y' : x ? translate : '';
          break;

        case '-90':
          translate = x && y ? 'Y' : x ? translate : '';
          break;

        case '-270':
          width *= -1;
          translate = x && y ? 'X' : y ? translate : '';
          break;

        default:
          translate = '';
      }
    }

    if (r % 180 === 0) {
      element.style.maxWidth = '100%';
    }

    element.style.transform = 'rotate(' + r + 'deg)' + (x ? ' rotateX(' + x + 'deg)' : '') + (y ? ' rotateY(' + y + 'deg)' : '') + (translate ? ' translate' + translate + '(' + width + 'px)' : '');
  },
  _setCaptionPosition(element, figcaption) {
    if (figcaption) {
      figcaption.style.marginTop = (this.context.resizing._rotateVertical ? element.offsetWidth - element.offsetHeight : 0) + 'px';
    }
  },
  // resizing
  onMouseDownResizeHandle(e) {
    const contextResizing = this.context.resizing;
    const direction = contextResizing._resize_direction = e.target.classList[0];
    e.stopPropagation();
    e.preventDefault();
    contextResizing._resizeClientX = e.clientX;
    contextResizing._resizeClientY = e.clientY;
    this.context.element.resizeBackground.style.display = 'block';
    contextResizing.resizeButton.style.display = 'none';
    contextResizing.resizeDiv.style.float = /l/.test(direction) ? 'right' : /r/.test(direction) ? 'left' : 'none';

    const closureFuncBound = function closureFunc() {
      const change = contextResizing._isChange;
      contextResizing._isChange = false;
      document.removeEventListener('mousemove', resizingElementBound);
      document.removeEventListener('mouseup', closureFuncBound); // element resize

      this.plugins.resizing.cancel_controller_resize.call(this); // history stack

      if (change) { this.history.push(); }
    }.bind(this);

    const resizingElementBound = this.plugins.resizing.resizing_element.bind(this, contextResizing, direction, this.context[contextResizing._resize_plugin]);
    document.addEventListener('mousemove', resizingElementBound);
    document.addEventListener('mouseup', closureFuncBound);
  },
  resizing_element(contextResizing, direction, plugin, e) {
    const clientX = e.clientX;
    const clientY = e.clientY;
    let resultW = plugin._element_w;
    let resultH = plugin._element_h;
    const w = plugin._element_w + (/r/.test(direction) ? clientX - contextResizing._resizeClientX : contextResizing._resizeClientX - clientX);
    const h = plugin._element_h + (/b/.test(direction) ? clientY - contextResizing._resizeClientY : contextResizing._resizeClientY - clientY);
    const wh = plugin._element_h / plugin._element_w * w;
    if (/t/.test(direction)) { contextResizing.resizeDiv.style.top = plugin._element_h - (/h/.test(direction) ? h : wh) + 'px'; }
    if (/l/.test(direction)) { contextResizing.resizeDiv.style.left = plugin._element_w - w + 'px'; }

    if (/r|l/.test(direction)) {
      contextResizing.resizeDiv.style.width = w + 'px';
      resultW = w;
    }

    if (/^(t|b)[^h]$/.test(direction)) {
      contextResizing.resizeDiv.style.height = wh + 'px';
      resultH = wh;
    } else if (/^(t|b)h$/.test(direction)) {
      contextResizing.resizeDiv.style.height = h + 'px';
      resultH = h;
    }

    contextResizing._resize_w = resultW;
    contextResizing._resize_h = resultH;
    this.util.changeTxt(contextResizing.resizeDisplay, Math.round(resultW) + ' x ' + Math.round(resultH));
    contextResizing._isChange = true;
  },
  cancel_controller_resize() {
    const isVertical = this.context.resizing._rotateVertical;
    this.controllersOff();
    this.context.element.resizeBackground.style.display = 'none';

    let w = Math.round(isVertical ? this.context.resizing._resize_h : this.context.resizing._resize_w);

    let h: number | 'auto' = Math.round(isVertical ? this.context.resizing._resize_w : this.context.resizing._resize_h);

    if (!isVertical && !/^\d+%$/.test(w.toString())) {
      const padding = 16;
      const limit = this.context.element.wysiwygFrame.clientWidth - padding * 2 - 2;

      if (parseInt(w.toString().match(/\d+/)[0], 10) > limit) {
        w = limit;
        h = this.context.resizing._resize_plugin === 'video' ? h / w * limit : 'auto';
      }
    }

    this.plugins[this.context.resizing._resize_plugin].setSize.call(this, w, h);

    this.plugins.resizing.setTransformSize.call(this, this.context[this.context.resizing._resize_plugin]._element, w, h);

    this.plugins[this.context.resizing._resize_plugin].init.call(this);
  }
});
// CONCATENATED MODULE: ./src/plugins/modules/notice.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */


const notice = ({
  name: 'notice',
  add(core) {
    const context = core.context;
    context.notice = {};
    /** dialog */

    let noticeDiv = core.util.createElement('DIV');
    const noticeSpan = core.util.createElement('SPAN');
    const noticeButton = core.util.createElement('BUTTON');
    noticeDiv.className = 'ke-notice';
    noticeButton.className = 'close';
    noticeButton.setAttribute('aria-label', 'Close');
    noticeButton.setAttribute('title', core.lang.dialogBox.close);
    noticeButton.innerHTML = '<i aria-hidden="true" data-command="close" class="ke-icon-cancel"></i>';
    noticeDiv.appendChild(noticeSpan);
    noticeDiv.appendChild(noticeButton);
    context.notice.modal = noticeDiv;
    context.notice.message = noticeSpan;
    /** add event listeners */

    noticeButton.addEventListener('click', this.onClick_cancel.bind(core));
    /** append html */

    context.element.editorArea.insertBefore(noticeDiv, context.element.wysiwygFrame);
    /** empty memory */

    noticeDiv = null;
  },
  onClick_cancel(e) {
    e.preventDefault();
    e.stopPropagation();
    this.plugins.notice.close.call(this);
  },
  open(text) {
    this.context.notice.message.textContent = text;
    this.context.notice.modal.style.display = 'block';
  },
  close() {
    this.context.notice.modal.style.display = 'none';
  }
});
// CONCATENATED MODULE: ./src/plugins/dialog/image.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

const dialogImagePlugin = ({
  name: 'image',
  add(core) {
    core.addModule([dialog, resizing, notice]);
    const context = core.context;
    context.image = {
      _linkElement: null,
      _container: null,
      _cover: null,
      _element: null,
      _element_w: 1,
      _element_h: 1,
      _element_l: 0,
      _element_t: 0,
      _origin_w: context.option.imageWidth === 'auto' ? '' : context.option.imageWidth,
      _origin_h: '',
      _altText: '',
      _caption: null,
      captionCheckEl: null,
      _linkValue: '',
      _align: 'none',
      _captionChecked: false,
      _proportionChecked: true,
      _floatClassRegExp: '__se__float\\-[a-z]+',
      _xmlHttp: null,
      _resizing: context.option.imageResizing,
      _defaultAuto: context.option.imageWidth === 'auto',
      _uploadFileLength: 0
    };
    /** image dialog */

    let imageDialog = this.setDialog.call(core);
    context.image.modal = imageDialog;
    context.image.imgUrlFile = imageDialog.querySelector('._se_image_url');
    context.image.imgInputFile = context.image.focusElement = imageDialog.querySelector('._se_image_file');
    context.image.altText = imageDialog.querySelector('._se_image_alt');
    context.image.imgLink = imageDialog.querySelector('._se_image_link');
    context.image.imgLinkNewWindowCheck = imageDialog.querySelector('._se_image_link_check');
    context.image.captionCheckEl = imageDialog.querySelector('._se_image_check_caption');
    /** add event listeners */

    context.image.modal.querySelector('.ke-dialog-tabs').addEventListener('click', this.openTab.bind(core));
    context.image.modal.querySelector('.ke-btn-primary').addEventListener('click', this.submit.bind(core));
    context.image.imageX = {};
    context.image.imageY = {};

    if (context.option.imageResizing) {
      context.image.proportion = imageDialog.querySelector('._se_image_check_proportion');
      context.image.imageX = imageDialog.querySelector('._se_image_size_x');
      context.image.imageY = imageDialog.querySelector('._se_image_size_y');
      context.image.imageX.value = context.option.imageWidth;
      context.image.imageX.addEventListener('change', this.setInputSize.bind(core, 'x'));
      context.image.imageY.addEventListener('change', this.setInputSize.bind(core, 'y'));
      imageDialog.querySelector('.ke-dialog-btn-revert').addEventListener('click', this.sizeRevert.bind(core));
    }
    /** append html */


    context.dialog.modal.appendChild(imageDialog);
    /** empty memory */

    imageDialog = null;
  },

  /** dialog */
  setDialog() {
    const option = this.context.option;
    const lang = this.lang;
    const internalDialog = this.util.createElement('DIV');
    internalDialog.className = 'ke-dialog-content';
    internalDialog.style.display = 'none';
    // @ts-ignore
    let html = '<div class="ke-dialog-header">' + '<button type="button" data-command="close" class="close" aria-label="Close" title="' + lang.dialogBox.close + '">' + '<i aria-hidden="true" data-command="close" class="ke-icon-cancel"></i>' + '</button>' + '<span class="ke-modal-title">' + lang.dialogBox.imageBox.title + '</span>' + '</div>' + '<div class="ke-dialog-tabs">' + '<button type="button" class="_se_tab_link active" data-tab-link="image">' + lang.toolbar.image + '</button>' + '<button type="button" class="_se_tab_link" data-tab-link="url">' + lang.toolbar.link + '</button>' + '</div>' + '<form class="editor_image" method="post" enctype="multipart/form-data">' + '<div class="_se_tab_content _se_tab_content_image">' + '<div class="ke-dialog-body">';

    if (option.imageFileInput) {
      // @ts-ignore
      html += '<div class="ke-dialog-form">' + '<label>' + lang.dialogBox.imageBox.file + '</label>' + '<input class="ke-input-form _se_image_file" type="file" accept="image/*" multiple="multiple" />' + '</div>';
    }

    if (option.imageUrlInput) {
      // @ts-ignore
      html += '<div class="ke-dialog-form">' + '<label>' + lang.dialogBox.imageBox.url + '</label>' + '<input class="ke-input-form _se_image_url" type="text" />' + '</div>';
    }

    // @ts-ignore
    html += '<div class="ke-dialog-form">' + '<label>' + lang.dialogBox.imageBox.altText + '</label><input class="ke-input-form _se_image_alt" type="text" />' + '</div>';

    if (option.imageResizing) {
      // @ts-ignore
      html += '<div class="ke-dialog-form">' + '<div class="ke-dialog-size-text"><label class="size-w">' + lang.dialogBox.width + '</label><label class="ke-dialog-size-x">&nbsp;</label><label class="size-h">' + lang.dialogBox.height + '</label></div>' + '<input class="ke-input-control _se_image_size_x" type="number" min="1" ' + (option.imageWidth === 'auto' ? 'disabled' : '') + ' /><label class="ke-dialog-size-x">x</label><input class="ke-input-control _se_image_size_y" type="number" min="1" disabled />' + '<label><input type="checkbox" class="ke-dialog-btn-check _se_image_check_proportion" checked disabled/>&nbsp;' + lang.dialogBox.proportion + '</label>' + '<button type="button" title="' + lang.dialogBox.revertButton + '" class="ke-btn ke-dialog-btn-revert" style="float: right;"><i class="ke-icon-revert"></i></button>' + '</div>';
    }

    // @ts-ignore
    html += '<div class="ke-dialog-form-footer">' + '<label><input type="checkbox" class="ke-dialog-btn-check _se_image_check_caption" />&nbsp;' + lang.dialogBox.caption + '</label>' + '</div>' + '</div>' + '</div>' + '<div class="_se_tab_content _se_tab_content_url" style="display: none">' + '<div class="ke-dialog-body">' + '<div class="ke-dialog-form">' + '<label>' + lang.dialogBox.linkBox.url + '</label><input class="ke-input-form _se_image_link" type="text" />' + '</div>' + '<label><input type="checkbox" class="_se_image_link_check"/>&nbsp;' + lang.dialogBox.linkBox.newWindowCheck + '</label>' + '</div>' + '</div>' + '<div class="ke-dialog-footer">' + '<div class="footer-div">' + '<label><input type="radio" name="keditor_image_radio" class="ke-dialog-btn-radio" value="none" checked>' + lang.dialogBox.basic + '</label>' + '<label><input type="radio" name="keditor_image_radio" class="ke-dialog-btn-radio" value="left">' + lang.dialogBox.left + '</label>' + '<label><input type="radio" name="keditor_image_radio" class="ke-dialog-btn-radio" value="center">' + lang.dialogBox.center + '</label>' + '<label><input type="radio" name="keditor_image_radio" class="ke-dialog-btn-radio" value="right">' + lang.dialogBox.right + '</label>' + '</div>' + '<button type="button" data-command="close" class="ke-btn-cancel" aria-label="Close" title="' + lang.dialogBox.close + '"><span data-command="close">' + lang.dialogBox.close + '</span></button>' + '<button type="submit" class="ke-btn-primary" title="' + lang.dialogBox.submitButton + '"><span>' + lang.dialogBox.submitButton + '</span></button>' + '</div>' + '</form>';
    internalDialog.innerHTML = html;
    return internalDialog;
  },
  openTab(e) {
    const modal = this.context.image.modal;
    const targetElement = e === 'init' ? modal.querySelector('._se_tab_link') : e.target;

    if (!/^BUTTON$/i.test(targetElement.tagName)) {
      return false;
    }
    // Declare all variables
    const tabName = targetElement.getAttribute('data-tab-link');
    const contentClassName = '_se_tab_content';
    let i: number;
    let tabContent;
    let tabLinks;

    // Get all elements with class="tabcontent" and hide them
    tabContent = modal.getElementsByClassName(contentClassName);

    for (const elem of tabContent) {
      elem.style.display = 'none';
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tabLinks = modal.getElementsByClassName('_se_tab_link');

    for (i = 0; i < tabLinks.length; i++) {
      this.util.removeClass(tabLinks[i], 'active');
    }
    // Show the current tab, and add an "active" class to the button that opened the tab
    modal.querySelector('.' + contentClassName + '_' + tabName).style.display = 'block';
    this.util.addClass(targetElement, 'active'); // focus

    if (tabName === 'image') {
      this.context.image.imgInputFile.focus();
    } else if (tabName === 'url') {
      this.context.image.imgLink.focus();
    }

    return false;
  },
  submitAction(fileList) {
    if (fileList.length > 0) {
      let fileSize = 0;
      const files = [];

      for (let i = 0, len = fileList.length; i < len; i++) {
        if (/image/i.test(fileList[i].type)) {
          files.push(fileList[i]);
          fileSize += fileList[i].size;
        }
      }

      const limitSize = this.context.option.imageUploadSizeLimit;

      if (limitSize > 0) {
        let infoSize = 0;
        const imagesInfo = this._variable._imagesInfo;

        for (let i = 0, len = imagesInfo.length; i < len; i++) {
          infoSize += imagesInfo[i].size * 1;
        }

        if (fileSize + infoSize > limitSize) {
          const err = '[KEDITOR.imageUpload.fail] Size of uploadable total images: ' + limitSize / 1000 + 'KB';

          if (this._imageUploadError(err, {
            limitSize,
            currentSize: infoSize,
            uploadSize: fileSize
          })) {
            notice.open.call(this, err);
          }

          this.closeLoading();
          return;
        }
      }

      this.context.image._uploadFileLength = files.length;
      const imageUploadUrl = this.context.option.imageUploadUrl;
      const imageUploadHeader = this.context.option.imageUploadHeader;
      const filesLen = this.context.dialog.updateModal ? 1 : files.length;

      if (typeof imageUploadUrl === 'string' && imageUploadUrl.length > 0) {
        const formData = new FormData();

        for (let i = 0; i < filesLen; i++) {
          formData.append('file-' + i, files[i]);
        }

        this.context.image._xmlHttp = this.util.getXMLHttpRequest();
        this.context.image._xmlHttp.onreadystatechange = this.plugins.image.callBack_imgUpload.bind(this, this.context.image._linkValue, this.context.image.imgLinkNewWindowCheck.checked, this.context.image.imageX.value, this.context.image._align, this.context.dialog.updateModal, this.context.image._element);

        this.context.image._xmlHttp.open('post', imageUploadUrl, true);

        if (typeof imageUploadHeader === 'object' && Object.keys(imageUploadHeader).length > 0) {
          for (const key of Object.keys(imageUploadHeader)) {
            this.context.image._xmlHttp.setRequestHeader(key, imageUploadHeader[key]);
          }
        }

        this.context.image._xmlHttp.send(formData);
      } else {
        for (let i = 0; i < filesLen; i++) {
          this.plugins.image.setup_reader.call(this, files[i], this.context.image._linkValue, this.context.image.imgLinkNewWindowCheck.checked, this.context.image.imageX.value, this.context.image._align, i, filesLen - 1);
        }
      }
    }
  },
  onRender_imgInput() {
    try {
      this.plugins.image.submitAction.call(this, this.context.image.imgInputFile.files);
    } catch(e) {
      this.closeLoading();
      throw Error('[KEDITOR.imageUpload.fail] cause : "' + e.message + '"');
    }
  },
  setup_reader(file, imgLinkValue, newWindowCheck, width, align, index, filesLen) {
    const reader = new FileReader();

    if (this.context.dialog.updateModal) {
      this.context.image._element.setAttribute('data-file-name', file.name);

      this.context.image._element.setAttribute('data-file-size', file.size);
    }

    reader.onload = function(update, updateElement, internalFile) {
      try {
        if (update) { this.plugins.image.update_src.call(this, reader.result, updateElement, internalFile); } else { this.plugins.image.create_image.call(this, reader.result, imgLinkValue, newWindowCheck, width, align, internalFile); }
        if (index === filesLen) { this.closeLoading(); }
      } catch(e) {
        this.closeLoading();
        throw Error('[KEDITOR.imageFileRendering.fail] cause : "' + e.message + '"');
      }
    }.bind(this, this.context.dialog.updateModal, this.context.image._element, file);

    reader.readAsDataURL(file);
  },
  callBack_imgUpload(linkValue, linkNewWindow, width, align, update, updateElement) {
    if (this.context.image._xmlHttp.readyState === 4) {
      if (this.context.image._xmlHttp.status === 200) {
        const response = JSON.parse(this.context.image._xmlHttp.responseText);

        if (response.errorMessage) {
          this.closeLoading();

          if (this._imageUploadError(response.errorMessage, response.result)) {
            notice.open.call(this, response.errorMessage);
          }
        } else {
          const fileList = response.result;

          for (let i = 0, len = fileList.length, file; i < len; i++) {
            file = {
              name: fileList[i].name,
              size: fileList[i].size
            };
            if (update) { this.plugins.image.update_src.call(this, fileList[i].url, updateElement, file); } else { this.plugins.image.create_image.call(this, fileList[i].url, linkValue, linkNewWindow, width, align, file); }
          }
        }

        this.closeLoading();
      } else {
          this.closeLoading();
          throw Error('[KEDITOR.imageUpload.fail] status: ' + this.context.image._xmlHttp.status + ', responseURL: ' + this.context.image._xmlHttp.responseURL);
        }
    }
  },
  onRender_imgUrl() {
    if (this.context.image.imgUrlFile.value.trim().length === 0) { return false; }

    try {
      const file = {
        name: this.context.image.imgUrlFile.value.split('/').pop(),
        size: 0
      };
      if (this.context.dialog.updateModal) { this.plugins.image.update_src.call(this, this.context.image.imgUrlFile.value, this.context.image._element, file); } else { this.plugins.image.create_image.call(this, this.context.image.imgUrlFile.value, this.context.image._linkValue, this.context.image.imgLinkNewWindowCheck.checked, this.context.image.imageX.value + 'px', this.context.image._align, file); }
    } catch(e) {
      throw Error('[KEDITOR.imageURLRendering.fail] cause : "' + e.message + '"');
    } finally {
      this.closeLoading();
    }
  },
  onRender_link(imgTag, imgLinkValue, newWindowCheck) {
    if (imgLinkValue.trim().length > 0) {
      const link = this.util.createElement('A');
      link.href = /^https?:\/\//.test(imgLinkValue) ? imgLinkValue : 'http://' + imgLinkValue;
      link.target = newWindowCheck ? '_blank' : '';
      link.setAttribute('data-image-link', 'image');
      imgTag.setAttribute('data-image-link', imgLinkValue);
      link.appendChild(imgTag);
      return link;
    }

    return imgTag;
  },
  setInputSize(xy) {
    if (!this.context.dialog.updateModal) { return; }
    const contextImage = this.context.image;

    if (contextImage.proportion.checked) {
      if (xy === 'x') {
        contextImage.imageY.value = Math.round(contextImage._element_h / contextImage._element_w * contextImage.imageX.value);
      } else {
        contextImage.imageX.value = Math.round(contextImage._element_w / contextImage._element_h * contextImage.imageY.value);
      }
    }
  },
  submit(e) {
    const contextImage = this.context.image;
    const imagePlugin = this.plugins.image;
    this.showLoading();
    e.preventDefault();
    e.stopPropagation();
    contextImage._linkValue = contextImage.imgLink.value;
    contextImage._altText = contextImage.altText.value;
    contextImage._align = contextImage.modal.querySelector('input[name="keditor_image_radio"]:checked').value;
    contextImage._captionChecked = contextImage.captionCheckEl.checked;
    if (contextImage._resizing) { contextImage._proportionChecked = contextImage.proportion.checked; }

    try {
      if (this.context.dialog.updateModal) {
        imagePlugin.update_image.call(this, false, false);
      }

      if (contextImage.imgInputFile && contextImage.imgInputFile.files.length > 0) {
        imagePlugin.onRender_imgInput.call(this);
      } else if (contextImage.imgUrlFile && contextImage.imgUrlFile.value.trim().length > 0) {
        imagePlugin.onRender_imgUrl.call(this);
      } else {
        this.closeLoading();
      }
    } catch(error) {
      this.closeLoading();
      throw Error('[KEDITOR.image.submit.fail] cause : "' + error.message + '"');
    } finally {
      this.plugins.dialog.close.call(this);
    }

    return false;
  },
  setImagesInfo(img, file) {
    const imagesInfo = this._variable._imagesInfo;
    let dataIndex = img.getAttribute('data-index');
    let info = null;
    let state = ''; // create

    if (!dataIndex) {
      state = 'create';
      dataIndex = this._variable._imageIndex;
      this._variable._imageIndex++;
      img.setAttribute('data-index', dataIndex);
      img.setAttribute('data-file-name', file.name);
      img.setAttribute('data-file-size', file.size);
      info = {
        src: img.src,
        index: dataIndex * 1,
        name: file.name,
        size: file.size
      };
      imagesInfo.push(info);
    } else {
      // update
      state = 'update';
      dataIndex *= 1;

      for (let i = 0, len = imagesInfo.length; i < len; i++) {
        if (dataIndex === imagesInfo[i].index) {
          info = imagesInfo[i];
          break;
        }
      }

      info.src = img.src, info.name = img.getAttribute('data-file-name');
      info.size = img.getAttribute('data-file-size') * 1;
    } // method bind


    info.delete = this.plugins.image.destroy.bind(this, img);

    info.select = () => {
      img.scrollIntoView(true);

      window.setTimeout(() => {
        this.plugins.image.onModifyMode.call(this, img, this.plugins.resizing.call_controller_resize.call(this, img, 'image'));
      });
    };

    img.setAttribute('origin-size', img.naturalWidth + ',' + img.naturalHeight);
    img.setAttribute('data-origin', img.offsetWidth + ',' + img.offsetHeight);

    this._imageUpload(img, dataIndex, state, info, --this.context.image._uploadFileLength < 0 ? 0 : this.context.image._uploadFileLength);
  },
  checkImagesInfo() {
    const images = this.context.element.wysiwyg.getElementsByTagName('IMG');
    const imagesInfo = this._variable._imagesInfo;
    if (images.length === imagesInfo.length) { return; }
    const imagePlugin = this.plugins.image;
    const currentImages = [];
    const infoIndex = [];

    for (let i = 0, len = imagesInfo.length; i < len; i++) {
      infoIndex[i] = imagesInfo[i].index;
    }

    for (let i = 0, len = images.length, img; i < len; i++) {
      img = images[i];

      if (!this.util.getParentElement(img, '.ke-image-container')) {
        currentImages.push(this._variable._imageIndex);
        imagePlugin.onModifyMode.call(this, img, null);
        imagePlugin.openModify.call(this, true);
        imagePlugin.update_image.call(this, true, false);
      } else if (!img.getAttribute('data-index') || infoIndex.indexOf(img.getAttribute('data-index') * 1) < 0) {
        currentImages.push(this._variable._imageIndex);
        img.removeAttribute('data-index');
        imagePlugin.setImagesInfo.call(this, img, {
          name: img.getAttribute('data-file-name') || img.src.split('/').pop(),
          size: img.getAttribute('data-file-size') || 0
        });
      } else {
        currentImages.push(img.getAttribute('data-index') * 1);
      }
    }

    for (let i = 0, dataIndex; i < imagesInfo.length; i++) {
      dataIndex = imagesInfo[i].index;
      if (currentImages.indexOf(dataIndex) > -1) { continue; }
      imagesInfo.splice(i, 1);

      this._imageUpload(null, dataIndex, 'delete', null, 0);

      i--;
    }
  },
  _onload_image(oImg, file) {
    if (!file) { return; }
    this.plugins.image.setImagesInfo.call(this, oImg, file);
  },
  create_image(src, linkValue, linkNewWindow, width, align, file) {
    const contextImage = this.context.image;
    let oImg = this.util.createElement('IMG');
    oImg.addEventListener('load', this.plugins.image._onload_image.bind(this, oImg, file));
    oImg.src = src;
    oImg.setAttribute('data-align', align);
    oImg.alt = contextImage._altText;
    oImg = this.plugins.image.onRender_link.call(this, oImg, linkValue, linkNewWindow);
    oImg.setAttribute('data-rotate', '0');

    if (contextImage._resizing) {
      if (/\d+/.test(width)) {
        width = width.match(/\d+/)[0] * 1;
        if (width > 0) { oImg.style.width = width + 'px'; } else { width = ''; }
      }

      oImg.setAttribute('data-proportion', contextImage._proportionChecked);
    }

    const cover = this.plugins.resizing.set_cover.call(this, oImg);
    const container = this.plugins.resizing.set_container.call(this, cover, 'ke-image-container'); // caption

    if (contextImage._captionChecked) {
      contextImage._caption = this.plugins.resizing.create_caption.call(this);

      contextImage._caption.setAttribute('contenteditable', false);

      cover.appendChild(contextImage._caption);
    } // align


    if ('none' !== align) {
      cover.style.margin = 'auto';
    } else {
      cover.style.margin = '0';
    }

    this.util.removeClass(container, contextImage._floatClassRegExp);
    this.util.addClass(container, '__se__float-' + align);

    if (!contextImage._resizing || !/\d+/.test(width)) {
      this.context.resizing._resize_plugin = 'image';
      contextImage._element = oImg;
      contextImage._cover = cover;
      contextImage._container = container;
      this.plugins.image.setAutoSize.call(this);
    }

    this.insertComponent(container);
  },
  update_image(init, openController) {
    const contextImage = this.context.image;
    const linkValue = contextImage._linkValue;
    let imageEl = contextImage._element;
    let cover = contextImage._cover;
    let container = contextImage._container;
    let isNewContainer = false;
    const changeSize = contextImage.imageX.value * 1 !== imageEl.offsetWidth || contextImage.imageY.value * 1 !== imageEl.offsetHeight;

    if (cover === null) {
      isNewContainer = true;
      imageEl = contextImage._element.cloneNode(true);
      cover = this.plugins.resizing.set_cover.call(this, imageEl);
    }

    if (container === null) {
      cover = cover.cloneNode(true);
      isNewContainer = true;
      container = this.plugins.resizing.set_container.call(this, cover, 'ke-image-container');
    }

    if (isNewContainer) {
      container.innerHTML = '';
      container.appendChild(cover);
    } // size


    imageEl.alt = contextImage._altText;

    if (contextImage._resizing) {
      imageEl.setAttribute('data-proportion', contextImage._proportionChecked);
      if (changeSize) { this.plugins.image.setSize.call(this, contextImage.imageX.value, contextImage.imageY.value); }
    } // caption


    if (contextImage._captionChecked) {
      if (!contextImage._caption) {
        contextImage._caption = this.plugins.resizing.create_caption.call(this);
        cover.appendChild(contextImage._caption);
      }
    } else {
      if (contextImage._caption) {
        this.util.removeItem(contextImage._caption);
        contextImage._caption = null;
      }
    } // align


    if (contextImage._align && 'none' !== contextImage._align) {
      cover.style.margin = 'auto';
    } else {
      cover.style.margin = '0';
    }

    this.util.removeClass(container, this.context.image._floatClassRegExp);
    this.util.addClass(container, '__se__float-' + contextImage._align);
    imageEl.setAttribute('data-align', contextImage._align); // link

    if (linkValue.trim().length > 0) {
      if (contextImage._linkElement !== null) {
        contextImage._linkElement.href = linkValue;
        contextImage._linkElement.target = contextImage.imgLinkNewWindowCheck.checked ? '_blank' : '';
        imageEl.setAttribute('data-image-link', linkValue);
      } else {
        const newEl = this.plugins.image.onRender_link.call(this, imageEl, linkValue, this.context.image.imgLinkNewWindowCheck.checked);
        cover.insertBefore(newEl, contextImage._caption);
      }
    } else if (contextImage._linkElement !== null) {
      const imageElement = imageEl;
      imageElement.setAttribute('data-image-link', '');
      const newEl = imageElement.cloneNode(true);
      cover.removeChild(contextImage._linkElement);
      cover.insertBefore(newEl, contextImage._caption);
      imageEl = newEl;
    }

    if (isNewContainer) {
      let existElement = this.util.isRangeFormatElement(contextImage._element.parentNode) || this.util.isWysiwygDiv(contextImage._element.parentNode) ? (
          contextImage._element
        ) : (
          /^A$/i.test(contextImage._element.parentNode.nodeName) ? (
            contextImage._element.parentNode
          ) : (
            this.util.getFormatElement(contextImage._element) || contextImage._element
          )
        );
      if (!existElement) {
        existElement = contextImage._element;
      }
      existElement.parentNode.insertBefore(container, existElement);
      this.util.removeItem(existElement);
      imageEl = container.querySelector('img');
    } // transform


    if (
      !init && (
        /\d+/.test(imageEl.style.height) ||
        contextImage._resizing && changeSize ||
        (
          this.context.resizing._rotateVertical && contextImage._captionChecked
        )
      )
    ) {
      this.plugins.resizing.setTransformSize.call(this, imageEl, null, null);
    } // set imagesInfo


    if (init) {
      this.plugins.image.setImagesInfo.call(this, imageEl, {
        name: imageEl.getAttribute('data-file-name') || imageEl.src.split('/').pop(),
        size: imageEl.getAttribute('data-file-size') || 0
      });
    }

    if (openController) {
      this.plugins.image.init.call(this);
      const size = this.plugins.resizing.call_controller_resize.call(this, imageEl, 'image');
      this.plugins.image.onModifyMode.call(this, imageEl, size);
    } // history stack


    this.history.push();
  },
  update_src(src, element, file) {
    element.src = src;

    window.setTimeout(this.plugins.image.setImagesInfo.bind(this, element, file));
  },
  sizeRevert() {
    const contextImage = this.context.image;

    if (contextImage._origin_w) {
      contextImage.imageX.value = contextImage._element_w = contextImage._origin_w;
      contextImage.imageY.value = contextImage._element_h = contextImage._origin_h;
    }
  },
  onModifyMode(element, size) {
    const contextImage = this.context.image;
    contextImage._linkElement = /^A$/i.test(element.parentNode.nodeName) ? element.parentNode : null;
    contextImage._element = element;
    contextImage._cover = this.util.getParentElement(element, 'FIGURE');
    contextImage._container = this.util.getParentElement(element, '.ke-image-container');
    contextImage._caption = this.util.getChildElement(contextImage._cover, 'FIGCAPTION');
    contextImage._align = element.getAttribute('data-align') || 'none';

    if (size) {
      contextImage._element_w = size.w;
      contextImage._element_h = size.h;
      contextImage._element_t = size.t;
      contextImage._element_l = size.l;
    }

    let userSize = contextImage._element.getAttribute('data-origin');

    if (userSize) {
      userSize = userSize.split(',');
      contextImage._origin_w = userSize[0] * 1;
      contextImage._origin_h = userSize[1] * 1;
    } else if (size) {
      contextImage._origin_w = size.w;
      contextImage._origin_h = size.h;

      contextImage._element.setAttribute('data-origin', size.w + ',' + size.h);
    }
  },
  openModify(notOpen) {
    const contextImage = this.context.image;
    contextImage.imgUrlFile.value = contextImage._element.src;
    contextImage._altText = contextImage.altText.value = contextImage._element.alt;
    contextImage._linkValue = contextImage.imgLink.value = contextImage._linkElement === null ? '' : contextImage._linkElement.href;
    contextImage.imgLinkNewWindowCheck.checked = contextImage._linkElement && contextImage._linkElement.target === '_blank';
    contextImage.modal.querySelector('input[name="keditor_image_radio"][value="' + contextImage._align + '"]').checked = true;
    contextImage._align = contextImage.modal.querySelector('input[name="keditor_image_radio"]:checked').value;
    contextImage._captionChecked = contextImage.captionCheckEl.checked = !!contextImage._caption;

    if (contextImage._resizing) {
      contextImage.proportion.checked = contextImage._proportionChecked = contextImage._element.getAttribute('data-proportion') !== 'false';
      contextImage.imageX.value = contextImage._element.offsetWidth;
      contextImage.imageY.value = contextImage._element.offsetHeight;
      contextImage.imageX.disabled = false;
      contextImage.imageY.disabled = false;
      contextImage.proportion.disabled = false;
    }

    if (!notOpen) { this.plugins.dialog.open.call(this, 'image', true); }
  },
  on(update) {
    if (!update) {
      const contextImage = this.context.image;
      contextImage.imageX.value = contextImage._origin_w = contextImage._defaultAuto ? '' : this.context.option.imageWidth;
      contextImage.imageY.value = contextImage._origin_h = '';
    }
  },
  setSize(w: number | string, h: number | string) {
    const contextImage = this.context.image;
    contextImage._element.style.width = /^\d+$/.test(w.toString()) ? w + 'px' : w;
    contextImage._element.style.height = /^\d+$/.test(h.toString()) ? h + 'px' : h;
  },
  setAutoSize() {
    const contextImage = this.context.image;
    this.plugins.resizing.resetTransform.call(this, contextImage._element);
    this.plugins.image.cancelPercentAttr.call(this);
    const originSize = (contextImage._element.getAttribute('data-origin') || '').split(',');
    contextImage._element.style.maxWidth = '100%';
    contextImage._element.style.width = originSize[0] ? originSize[0] + 'px' : '100%';
    contextImage._element.style.height = '';
    contextImage._cover.style.width = '';
    contextImage._cover.style.height = '';
  },
  setPercentSize(w) {
    const contextImage = this.context.image;
    contextImage._element.style.maxWidth = '100%';
    contextImage._container.style.width = w;
    contextImage._container.style.height = '';
    contextImage._cover.style.width = '100%';
    contextImage._cover.style.height = '';
    contextImage._element.style.width = '100%';
    contextImage._element.style.height = '';

    if (/100/.test(w)) {
      this.util.removeClass(contextImage._container, this.context.image._floatClassRegExp);
      this.util.addClass(contextImage._container, '__se__float-center');
    }
  },
  cancelPercentAttr() {
    const contextImage = this.context.image;
    contextImage._element.style.maxWidth = 'none';
    contextImage._cover.style.width = '';
    contextImage._cover.style.height = '';
    contextImage._container.style.width = '';
    contextImage._container.style.height = '';
    this.util.removeClass(contextImage._container, this.context.image._floatClassRegExp);
    this.util.addClass(contextImage._container, '__se__float-' + contextImage._align);
  },
  resetAlign() {
    const contextImage = this.context.image;

    contextImage._element.setAttribute('data-align', '');

    contextImage._align = 'none';
    contextImage._cover.style.margin = '0';
    this.util.removeClass(contextImage._container, contextImage._floatClassRegExp);
  },
  destroy(element) {
    const imageEl = element || this.context.image._element;
    const imageContainer = this.util.getParentElement(imageEl, '.ke-image-container') || imageEl;
    const dataIndex = imageEl.getAttribute('data-index') * 1;
    this.util.removeItem(imageContainer);
    this.plugins.image.init.call(this);
    this.controllersOff(); // history stack

    this.history.push();

    if (dataIndex >= 0) {
      const imagesInfo = this._variable._imagesInfo;

      for (let i = 0, len = imagesInfo.length; i < len; i++) {
        if (dataIndex === imagesInfo[i].index) {
          imagesInfo.splice(i, 1);

          this._imageUpload(null, dataIndex, 'delete', null, 0);

          return;
        }
      }
    }
  },
  init() {
    const contextImage = this.context.image;
    if (contextImage.imgInputFile) { contextImage.imgInputFile.value = ''; }
    if (contextImage.imgUrlFile) { contextImage.imgUrlFile.value = ''; }
    contextImage.altText.value = '';
    contextImage.imgLink.value = '';
    contextImage.imgLinkNewWindowCheck.checked = false;
    contextImage.modal.querySelector('input[name="keditor_image_radio"][value="none"]').checked = true;
    contextImage.captionCheckEl.checked = false;
    contextImage._element = null;
    this.plugins.image.openTab.call(this, 'init');

    if (contextImage._resizing) {
      contextImage.proportion.checked = false;
      contextImage.imageX.value = contextImage._defaultAuto ? '' : this.context.option.imageWidth;
      contextImage.imageY.value = '';
      contextImage.imageX.disabled = contextImage._defaultAuto;
      contextImage.imageY.disabled = true;
      contextImage.proportion.disabled = true;
    }
  }
});
// CONCATENATED MODULE: ./src/plugins/dialog/video.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

const video = ({
  name: 'video',
  add(core) {
    core.addModule([dialog, resizing]);
    const context = core.context;
    context.video = {
      _container: null,
      _cover: null,
      _element: null,
      _element_w: context.option.videoWidth,
      _element_h: context.option.videoHeight,
      _element_l: 0,
      _element_t: 0,
      _origin_w: context.option.videoWidth,
      _origin_h: context.option.videoHeight,
      _caption: null,
      captionCheckEl: null,
      _captionChecked: false,
      _proportionChecked: true,
      _align: 'none',
      _floatClassRegExp: '__se__float\\-[a-z]+',
      _resizing: context.option.videoResizing,
      _youtubeQuery: context.option.youtubeQuery
    };
    /** video dialog */

    let videoDialog = this.setDialog.call(core);
    context.video.modal = videoDialog;
    context.video.focusElement = videoDialog.querySelector('._se_video_url');
    context.video.captionCheckEl = videoDialog.querySelector('._se_video_check_caption');
    /** add event listeners */

    videoDialog.querySelector('.ke-btn-primary').addEventListener('click', this.submit.bind(core));
    context.video.videoWidth = {};
    context.video.videoHeight = {};

    if (context.option.videoResizing) {
      context.video.videoWidth = videoDialog.querySelector('._se_video_size_x');
      context.video.videoHeight = videoDialog.querySelector('._se_video_size_y');
      context.video.proportion = videoDialog.querySelector('._se_video_check_proportion');
      context.video.videoWidth.value = context.option.videoWidth;
      context.video.videoHeight.value = context.option.videoHeight;
      context.video.videoWidth.addEventListener('change', this.setInputSize.bind(core, 'x'));
      context.video.videoHeight.addEventListener('change', this.setInputSize.bind(core, 'y'));
      videoDialog.querySelector('.ke-dialog-btn-revert').addEventListener('click', this.sizeRevert.bind(core));
    }
    /** append html */


    context.dialog.modal.appendChild(videoDialog);
    /** empty memory */

    videoDialog = null;
  },

  /** dialog */
  setDialog() {
    const option = this.context.option;
    const lang = this.lang;
    const internalDialog = this.util.createElement('DIV');
    internalDialog.className = 'ke-dialog-content';
    internalDialog.style.display = 'none';
    // @ts-ignore
    let html = '' + '<form class="editor_video">' + '   <div class="ke-dialog-header">' + '       <button type="button" data-command="close" class="close" aria-label="Close" title="' + lang.dialogBox.close + '">' + '           <i aria-hidden="true" data-command="close" class="ke-icon-cancel"></i>' + '       </button>' + '       <span class="ke-modal-title">' + lang.dialogBox.videoBox.title + '</span>' + '   </div>' + '   <div class="ke-dialog-body">' + '       <div class="ke-dialog-form">' + '           <label>' + lang.dialogBox.videoBox.url + '</label>' + '           <input class="ke-input-form _se_video_url" type="text" />' + '       </div>';

    if (option.videoResizing) {
      // @ts-ignore
      html += '' + '   <div class="ke-dialog-form">' + '       <div class="ke-dialog-size-text"><label class="size-w">' + lang.dialogBox.width + '</label><label class="ke-dialog-size-x">&nbsp;</label><label class="size-h">' + lang.dialogBox.height + '</label></div>' + '       <input type="number" class="ke-input-control _se_video_size_x" /><label class="ke-dialog-size-x">x</label><input type="number" class="ke-input-control _se_video_size_y" />' + '       <label><input type="checkbox" class="ke-dialog-btn-check _se_video_check_proportion" checked/>&nbsp;' + lang.dialogBox.proportion + '</label>' + '       <button type="button" title="' + lang.dialogBox.revertButton + '" class="ke-btn ke-dialog-btn-revert" style="float: right;"><i class="ke-icon-revert"></i></button>' + '   </div>';
    }

    // @ts-ignore
    html += '' + '       <div class="ke-dialog-form-footer">' + '           <label><input type="checkbox" class="ke-dialog-btn-check _se_video_check_caption" />&nbsp;' + lang.dialogBox.caption + '</label>' + '       </div>' + '   </div>' + '   <div class="ke-dialog-footer">' + '       <div class="footer-div">' + '           <label><input type="radio" name="keditor_video_radio" class="ke-dialog-btn-radio" value="none" checked>' + lang.dialogBox.basic + '</label>' + '           <label><input type="radio" name="keditor_video_radio" class="ke-dialog-btn-radio" value="left">' + lang.dialogBox.left + '</label>' + '           <label><input type="radio" name="keditor_video_radio" class="ke-dialog-btn-radio" value="center">' + lang.dialogBox.center + '</label>' + '           <label><input type="radio" name="keditor_video_radio" class="ke-dialog-btn-radio" value="right">' + lang.dialogBox.right + '</label>' + '       </div>' + '       <button type="button" data-command="close" class="ke-btn-cancel" aria-label="Close" title="' + lang.dialogBox.close + '"><span data-command="close">' + lang.dialogBox.close + '</span></button>' + '       <button type="submit" class="ke-btn-primary" title="' + lang.dialogBox.submitButton + '"><span>' + lang.dialogBox.submitButton + '</span></button>' + '   </div>' + '</form>';
    internalDialog.innerHTML = html;
    return internalDialog;
  },
  setInputSize(xy) {
    if (this.context.video.proportion.checked) {
      if (xy === 'x') {
        this.context.video.videoHeight.value = Math.round(
          this.context.video._element_h / this.context.video._element_w * this.context.video.videoWidth.value
        );
      } else {
        this.context.video.videoWidth.value = Math.round(
          this.context.video._element_w / this.context.video._element_h * this.context.video.videoHeight.value
        );
      }
    }
  },
  submitAction() {
    if (this.context.video.focusElement.value.trim().length === 0) { return false; }
    const contextVideo = this.context.video;
    const w = /^\d+$/.test(contextVideo.videoWidth.value) ? contextVideo.videoWidth.value : this.context.option.videoWidth;
    const h = /^\d+$/.test(contextVideo.videoHeight.value) ? contextVideo.videoHeight.value : this.context.option.videoHeight;
    let oIframe = null;
    let cover = null;
    let container = null;
    let url = contextVideo.focusElement.value.trim();
    contextVideo._align = contextVideo.modal.querySelector('input[name="keditor_video_radio"]:checked').value;
    /** iframe source */

    if (/^<iframe.*\/iframe>$/.test(url)) {
      oIframe = new DOMParser().parseFromString(url, 'text/html').querySelector('iframe');
    } else {
        oIframe = this.util.createElement('IFRAME');
        /** youtube */

        if (/youtu\.?be/.test(url)) {
          url = url.replace('watch?v=', '');

          if (!/^\/\/.+\/embed\//.test(url)) {
            url = url.replace(url.match(/\/\/.+\//)[0], '//www.youtube.com/embed/');
          }

          if (contextVideo._youtubeQuery.length > 0) {
            if (/\?/.test(url)) {
              const splitUrl = url.split('?');
              url = splitUrl[0] + '?' + contextVideo._youtubeQuery + '&' + splitUrl[1];
            } else {
              url += '?' + contextVideo._youtubeQuery;
            }
          }
        }

        oIframe.src = url;
      }
    /** update */


    if (this.context.dialog.updateModal) {
      contextVideo._element.src = oIframe.src;
      container = contextVideo._container;
      cover = this.util.getParentElement(contextVideo._element, 'FIGURE');
      oIframe = contextVideo._element;
    } else {
        oIframe.frameBorder = '0';
        oIframe.allowFullscreen = true;

        oIframe.onload = function() {
          this.setAttribute('origin-size', this.offsetWidth + ',' + this.offsetHeight);
          this.setAttribute('data-origin', this.offsetWidth + ',' + this.offsetHeight);
          this.style.height = this.offsetHeight + 'px';
        }.bind(oIframe);

        contextVideo._element = oIframe;
        /** cover */

        cover = this.plugins.resizing.set_cover.call(this, oIframe);
        /** container */

        container = this.plugins.resizing.set_container.call(this, cover, 'ke-video-container');
        this._variable._videosCnt++;
      }

    contextVideo._cover = cover;
    contextVideo._container = container;
    const changeSize = w * 1 !== oIframe.offsetWidth || h * 1 !== oIframe.offsetHeight;

    if (contextVideo._resizing) {
      this.context.video._proportionChecked = contextVideo.proportion.checked;
      oIframe.setAttribute('data-proportion', contextVideo._proportionChecked);
    } // caption


    if (contextVideo._captionChecked) {
      if (!contextVideo._caption) {
        contextVideo._caption = this.plugins.resizing.create_caption.call(this);
        cover.appendChild(contextVideo._caption);
      }
    } else {
      if (contextVideo._caption) {
        this.util.removeItem(contextVideo._caption);
        contextVideo._caption = null;
      }
    } // size


    if (changeSize) {
      this.plugins.video.setSize.call(this, w, h);
    } // align


    if (contextVideo._align && 'none' !== contextVideo._align) {
      cover.style.margin = 'auto';
    } else {
      cover.style.margin = '0';
    }

    this.util.removeClass(container, this.context.video._floatClassRegExp);
    this.util.addClass(container, '__se__float-' + contextVideo._align);
    oIframe.setAttribute('data-align', contextVideo._align);

    if (!this.context.dialog.updateModal) {
      this.insertComponent(container);
    } else if (/\d+/.test(cover.style.height) || contextVideo._resizing && changeSize || this.context.resizing._rotateVertical && contextVideo._captionChecked) {
      this.plugins.resizing.setTransformSize.call(this, oIframe, null, null);
    } // history stack


    this.history.push();
  },
  submit(e) {
    this.showLoading();
    e.preventDefault();
    e.stopPropagation();
    this.context.video._captionChecked = this.context.video.captionCheckEl.checked;

    try {
      this.plugins.video.submitAction.call(this);
    } finally {
      this.plugins.dialog.close.call(this);
      this.closeLoading();
    }

    this.focus();
    return false;
  },
  _update_videoCover(oIframe) {
    const contextVideo = this.context.video;
    oIframe.frameBorder = '0';
    oIframe.allowFullscreen = true;

    oIframe.onload = function() {
      this.setAttribute('origin-size', this.offsetWidth + ',' + this.offsetHeight);
      this.setAttribute('data-origin', this.offsetWidth + ',' + this.offsetHeight);
      this.style.height = this.offsetHeight + 'px';
    }.bind(oIframe);

    const existElement = this.util.getParentElement(oIframe, this.util.isComponent) || this.util.getParentElement(oIframe, function(current) {
      return this.isWysiwygDiv(current.parentNode);
    }.bind(this.util));
    contextVideo._element = oIframe = oIframe.cloneNode(false);
    const cover = this.plugins.resizing.set_cover.call(this, oIframe);
    const container = this.plugins.resizing.set_container.call(this, cover, 'ke-video-container');
    const figcaption = existElement.getElementsByTagName('FIGCAPTION')[0];

    if (!!figcaption) {
      const caption = this.plugins.resizing.create_caption.call(this);
      caption.innerHTML = figcaption.innerHTML;
      cover.appendChild(caption);
    }

    const originSize = (oIframe.getAttribute('origin-size') || '').split(',');
    const w = originSize[0] || this.context.option.videoWidth;
    const h = originSize[1] || this.context.option.videoHeight;
    this.plugins.video.setSize.call(this, w, h);
    existElement.parentNode.insertBefore(container, existElement);
    this.util.removeItem(existElement);
  },
  sizeRevert() {
    const contextVideo = this.context.video;

    if (contextVideo._origin_w) {
      contextVideo.videoWidth.value = contextVideo._element_w = contextVideo._origin_w;
      contextVideo.videoHeight.value = contextVideo._element_h = contextVideo._origin_h;
    }
  },
  onModifyMode(element, size) {
    const contextVideo = this.context.video;
    contextVideo._element = element;
    contextVideo._cover = this.util.getParentElement(element, 'FIGURE');
    contextVideo._container = this.util.getParentElement(element, '.ke-video-container');
    contextVideo._caption = this.util.getChildElement(contextVideo._cover, 'FIGCAPTION');
    contextVideo._align = element.getAttribute('data-align') || 'none';
    contextVideo._element_w = size.w;
    contextVideo._element_h = size.h;
    contextVideo._element_t = size.t;
    contextVideo._element_l = size.l;

    let origin = contextVideo._element.getAttribute('data-origin');

    if (origin) {
      origin = origin.split(',');
      contextVideo._origin_w = origin[0] * 1;
      contextVideo._origin_h = origin[1] * 1;
    } else {
      contextVideo._origin_w = size.w;
      contextVideo._origin_h = size.h;

      contextVideo._element.setAttribute('data-origin', size.w + ',' + size.h);
    }
  },
  openModify(notOpen) {
    const contextVideo = this.context.video;
    contextVideo.focusElement.value = contextVideo._element.src;
    contextVideo.videoWidth.value = contextVideo._element.offsetWidth;
    contextVideo.videoHeight.value = contextVideo._element.offsetHeight;
    contextVideo._captionChecked = contextVideo.captionCheckEl.checked = !!contextVideo._caption;
    contextVideo.modal.querySelector('input[name="keditor_video_radio"][value="' + contextVideo._align + '"]').checked = true;

    if (contextVideo._resizing) {
      contextVideo.proportion.checked = contextVideo._proportionChecked = contextVideo._element.getAttribute('data-proportion') !== 'false';
      contextVideo.proportion.disabled = false;
    }

    if (!notOpen) { this.plugins.dialog.open.call(this, 'video', true); }
  },
  checkVideosInfo() {
    const videos = this.context.element.wysiwyg.getElementsByTagName('IFRAME');
    if (videos.length === this._variable._videosCnt) { return; }
    const videoPlugin = this.plugins.video;
    this._variable._videosCnt = videos.length;

    for (let i = 0, len = this._variable._videosCnt, loopVideo; i < len; i++) {
      loopVideo = videos[i];

      if (!this.util.getParentElement(loopVideo, '.ke-video-container')) {
        videoPlugin._update_videoCover.call(this, loopVideo);
      }
    }
  },
  setSize(w, h) {
    const contextVideo = this.context.video;
    contextVideo._element.style.width = /^\d+$/.test(w) ? w + 'px' : w;
    contextVideo._element.style.height = /^\d+$/.test(h) ? h + 'px' : h;
  },
  setAutoSize() {
    const contextVideo = this.context.video;
    this.plugins.resizing.resetTransform.call(this, contextVideo._element);
    this.plugins.video.cancelPercentAttr.call(this);
    const originSize = (contextVideo._element.getAttribute('data-origin') || '').split(',');
    const w = (originSize[0] || this.context.option.videoWidth) + 'px';
    const h = (originSize[1] || this.context.option.videoHeight) + 'px';
    contextVideo._element.style.maxWidth = '100%';
    contextVideo._cover.style.width = contextVideo._element.style.width = w;
    contextVideo._cover.style.height = contextVideo._element.style.height = h;
  },
  setPercentSize(w) {
    const contextVideo = this.context.video;
    contextVideo._element.style.maxWidth = '100%';
    contextVideo._container.style.width = w;
    contextVideo._container.style.height = '';
    contextVideo._cover.style.width = '100%';
    contextVideo._cover.style.height = '';
    contextVideo._element.style.width = '100%';
    contextVideo._element.style.height = contextVideo._origin_h / contextVideo._origin_w * contextVideo._element.offsetWidth + 'px';

    if (/100/.test(w)) {
      this.util.removeClass(contextVideo._container, this.context.video._floatClassRegExp);
      this.util.addClass(contextVideo._container, '__se__float-center');
    }
  },
  cancelPercentAttr() {
    const contextVideo = this.context.video;
    contextVideo._element.style.maxWidth = 'none';
    contextVideo._cover.style.width = '';
    contextVideo._cover.style.height = '';
    contextVideo._container.style.width = '';
    contextVideo._container.style.height = '';
    this.util.removeClass(contextVideo._container, this.context.video._floatClassRegExp);
    this.util.addClass(contextVideo._container, '__se__float-' + contextVideo._align);
  },
  resetAlign() {
    const contextVideo = this.context.video;

    contextVideo._element.setAttribute('data-align', '');

    contextVideo._align = 'none';
    contextVideo._cover.style.margin = '0';
    this.util.removeClass(contextVideo._container, contextVideo._floatClassRegExp);
  },
  destroy() {
    this._variable._videosCnt--;
    this.util.removeItem(this.context.video._container);
    this.plugins.video.init.call(this);
    this.controllersOff(); // history stack

    this.history.push();
  },
  init() {
    const contextVideo = this.context.video;
    contextVideo.focusElement.value = '';
    contextVideo.captionCheckEl.checked = false;
    contextVideo._origin_w = this.context.option.videoWidth;
    contextVideo._origin_h = this.context.option.videoHeight;
    contextVideo.modal.querySelector('input[name="keditor_video_radio"][value="none"]').checked = true;

    if (contextVideo._resizing) {
      contextVideo.videoWidth.value = this.context.option.videoWidth;
      contextVideo.videoHeight.value = this.context.option.videoHeight;
      contextVideo.proportion.checked = true;
      contextVideo.proportion.disabled = true;
    }
  }
});
// CONCATENATED MODULE: ./src/plugins/index.js

const srcPlugins = ({
  align: submenuAlign,
  font,
  fontSize,
  fontColor,
  hiliteColor,
  horizontalRule,
  list,
  table,
  formatBlock,
  template,
  link: dialogLinkPlugin,
  image: dialogImagePlugin,
  video
});
// EXTERNAL MODULE: ./src/lang/en.js

const en = {
  toolbar: {
    default: 'Default',
    save: 'Save',
    font: 'Font',
    formats: 'Formats',
    fontSize: 'Size',
    bold: 'Bold',
    underline: 'Underline',
    italic: 'Italic',
    strike: 'Strike',
    subscript: 'Subscript',
    superscript: 'Superscript',
    removeFormat: 'Remove Format',
    fontColor: 'Font Color',
    hiliteColor: 'Highlight Color',
    indent: 'Indent',
    outdent: 'Outdent',
    align: 'Align',
    alignLeft: 'Align left',
    alignRight: 'Align right',
    alignCenter: 'Align center',
    alignJustify: 'Align justify',
    list: 'List',
    orderList: 'Ordered list',
    unorderList: 'Unordered list',
    horizontalRule: 'Horizontal line',
    hr_solid: 'solid',
    hr_dotted: 'dotted',
    hr_dashed: 'dashed',
    table: 'Table',
    link: 'Link',
    image: 'Image',
    video: 'Video',
    fullScreen: 'Full screen',
    showBlocks: 'Show blocks',
    codeView: 'Code view',
    undo: 'Undo',
    redo: 'Redo',
    preview: 'Preview',
    print: 'print',
    tag_p: 'Paragraph',
    tag_div: 'Normal (DIV)',
    tag_h: 'Header',
    tag_blockquote: 'Quote',
    tag_pre: 'Code',
    template: 'Template'
  },
  dialogBox: {
    linkBox: {
      title: 'Insert Link',
      url: 'URL to link',
      text: 'Text to display',
      newWindowCheck: 'Open in new window'
    },
    imageBox: {
      title: 'Insert image',
      file: 'Select from files',
      url: 'Image URL',
      altText: 'Alternative text'
    },
    videoBox: {
      title: 'Insert Video',
      url: 'Media embed URL, YouTube'
    },
    caption: 'Insert description',
    close: 'Close',
    submitButton: 'Submit',
    revertButton: 'Revert',
    proportion: 'constrain proportions',
    width: 'Width',
    height: 'Height',
    basic: 'Basic',
    left: 'Left',
    right: 'Right',
    center: 'Center'
  },
  controller: {
    edit: 'Edit',
    remove: 'Remove',
    insertRowAbove: 'Insert row above',
    insertRowBelow: 'Insert row below',
    deleteRow: 'Delete row',
    insertColumnBefore: 'Insert column before',
    insertColumnAfter: 'Insert column after',
    deleteColumn: 'Delete column',
    resize100: 'Resize 100%',
    resize75: 'Resize 75%',
    resize50: 'Resize 50%',
    resize25: 'Resize 25%',
    mirrorHorizontal: 'Mirror, Horizontal',
    mirrorVertical: 'Mirror, Vertical',
    rotateLeft: 'Rotate left',
    rotateRight: 'Rotate right',
    maxSize: 'Max size',
    minSize: 'Min size',
    tableHeader: 'Table header',
    mergeCells: 'Merge cells',
    splitCells: 'Split Cells',
    HorizontalSplit: 'Horizontal split',
    VerticalSplit: 'Vertical split'
  }
};

// CONCATENATED MODULE: ./src/lib/util.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

/**
 * @description utility function
 */

const utilFunctions = {
  _d: document,
  _w: window,
  _onlyZeroWidthRegExp: new RegExp('^' + String.fromCharCode(8203) + '+$'),

  /**
   * @description Removes attribute values such as style and converts tags that do not conform to the "html5" standard.
   */
  _tagConvertor(text: string) {
    const ec = {
      b: 'strong',
      i: 'em',
      var: 'em',
      u: 'ins',
      strike: 'del',
      s: 'del'
    };
    return text.replace(
      /(<\/?)(b|strong|var|i|em|u|ins|s|strike|del)\b\s*(?:[^>^<]+)?\s*(?=>)/ig,
      (m, t, n) => t + (typeof ec[n] === 'string' ? ec[n] : n)
    );
  },

  /**
   * @description Unicode Character 'ZERO WIDTH SPACE'
   */
  zeroWidthSpace: '\u200B',

  /**
   * @description A method that checks If the text is blank or to see if it contains only Unicode 'ZERO WIDTH SPACE' (\u200B)
   * @param text String value or Node
   */
  onlyZeroWidthSpace(text: string | HTMLElement) {
    if (typeof text !== 'string') { text = text.textContent; }
    return text === '' || this._onlyZeroWidthRegExp.test(text);
  },

  /**
   * @description Gets XMLHttpRequest object
   */
  getXMLHttpRequest() {
    try {
      return new XMLHttpRequest();
    } catch(err) {
      alert('Browser does not support XMLHttpRequest!');
    }
  },

  /**
   * @description Create Element node
   * @param elementName Element name
   */
  createElement(elementName: string) {
    return document.createElement(elementName);
  },

  /**
   * @description Create text node
   * @param text text contents
   */
  createTextNode(text: string) {
    return document.createTextNode(text || '');
  },

  /**
   * @description Get the the tag path of the arguments value
   * If not found, return the first found value
   * @param nameArray File name array
   * @param extension js, css
   */
  getIncludePath(nameArray: string[], extension: string) {
    let path = '';
    const pathList = [];
    const tagName = extension === 'js' ? 'script' : 'link';
    const src = extension === 'js' ? 'src' : 'href';
    let fileName = '(?:';

    for (let i = 0, len = nameArray.length; i < len; i++) {
      fileName += nameArray[i] + (i < len - 1 ? '|' : ')');
    }

    const regExp = new RegExp('(^|.*[\\/])' + fileName + '(\\.[^\\/]+)?\.' + extension + '(?:\\?.*|;.*)?$', 'i');
    const extRegExp = new RegExp('.+\\.' + extension + '(?:\\?.*|;.*)?$', 'i');

    for (let c = document.getElementsByTagName(tagName), i = 0; i < c.length; i++) {
      if (extRegExp.test(c[i][src])) {
        pathList.push(c[i]);
      }
    }

    // for (let i = 0; i < pathList.length; i++) {
    for (const pathElement of pathList) {
      const editorTag = pathElement[src].match(regExp);

      if (editorTag) {
        path = editorTag[0];
        break;
      }
    }

    if (path === '') {
      path = pathList.length > 0 ? pathList[0][src] : '';
    }

    // Bug fix
    if (-1 === path.indexOf(':/') && '//' !== path.slice(0, 2)) {
      path = (0 === path.indexOf('/')) ? (location.href.match(/^.*?:\/\/[^\/]*/)[0] + path) : (location.href.match(/^[^\?]*\/(?:)/)[0] + path);
    }

    if (!path) {
      throw new Error(
        '[KEDITOR.util.getIncludePath.fail] The KEDITOR installation path could not be automatically detected.' +
        '(name: +' + name + ', extension: ' + extension + ')'
        );
    }
    return path;
  },

  /**
   * @description Returns the CSS text that has been applied to the current page.
   */
  getPageStyle() {
    let cssText = '';
    const sheets = document.styleSheets;

    for (let i = 0, len = sheets.length, rules; i < len; i++) {
      try {
        // @ts-ignore
        rules = sheets[i].cssRules;
      } catch(e) {
        continue;
      }

      for (let c = 0, cLen = rules.length; c < cLen; c++) {
        cssText += rules[c].cssText;
      }
    }

    return cssText;
  },

  /**
   * @description Converts contents into a format that can be placed in an editor
   * @param contents contents
   */
  convertContentsForEditor(contents: string) {
    let tag;
    let baseHtml = '';
    let innerHTML = '';
    contents = contents.trim();
    tag = document.createRange().createContextualFragment(contents).childNodes;

    for (let i = 0, len = tag.length; i < len; i++) {
      baseHtml = tag[i].outerHTML || tag[i].textContent;

      if (tag[i].nodeType === 3) {
        const textArray = baseHtml.split(/\n/g);
        let text = '';

        for (let t = 0, tLen = textArray.length; t < tLen; t++) {
          text = textArray[t].trim();
          if (text.length > 0) { innerHTML += '<P>' + text + '</p>'; }
        }
      } else {
        innerHTML += baseHtml;
      }
    }

    const ec = {
      '&': '&amp;',
      '\u00A0': '&nbsp;',
      '\'': '&quot;',
      '<': '&amp;lt;',
      '>': '&amp;gt;'
    };
    contents = contents.replace(/&|\u00A0|'|<|>/g, (m) => typeof ec[m] === 'string' ? ec[m] : m);
    if (innerHTML.length === 0) { innerHTML = '<p>' + (contents.length > 0 ? contents : '<br>') + '</p>'; }
    return this._tagConvertor(innerHTML.replace(this._deleteExclusionTags, ''));
  },

  /**
   * @description Converts wysiwyg area element into a format that can be placed in an editor of code view mode
   * @param wysiwygDiv WYSIWYG element (context.element.wysiwyg)
   */
  convertHTMLForCodeView(wysiwygDiv) {
    let html = '';
    const reg = RegExp;

    (function recursionFunc(element) {
      const children = element.childNodes;

      for (let i = 0, len = children.length, node; i < len; i++) {
        node = children[i];

        if (/^(BLOCKQUOTE|TABLE|THEAD|TBODY|TR|OL|UL|FIGCAPTION)$/i.test(node.nodeName)) {
          node.innerHTML = node.innerHTML.replace(/\n/g, '');
          const tag = node.nodeName.toLowerCase();
          html += node.outerHTML.match(reg('<' + tag + '[^>]*>', 'i'))[0] + '\n';
          recursionFunc(node);
          html += '</' + tag + '>\n';
        } else {
          html += node.nodeType === 3 ? /^\n+$/.test(node.data) ? '' : node.data : node.outerHTML + '\n';
        }
      }
    })(wysiwygDiv);

    return html;
  },

  /**
   * @description It is judged whether it is the edit region top div element or iframe's body tag.
   * @param element The element to check
   */
  isWysiwygDiv(element) {
    if (element && element.nodeType === 1 && (this.hasClass(element, 'ke-wrapper-wysiwyg') || /^BODY$/i.test(element.nodeName))) {
      return true;
    }
    return false;
  },

  /**
   * @description It is judged whether it is the format element (P, DIV, H1-6, LI, TH, TD)
   * @param element The element to check
   */
  isFormatElement(element) {
    return (
      element &&
      element.nodeType === 1 &&
      /^(P|DIV|H[1-6]|LI|TH|TD)$/i.test(element.nodeName) &&
      !this.isComponent(element) &&
      !this.isWysiwygDiv(element)
    );
  },

  /**
   * @description It is judged whether it is the range format element.
   * (BLOCKQUOTE, OL, UL, PRE, FIGCAPTION, TABLE, THEAD, TBODY, TR, TH, TD)
   * * Range format element is wrap the format element  (P, DIV, H1-6, LI)
   * @param element The element to check
   */
  isRangeFormatElement(element) {
    return (
      element &&
      element.nodeType === 1 &&
      (
        /^(BLOCKQUOTE|OL|UL|PRE|FIGCAPTION|TABLE|THEAD|TBODY|TR|TH|TD)$/i.test(element.nodeName) ||
        element.getAttribute('data-format') === 'range'
      )
    );
  },

  /**
   * @description It is judged whether it is the component(img, iframe cover, table, hr) element - ".ke-component"
   * @param element The element to check
   */
  isComponent(element) {
    return element && (/ke-component/.test(element.className) || /^(TABLE|HR)$/.test(element.nodeName));
  },

  /**
   * @description If a parent node that contains an argument node finds a format node (P, DIV, H[1-6], LI), it returns that node.
   * @param element Reference element if null or no value, it is relative to the current focus node.
   * @param validation Additional validation function.
   */
  getFormatElement(element, validation: (elem: any) => boolean = null) {
    if (!element) { return null; }

    if (!validation) {
      validation = () => true;
    }

    while (element) {
      if (this.isWysiwygDiv(element)) {
        return null;
      }
      if (this.isRangeFormatElement(element)) {
        return element.firstElementChild;
      }
      if (this.isFormatElement(element) && validation(element)) {
        return element;
      }
      element = element.parentNode;
    }

    return null;
  },

  /**
   * @description If a parent node that contains an argument node finds a format node (BLOCKQUOTE, TABLE, TH, TD, OL, UL, PRE), it returns that node.
   * @param element Reference element if null or no value, it is relative to the current focus node.
   * @param validation Additional validation function.
   * @returns An element on success, null if it does not find the node
   */
  getRangeFormatElement(element: any, validation: (elem: any) => boolean = null) {
    if (!element) { return null; }

    if (!validation) {
      validation = function() {
        return true;
      };
    }

    while (element) {
      if (this.isWysiwygDiv(element)) { return null; }
      if (this.isRangeFormatElement(element) && !/^(THEAD|TBODY|TR)$/i.test(element.nodeName) && validation(element)) { return element; }
      element = element.parentNode;
    }

    return null;
  },

  /**
   * @description Get the index of the argument value in the element array
   * @param array element array
   * @param element The element to find index
   */
  getArrayIndex(array: any[], element: any) {
    let idx = -1;

    for (let i = 0, len = array.length; i < len; i++) {
      if (array[i] === element) {
        idx = i;
        break;
      }
    }

    return idx;
  },

  /**
   * @description Get the next index of the argument value in the element array
   * @param array element array
   * @param item The element to find index
   */
  nextIdx(array: any[], item: any) {
    const idx = this.getArrayIndex(array, item);
    if (idx === -1) { return -1; }
    return idx + 1;
  },

  /**
   * @description Get the previous index of the argument value in the element array
   * @param array Element array
   * @param item The element to find index
   */
  prevIdx(array, item) {
    const idx = this.getArrayIndex(array, item);
    if (idx === -1) { return -1; }
    return idx - 1;
  },

  /**
   * @description Returns the index compared to other sibling nodes.
   * @param node The Node to find index
   */
  getPositionIndex(node: any) {
    let idx = 0;

    node = node.previousSibling;

    while (node) {
      idx += 1;
      node = node.previousSibling;
    }

    return idx;
  },

  /**
   * @description Returns the position of the "node" in the "parentNode" in a numerical array.
   * ex) <p><span>aa</span><span>bb</span></p> - (node: "bb", parentNode: "<P>") -> [1, 0]
   * @param node The Node to find position path
   * @param parentNode Parent node. If null, wysiwyg div area
   */
  getNodePath(node: any, parentNode = null): any[] {
    const path: HTMLElement[] = [];
    let finds = true;
    this.getParentElement(node, function(el) {
      if (el === parentNode) { finds = false; }
      if (finds && !this.isWysiwygDiv(el)) { path.push(el); }
      return false;
    }.bind(this));
    return path.map(this.getPositionIndex).reverse();
  },

  /**
   * @description Returns the node in the location of the path array obtained from "util.getNodePath".
   * @param offsets Position array, array obtained from "util.getNodePath"
   * @param parentNode Base parent element
   */
  getNodeFromPath(offsets: any[], parentNode) {
    let current = parentNode;
    let nodes;

    for (let i = 0, len = offsets.length; i < len; i++) {
      nodes = current.childNodes;
      if (nodes.length === 0) {
        break;
      }
      if (nodes.length <= offsets[i]) {
        current = nodes[nodes.length - 1];
      } else {
        current = nodes[offsets[i]];
      }
    }

    return current;
  },

  /**
   * @description Check the node is a list (ol, ul)
   * @param node The element or element name to check
   * @returns True if the input is a list
   */
  isList(node: HTMLElement | string) {
    return node && /^(OL|UL)$/i.test(typeof node === 'string' ? node : node.nodeName);
  },

  /**
   * @description Check the node is a list cell (li)
   * @param node The element or element name to check
   * @returns True if the input is a list cell
   */
  isListCell(node: HTMLElement | string) {
    return node && /^LI$/i.test(typeof node === 'string' ? node : node.nodeName);
  },

  /**
   * @description Check the node is a table (table, thead, tbody, tr, th, td)
   * @param node The element or element name to check
   * @returns True if the node is a table
   */
  isTable(node: HTMLElement | string) {
    return node && /^(TABLE|THEAD|TBODY|TR|TH|TD)$/i.test(typeof node === 'string' ? node : node.nodeName);
  },

  /**
   * @description Check the node is a table cell (td, th)
   * @param node The element or element name to check
   * @returns True if the node is a table cell
   */
  isCell(node: HTMLElement | string) {
    return node && /^(TD|TH)$/i.test(typeof node === 'string' ? node : node.nodeName);
  },

  /**
   * @description Check the node is a break node (BR)
   * @param node The element or element name to check
   * @returns True if the node is a break node
   */
  isBreak(node: HTMLElement | string) {
    return node && /^BR$/i.test(typeof node === 'string' ? node : node.nodeName);
  },

  /**
   * @description Get all child nodes of the argument value element (Without text node)
   * @param element element to get child node
   * @param validation Conditional function
   * @returns Native array of child nodes
   */
  getListChildren(element: any, validation: (elem: any) => boolean = null) {
    const children = [];
    if (!element || !element.children || element.children.length === 0) { return children; }

    validation = validation || ((elem: any) => true);

    (function recursionFunc(current) {
      if (element !== current && validation(current) || /^BR$/i.test(element.nodeName)) {
        children.push(current);
      }

      for (let i = 0, len = current.children.length; i < len; i++) {
        recursionFunc(current.children[i]);
      }
    })(element);

    return children;
  },

  /**
   * @description Get all child nodes of the argument value element (Include text nodes)
   * @param element element to get child node
   * @param validation Conditional function
   * @returns Native array of children
   */
  getListChildNodes(element: any, validation: (elem: any) => boolean = null) {
    const children = [];
    if (!element || element.childNodes.length === 0) { return children; }

    validation = validation || ((elem: any) => true);

    (function recursionFunc(current) {
      if (element !== current && validation(current) || /^BR$/i.test(element.nodeName)) {
        children.push(current);
      }

      for (let i = 0, len = current.childNodes.length; i < len; i++) {
        recursionFunc(current.childNodes[i]);
      }
    })(element);

    return children;
  },

  /**
   * @description Returns the number of parents nodes, 0 when the parent node is the WYSIWYG area.
   * @param element The element to check
   * @returns The number of parents nodes
   */
  getElementDepth(element: any): number {
    let depth = 0;
    element = element.parentNode;

    while (element && !this.isWysiwygDiv(element)) {
      depth += 1;
      element = element.parentNode;
    }

    return depth;
  },

  /**
   * @description Get the parent element of the argument value.
   * A tag that satisfies the query condition is imported.
   * Returns null if not found.
   * @param element Reference element
   * @param query Query String (nodeName, .className, #ID, :name) or validation function.
   * Not use it like jquery.
   * Only one condition can be entered at a time.
   */
  getParentElement(element: any, query: ((elem: any) => boolean) | string = null): HTMLElement | null {
    let check;

    if (typeof query === 'function') {
      check = query;
    } else {
      let attr;

      if (/^\./.test(query)) {
        attr = 'className';
        query = query.split('.')[1];
      } else if (/^#/.test(query)) {
        attr = 'id';
        query = '^' + query.split('#')[1] + '$';
      } else if (/^:/.test(query)) {
        attr = 'name';
        query = '^' + query.split(':')[1] + '$';
      } else {
        attr = 'nodeName';
        query = '^' + query + '$';
      }

      const regExp = new RegExp(query, 'i');

      check = function(el) {
        return regExp.test(el[attr]);
      };
    }

    while (element && !check(element)) {
      if (this.isWysiwygDiv(element)) {
        return null;
      }

      element = element.parentNode;
    }

    return element;
  },

  /**
   * @description Get the child element of the argument value.
   * A tag that satisfies the query condition is imported.
   * Returns null if not found.
   * @param element Reference element
   * @param query Query String (nodeName, .className, #ID, :name) or validation function.
   * @param last If true returns the last node among the found child nodes. (default: first node)
   * Not use it like jquery.
   * Only one condition can be entered at a time.
   */
  getChildElement(element: any, query: ((elem: any) => boolean) | string, last = false) {
    let check;

    if (typeof query === 'function') {
      check = query;
    } else {
      let attr;

      if (/^\./.test(query)) {
        attr = 'className';
        query = query.split('.')[1];
      } else if (/^#/.test(query)) {
        attr = 'id';
        query = '^' + query.split('#')[1] + '$';
      } else if (/^:/.test(query)) {
        attr = 'name';
        query = '^' + query.split(':')[1] + '$';
      } else {
        attr = 'nodeName';
        query = '^' + query + '$';
      }

      const regExp = new RegExp(query, 'i');

      check = (el) => regExp.test(el[attr]);
    }

    const childList = this.getListChildNodes(element, (current) => check(current));
    return childList[last ? childList.length - 1 : 0];
  },

  /**
   * @description 1. The first node of all the child nodes of the "first" element is returned.
   * 2. The last node of all the child nodes of the "last" element is returned.
   * 3. When there is no "last" element, the first and last nodes of all the children of the "first" element are returned.
   * { sc: "first", ec: "last" }
   * @param first First element
   * @param last Last element
   */
  getEdgeChildNodes(first: any, last: any = null) {
    if (!first) { return; }
    if (!last) { last = first; }

    while (first && first.nodeType === 1 && first.childNodes.length > 0 && !this.isBreak(first)) { first = first.firstChild; }

    while (last && last.nodeType === 1 && last.childNodes.length > 0 && !this.isBreak(last)) { last = last.lastChild; }

    return {
      sc: first,
      ec: last || first
    };
  },

  /**
   * @description Returns the position of the left and top of argument. {left:0, top:0}
   * @param element Element node
   * @param wysiwygFrame When use iframe option, iframe object should be sent (context.element.wysiwygFrame)
   */
  getOffset(element: any, wysiwygFrame = null) {
    let offsetLeft = 0;
    let offsetTop = 0;
    let offsetElement = element.nodeType === 3 ? element.parentElement : element;
    const wysiwyg = this.getParentElement(element, this.isWysiwygDiv.bind(this));

    while (offsetElement && !this.hasClass(offsetElement, 'ke-container') && offsetElement !== wysiwyg) {
      offsetLeft += offsetElement.offsetLeft;
      offsetTop += offsetElement.offsetTop;
      offsetElement = offsetElement.offsetParent;
    }

    const iframe = wysiwygFrame && /iframe/i.test(wysiwygFrame.nodeName);
    return {
      left: offsetLeft + (iframe ? wysiwygFrame.offsetLeft : 0),
      top: offsetTop - wysiwyg.scrollTop + (iframe ? wysiwygFrame.offsetTop : 0)
    };
  },

  /**
   * @description It compares the start and end indexes of "a" and "b" and returns the number of overlapping indexes in the range.
   * ex) 1, 5, 4, 6 => 2 (4 ~ 5)
   * @param aStart Start index of "a"
   * @param aEnd End index of "a"
   * @param bStart Start index of "b"
   * @param bEnd Start index of "b"
   */
  getOverlapRangeAtIndex(aStart: number, aEnd: number, bStart: number, bEnd: number) {
    if (aStart <= bEnd ? aEnd < bStart : aEnd > bStart) { return 0; }
    const overlap = (aStart > bStart ? aStart : bStart) - (aEnd < bEnd ? aEnd : bEnd);
    return (overlap < 0 ? overlap * -1 : overlap) + 1;
  },

  /**
   * @description Set the text content value of the argument value element
   * @param element Element to replace text content
   * @param txt Text to be applied
   */
  changeTxt(element: any, txt: string) {
    if (!element || !txt) { return; }
    element.textContent = txt;
  },

  /**
   * @description Determine whether any of the matched elements are assigned the given class
   * @param element Elements to search class name
   * @param className Class name to search for
   */
  hasClass(element: any, className: string) {
    if (!element) { return; }
    return element.classList.contains(className.trim());
  },

  /**
   * @description Append the className value of the argument value element
   * @param element Elements to add class name
   * @param className Class name to be add
   */
  addClass(element: any, className: string) {
    if (!element) { return; }
    const check = new RegExp('(\\s|^)' + className + '(\\s|$)');
    if (check.test(element.className)) { return; }
    element.className += ' ' + className;
  },

  /**
   * @description Delete the className value of the argument value element
   * @param element Elements to remove class name
   * @param className Class name to be remove
   */
  removeClass(element: any, className: string) {
    if (!element) { return; }
    const check = new RegExp('(\\s|^)' + className + '(\\s|$)');
    element.className = element.className.replace(check, ' ').trim();
  },

  /**
   * @description Argument value If there is no class name, insert it and delete the class name if it exists
   * @param element Elements to replace class name
   * @param className Class name to be change
   */
  toggleClass(element: any, className: string) {
    if (!element) { return; }
    const check = new RegExp('(\\s|^)' + className + '(\\s|$)');

    if (check.test(element.className)) {
      element.className = element.className.replace(check, ' ').trim();
    } else {
      element.className += ' ' + className;
    }
  },

  /**
   * @description Delete argumenu value element
   * @param item Element to be remove
   */
  removeItem(item: any) {
    if (!item) { return; }

    try {
      item.remove();
    } catch(e) {
      item.parentNode.removeChild(item);
    }
  },

  /**
   * @description Delete all parent nodes that match the condition.
   * Returns an {sc: previousSibling, ec: nextSibling}(the deleted node reference) or null.
   * @param item Element to be remove
   * @param validation Validation function. default(Deleted if it only have breakLine and blanks)
   */
  removeItemAllParents(item: any, validation: (elem: any) => boolean = null): {sc: any, ec: any} | null {
    if (!item) { return null; }
    let cc = null;

    if (!validation) {
      validation = (current) => {
        const text = current.textContent.trim();
        return text.length === 0 || /^(\n|\u200B)+$/.test(text);
      };
    }

    (function recursionFunc(element) {
      if (!utilFunctions.isWysiwygDiv(element)) {
        const parent = element.parentNode;

        if (parent && validation(element)) {
          cc = {
            sc: element.previousElementSibling,
            ec: element.nextElementSibling
          };
          utilFunctions.removeItem(element);
          recursionFunc(parent);
        }
      }
    })(item);

    return cc;
  },

  /**
   * @description Delete a empty child node of argument element
   * @param element Element node
   */
  removeEmptyNode(element: any) {
    const inst = this;

    (function recursionFunc(current) {
      if (
        current !== element &&
        inst.onlyZeroWidthSpace(current.textContent) &&
        !/^BR$/i.test(current.nodeName) &&
        (!current.firstChild || !/^BR$/i.test(current.firstChild.nodeName)) &&
        !inst.isComponent(current)
      ) {
        if (current.parentNode) {
          current.parentNode.removeChild(current);
          return -1;
        }
      } else {
        const children = current.children;

        for (let i = 0, len = children.length, r = 0; i < len; i++) {
          if (!children[i + r] || inst.isComponent(children[i + r])) { continue; }
          r += recursionFunc(children[i + r]);
        }
      }

      return 0;
    })(element);

    if (element.childNodes.length === 0) { element.innerHTML = '<br>'; }
  },

  /**
   * @description Nodes that need to be added without modification when changing text nodes !(span|font|b|strong|var|i|em|u|ins|s|strike|del|sub|sup)
   * @param element Element to check
   */
  isIgnoreNodeChange(element) {
    return element.nodeType !== 3 && !/^(span|font|b|strong|var|i|em|u|ins|s|strike|del|sub|sup|mark)$/i.test(element.nodeName);
  },

  /**
   * @description Gets the clean HTML code for editor
   * @param html HTML string
   */
  cleanHTML(html: string): string {
    const tagsAllowed = new RegExp('^(meta|script|link|style|[a-z]+\:[a-z]+)$', 'i');

    const domTree: any = document.createRange().createContextualFragment(html).childNodes;

    let cleanHTML = '';

    for (let i = 0, len = domTree.length; i < len; i++) {
      if (!tagsAllowed.test(domTree[i].nodeName)) {
        cleanHTML += domTree[i].nodeType === 1 ? domTree[i].outerHTML : domTree[i].nodeType === 3 ? domTree[i].textContent : '';
      }
    }

    cleanHTML = cleanHTML.replace(/<([a-zA-Z]+\:[a-zA-Z]+|script|style).*>(\n|.)*<\/([a-zA-Z]+\:[a-zA-Z]+|script|style)>/g, '').replace(/(<[a-zA-Z0-9]+)[^>]*(?=>)/g, (m, t) => {
      const v = m.match(/((?:colspan|rowspan|target|href|src|class|data-file-size|data-file-name|data-origin|origin-size|data-format)\s*=\s*"[^"]*")/ig);

      if (v) {
        for (let i = 0, len = v.length; i < len; i++) {
          if (/^class="(?!__se__)/.test(v[i])) { continue; }
          t += ' ' + v[i];
        }
      }

      return t;
    }).replace(/<\/?(span[^>^<]*)>/g, '').replace(this._deleteExclusionTags, '');
    return this._tagConvertor(cleanHTML || html);
  },

  /**
   * @description Delete Exclusion tags regexp object
   */
  _deleteExclusionTags: (() => {
    const exclusionTags = 'br|p|div|pre|blockquote|h[1-6]|ol|ul|dl|li|hr|figure|figcaption|img|iframe|audio|video|table|thead|tbody|tr|th|td|a|b|strong|var|i|em|u|ins|s|span|strike|del|sub|sup|mark'.split('|');
    let regStr = '<\\/?(';

    for (let i = 0, len = exclusionTags.length; i < len; i++) {
      regStr += '(?!\\b' + exclusionTags[i] + '\\b)';
    }

    regStr += '[^>^<])+>';
    return new RegExp(regStr, 'g');
  })()
};
// CONCATENATED MODULE: ./src/lib/constructor.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */
const libConstructor = ({
  /**
   * @description document create - call _createToolBar()
   * @param element Textarea
   * @param options Options
   */
  init(element: any, options = null): any {
    if (typeof options !== 'object') { options = {}; }
    /** --- init options --- */
    this._initOptions(element, options);
    // keditor div
    const topDiv = document.createElement('DIV');
    topDiv.className = 'keditor';
    if (element.id) {
      topDiv.id = 'keditor_' + element.id;
    }
    // relative div
    const relative = document.createElement('DIV');
    relative.className = 'ke-container'; // toolbar

    if (!options.lang) {
      options.lang = en;
    }
    const toolBar = this._createToolBar(document, options.buttonList, options.plugins, options.lang);

    const arrow = document.createElement('DIV');
    arrow.className = 'ke-arrow';
    // sticky toolbar dummy
    const stickyDummy = document.createElement('DIV');
    stickyDummy.className = 'ke-toolbar-sticky-dummy';
    // inner editor div
    const editorDiv = document.createElement('DIV');
    editorDiv.className = 'ke-wrapper';
    /** --- init elements and create bottom bar --- */

    const initHTML = utilFunctions.convertContentsForEditor(element.value);

    const initElements = this._initElements(options, topDiv, toolBar.element, arrow, initHTML);

    const bottomBar = initElements.bottomBar;
    const wysiwygDiv = initElements.wysiwygFrame;
    let textarea = initElements.codeView;
    // resizing bar
    const resizingBar = bottomBar.resizingBar;
    const navigation = bottomBar.navigation;
    const charCounter = bottomBar.charCounter;

    const loadingBox = document.createElement('DIV');
    loadingBox.className = 'ke-loading-box keditor-common';
    loadingBox.innerHTML = '<div class="ke-loading-effect"></div>'; // resize operation background

    const resizeBack = document.createElement('DIV');
    resizeBack.className = 'ke-resizing-back';
    /** append html */
    editorDiv.appendChild(wysiwygDiv);
    editorDiv.appendChild(textarea);
    relative.appendChild(toolBar.element);
    relative.appendChild(stickyDummy);
    relative.appendChild(editorDiv);
    relative.appendChild(resizeBack);
    relative.appendChild(loadingBox);
    if (resizingBar) { relative.appendChild(resizingBar); }
    topDiv.appendChild(relative);
    textarea = this._checkCodeMirror(options, textarea);
    return {
      constructed: {
        _top: topDiv,
        _relative: relative,
        _toolBar: toolBar.element,
        _editorArea: editorDiv,
        _wysiwygArea: wysiwygDiv,
        _codeArea: textarea,
        _resizingBar: resizingBar,
        _navigation: navigation,
        _charCounter: charCounter,
        _loading: loadingBox,
        _resizeBack: resizeBack,
        _stickyDummy: stickyDummy,
        _arrow: arrow
      },
      options,
      plugins: toolBar.plugins,
      pluginCallButtons: toolBar.pluginCallButtons
    };
  },

  /**
   * @description Check the CodeMirror option to apply the CodeMirror and return the CodeMirror element.
   * @param options options
   * @param textarea textarea element
   * @returns The textarea that was passed as argument
   */
  _checkCodeMirror(options: any, textarea: any) {
    if (options.codeMirror) {
      const cmOptions = [{
        mode: 'htmlmixed',
        htmlMode: true,
        lineNumbers: true
      }, options.codeMirror.options || {}].reduce((init, option) => {
        Object.keys(option).forEach((key) => {
          init[key] = option[key];
        });
        return init;
      }, {});

      if (options.height === 'auto') {
        cmOptions.viewportMargin = Infinity;
      }

      const cm = options.codeMirror.src.fromTextArea(textarea, cmOptions);
      cm.display.wrapper.style.cssText = textarea.style.cssText;
      options.codeMirrorEditor = cm;
      textarea = cm.display.wrapper;
      textarea.className += ' ke-wrapper-code-mirror';
    }

    return textarea;
  },

  /**
   * @description Add or reset options
   * @param mergeOptions New options property
   * @param context Context object of core
   * @param plugins Origin plugins
   * @param originOptions Origin options
   * @returns pluginCallButtons
   */
  _setOptions(mergeOptions: any, context: any, plugins: any, originOptions: any) {
    this._initOptions(context.element.originElement, mergeOptions);

    const el = context.element;
    const relative = el.relative;
    const editorArea = el.editorArea;
    const isNewToolbar = !!mergeOptions.buttonList || mergeOptions.mode !== originOptions.mode;
    const isNewPlugins = !!mergeOptions.plugins;

    const toolBar = this._createToolBar(document, isNewToolbar ? mergeOptions.buttonList : originOptions.buttonList, isNewPlugins ? mergeOptions.plugins : plugins, mergeOptions.lang);

    const arrow = document.createElement('DIV');
    arrow.className = 'ke-arrow';

    if (isNewToolbar) {
      relative.insertBefore(toolBar.element, el.toolbar);
      relative.removeChild(el.toolbar);
      el.toolbar = toolBar.element;
      el._arrow = arrow;
    }

    const initElements = this._initElements(mergeOptions, el.topArea, isNewToolbar ? toolBar.element : el.toolbar, arrow, el.wysiwyg.innerHTML);

    const bottomBar = initElements.bottomBar;
    const wysiwygFrame = initElements.wysiwygFrame;
    let code = initElements.codeView;
    if (el.resizingBar) { relative.removeChild(el.resizingBar); }
    if (bottomBar.resizingBar) { relative.appendChild(bottomBar.resizingBar); }
    el.resizingBar = bottomBar.resizingBar;
    el.navigation = bottomBar.navigation;
    el.charCounter = bottomBar.charCounter;
    el.poweredBy = bottomBar.poweredBy;
    editorArea.removeChild(el.wysiwygFrame);
    editorArea.removeChild(el.code);
    editorArea.appendChild(wysiwygFrame);
    editorArea.appendChild(code);
    code = this._checkCodeMirror(mergeOptions, code);
    el.wysiwygFrame = wysiwygFrame;
    el.code = code;
    return {
      callButtons: isNewToolbar ? toolBar.pluginCallButtons : null,
      plugins: isNewToolbar || isNewPlugins ? toolBar.plugins : null
    };
  },

  /**
   * @description Initialize property of keditor elements
   * @param options Options
   * @param topDiv KothingEditor top div
   * @param toolBar Tool bar
   * @param toolBarArrow Tool bar arrow (balloon editor)
   * @param initValue Code view textarea
   * @returns Bottom bar elements (resizingBar, navigation, charCounter)
   */
  _initElements(options: any, topDiv: any, toolBar: any, toolBarArrow: any, initHTML: string) {
    /** top div */
    topDiv.style.width = options.width;
    topDiv.style.minWidth = options.minWidth;
    topDiv.style.maxWidth = options.maxWidth;
    topDiv.style.display = options.display;
    if (typeof options.position === 'string') { topDiv.style.position = options.position; }
    /** toolbar */

    if (/inline/i.test(options.mode)) {
      toolBar.className += ' ke-toolbar-inline';
      toolBar.style.width = options.toolbarWidth;
    } else if (/balloon/i.test(options.mode)) {
      toolBar.className += ' ke-toolbar-balloon';
      toolBar.appendChild(toolBarArrow);
    }
    /** editor */
    // wysiwyg div or iframe

    const wysiwygDiv = document.createElement(!options.iframe ? 'DIV' : 'IFRAME') as any;
    wysiwygDiv.className = 'ke-wrapper-inner ke-wrapper-wysiwyg';
    wysiwygDiv.style.display = 'block';

    if (!options.iframe) {
      wysiwygDiv.setAttribute('contenteditable', 'true');
      wysiwygDiv.setAttribute('scrolling', 'auto');
      wysiwygDiv.className += ' keditor-editable';
      wysiwygDiv.innerHTML = initHTML;
    } else {
      const cssTags = (() => {
        const CSSFileName = new RegExp('(^|.*[\\/])' + (options.iframeCSSFileName || 'keditor') + '(\\..+)?\.css(?:\\?.*|;.*)?$', 'i');
        const path = [];

        for (let c = document.getElementsByTagName('link'), i = 0, len = c.length, styleTag; i < len; i++) {
          styleTag = c[i].href.match(CSSFileName);
          if (styleTag) { path.push(styleTag[0]); }
        }

        if (!path || path.length === 0) {
          throw new Error(
            '[KEDITOR.constructor.iframe.fail] The keditor CSS files installation path could not be automatically detected.' +
            'Please set the option property "iframeCSSFileName" before creating editor instances.'
          );
        }
        let tagString = '';

        for (let i = 0, len = path.length; i < len; i++) {
          tagString += '<link href="' + path[i] + '" rel="stylesheet">';
        }

        return tagString;
      })() + (
        options.height === 'auto' ? '<style>\n/** Iframe height auto */\nbody{height: min-content; overflow: hidden;}\n</style>' : ''
      );

      wysiwygDiv.allowFullscreen = true;
      wysiwygDiv.frameBorder = 0;
      wysiwygDiv.addEventListener('load', function() {
        this.setAttribute('scrolling', 'auto');
        // @ts-ignore
        this.contentDocument.head.innerHTML = '' + '<meta charset="utf-8" />' + '<meta name="viewport" content="width=device-width, initial-scale=1">' + '<title></title>' + cssTags;
        this.contentDocument.body.className = 'keditor-editable';
        this.contentDocument.body.setAttribute('contenteditable', true);
        this.contentDocument.body.innerHTML = initHTML;
      });
    }

    wysiwygDiv.style.height = options.height;
    wysiwygDiv.style.minHeight = options.minHeight;
    wysiwygDiv.style.maxHeight = options.maxHeight; // textarea for code view

    const textarea = document.createElement('TEXTAREA');
    textarea.className = 'ke-wrapper-inner ke-wrapper-code';
    textarea.style.display = 'none';
    textarea.style.height = options.height;
    textarea.style.minHeight = options.minHeight;
    textarea.style.maxHeight = options.maxHeight;
    if (options.height === 'auto') { textarea.style.overflow = 'hidden'; }
    /** resize bar */

    let resizingBar = null;
    let navigation = null;
    let charCounter = null;
    const poweredBy = null;

    if (options.resizingBar) {
      resizingBar = document.createElement('DIV');
      resizingBar.className = 'ke-resizing-bar keditor-common';
      /** navigation */

      navigation = document.createElement('DIV');
      navigation.className = 'ke-navigation keditor-common';
      resizingBar.appendChild(navigation);
      /** char counter */

      if (options.charCounter) {
        const charWrapper = document.createElement('DIV');
        charWrapper.className = 'ke-char-counter-wrapper';
        charCounter = document.createElement('SPAN');
        charCounter.className = 'ke-char-counter';
        charCounter.textContent = '0';
        charWrapper.appendChild(charCounter);

        if (options.maxCharCount > 0) {
          const charMax = document.createElement('SPAN');
          charMax.textContent = ' / ' + options.maxCharCount;
          charWrapper.appendChild(charMax);
        }

        resizingBar.appendChild(charWrapper);
      }
    }

    return {
      bottomBar: {
        poweredBy,
        resizingBar,
        navigation,
        charCounter
      },
      wysiwygFrame: wysiwygDiv,
      codeView: textarea
    };
  },

  /**
   * @description Initialize options
   * @param element Options object
   * @param options Options object
   */
  _initOptions(element: any, options: any) {
    /** user options */
    options.lang = options.lang; // popup, editor display
    // options.position = options.position;

    options.popupDisplay = options.popupDisplay || 'full';
    options.display = (
      options.display || (element.style.display === 'none' || !element.style.display ? 'block' : element.style.display)
    ); // toolbar

    options.mode = options.mode || 'classic'; // classic, inline, balloon

    options.toolbarWidth = options.toolbarWidth ? (
      /^\d+$/.test(options.toolbarWidth) ? options.toolbarWidth + 'px' : options.toolbarWidth
    ) : (
      'auto'
    );
    options.stickyToolbar = (/balloon/i.test(options.mode) || options.stickyToolbar === undefined || options.stickyToolbar === null) ? -1 : (
      /^\d+/.test(options.stickyToolbar) ? options.stickyToolbar.toString().match(/\d+/)[0] * 1 : options.stickyToolbar === true ? 0 : -1
    ); // bottom resizing bar

    options.resizingBar = options.resizingBar === undefined ? /inline|balloon/i.test(options.mode) ? false : true : options.resizingBar;
    options.showPathLabel = !options.resizingBar ? false : typeof options.showPathLabel === 'boolean' ? options.showPathLabel : true;
    options.maxCharCount = /^\d+$/.test(options.maxCharCount) && options.maxCharCount > -1 ? options.maxCharCount * 1 : null;
    options.charCounter = options.maxCharCount > 0 ? true : typeof options.charCounter === 'boolean' ? options.charCounter : false;

    options.width = options.width ? (
      /^\d+$/.test(options.width) ? options.width + 'px' : options.width
    ) : (
      element.clientWidth ? element.clientWidth + 'px' : '100%'
    );
    options.minWidth = (/^\d+$/.test(options.minWidth) ? options.minWidth + 'px' : options.minWidth) || '';
    options.maxWidth = (/^\d+$/.test(options.maxWidth) ? options.maxWidth + 'px' : options.maxWidth) || '';
    options.height = options.height ? (
      /^\d+$/.test(options.height) ? options.height + 'px' : options.height
    ) : (
      element.clientHeight ? element.clientHeight + 'px' : 'auto'
    );
    options.minHeight = (/^\d+$/.test(options.minHeight) ? options.minHeight + 'px' : options.minHeight) || '';
    // font, size, formats, color list
    options.maxHeight = (/^\d+$/.test(options.maxHeight) ? options.maxHeight + 'px' : options.maxHeight) || '';

    options.font = options.font || null;
    options.fontSize = options.fontSize || null;
    options.formats = options.formats || null;
    options.colorList = options.colorList || null; // images

    options.imageResizing = options.imageResizing === undefined ? true : options.imageResizing;
    options.imageWidth = options.imageWidth && /\d+/.test(options.imageWidth) ? options.imageWidth.toString().match(/\d+/)[0] : 'auto';
    options.imageFileInput = options.imageFileInput === undefined ? true : options.imageFileInput;
    options.imageUrlInput = options.imageUrlInput === undefined || !options.imageFileInput ? true : options.imageUrlInput;
    options.imageUploadHeader = options.imageUploadHeader || null;
    options.imageUploadUrl = options.imageUploadUrl || null;
    options.imageUploadSizeLimit = /\d+/.test(options.imageUploadSizeLimit) ? options.imageUploadSizeLimit.toString().match(/\d+/)[0] * 1 : null; // video

    options.videoResizing = options.videoResizing === undefined ? true : options.videoResizing;
    options.videoWidth = options.videoWidth && /\d+/.test(options.videoWidth) ? options.videoWidth.toString().match(/\d+/)[0] : 560;
    options.videoHeight = options.videoHeight && /\d+/.test(options.videoHeight) ? options.videoHeight.toString().match(/\d+/)[0] : 315;
    options.youtubeQuery = (options.youtubeQuery || '').replace('?', ''); // --template
    // options.templates = options.templates;
    // --callBack function
    // options.callBackSave = options.callBackSave;
    // --editor area

    options.codeMirror = options.codeMirror ? options.codeMirror.src ? options.codeMirror : {
      src: options.codeMirror
    } : null;
    options.iframe = options.fullPage || options.iframe; // options.iframeCSSFileName = options.iframeCSSFileName;
    // options.fullPage = options.fullPage;
    // buttons

    options.buttonList = options.buttonList || [
      ['undo', 'redo'],
      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
      ['removeFormat'],
      ['outdent', 'indent'],
      ['codeView', 'showBlocks', 'fullScreen'],
      ['preview', 'print']
    ];
  },

  /**
   * @description KothingEditor's Default button list
   */
  _defaultButtons(lang) {
    return {
      /** command */
      bold: ['_se_command_bold', lang.toolbar.bold + ' (CTRL+B)', 'STRONG', '', '<i class="ke-icon-bold"></i>'],
      underline: ['_se_command_underline', lang.toolbar.underline + ' (CTRL+U)', 'INS', '', '<i class="ke-icon-underline"></i>'],
      italic: ['_se_command_italic', lang.toolbar.italic + ' (CTRL+I)', 'EM', '', '<i class="ke-icon-italic"></i>'],
      strike: ['_se_command_strike', lang.toolbar.strike + ' (CTRL+SHIFT+S)', 'DEL', '', '<i class="ke-icon-strokethrough"></i>'],
      subscript: ['_se_command_subscript', lang.toolbar.subscript, 'SUB', '', '<i class="ke-icon-subscript"></i>'],
      superscript: ['_se_command_superscript', lang.toolbar.superscript, 'SUP', '', '<i class="ke-icon-superscript"></i>'],
      removeFormat: ['', lang.toolbar.removeFormat, 'removeFormat', '', '<i class="ke-icon-erase"></i>'],
      indent: ['', lang.toolbar.indent + ' (CTRL+])', 'indent', '', '<i class="ke-icon-indent-right"></i>'],
      outdent: ['_se_command_outdent', lang.toolbar.outdent + ' (CTRL+[)', 'outdent', '', '<i class="ke-icon-indent-left"></i>'],
      fullScreen: ['code-view-enabled', lang.toolbar.fullScreen, 'fullScreen', '', '<i class="ke-icon-expansion"></i>'],
      showBlocks: ['', lang.toolbar.showBlocks, 'showBlocks', '', '<i class="ke-icon-showBlocks"></i>'],
      codeView: ['code-view-enabled', lang.toolbar.codeView, 'codeView', '', '<i class="ke-icon-code-view"></i>'],
      undo: ['_se_command_undo', lang.toolbar.undo + ' (CTRL+Z)', 'undo', '', '<i class="ke-icon-undo"></i>', true],
      redo: ['_se_command_redo', lang.toolbar.redo + ' (CTRL+Y / CTRL+SHIFT+Z)', 'redo', '', '<i class="ke-icon-redo"></i>', true],
      preview: ['', lang.toolbar.preview, 'preview', '', '<i class="ke-icon-preview"></i>'],
      print: ['', lang.toolbar.print, 'print', '', '<i class="ke-icon-print"></i>'],
      save: ['_se_command_save', lang.toolbar.save, 'save', '', '<i class="ke-icon-save"></i>', true],

      /** plugins - submenu */
      font: [
        'ke-btn-select ke-btn-tool-font _se_command_font_family',
        lang.toolbar.font,
        'font',
        'submenu',
        '<span class="txt">' + lang.toolbar.font + '</span><i class="ke-icon-arrow-down"></i>'
      ],
      formatBlock: [
        'ke-btn-select ke-btn-tool-format',
        lang.toolbar.formats,
        'formatBlock',
        'submenu',
        '<span class="txt _se_command_format">' + lang.toolbar.formats + '</span><i class="ke-icon-arrow-down"></i>'
      ],
      fontSize: [
        'ke-btn-select ke-btn-tool-size',
        lang.toolbar.fontSize,
        'fontSize',
        'submenu',
        '<span class="txt _se_command_font_size">' + lang.toolbar.fontSize + '</span><i class="ke-icon-arrow-down"></i>'
      ],
      fontColor: ['', lang.toolbar.fontColor, 'fontColor', 'submenu', '<i class="ke-icon-fontColor"></i>'],
      hiliteColor: ['', lang.toolbar.hiliteColor, 'hiliteColor', 'submenu', '<i class="ke-icon-hiliteColor"></i>'],
      align: ['ke-btn-align', lang.toolbar.align, 'align', 'submenu', '<i class="ke-icon-align-left _se_command_align"></i>'],
      list: ['_se_command_list', lang.toolbar.list, 'list', 'submenu', '<i class="ke-icon-list-number"></i>'],
      horizontalRule: ['btn_line', lang.toolbar.horizontalRule, 'horizontalRule', 'submenu', '<i class="ke-icon-hr"></i>'],
      table: ['', lang.toolbar.table, 'table', 'submenu', '<i class="ke-icon-grid"></i>'],
      template: ['', lang.toolbar.template, 'template', 'submenu', '<i class="ke-icon-template"></i>'],

      /** plugins - dialog */
      link: ['', lang.toolbar.link, 'link', 'dialog', '<i class="ke-icon-link"></i>'],
      image: ['', lang.toolbar.image, 'image', 'dialog', '<i class="ke-icon-image"></i>'],
      video: ['', lang.toolbar.video, 'video', 'dialog', '<i class="ke-icon-video"></i>']
    };
  },

  /**
   * @description Create a group div containing each module
   */
  _createModuleGroup(oneModule) {
    const oDiv = utilFunctions.createElement('DIV');
    oDiv.className = 'ke-btn-module' + (oneModule ? '' : ' ke-btn-module-border');
    const oUl = utilFunctions.createElement('UL');
    oUl.className = 'ke-menu-list';
    oDiv.appendChild(oUl);
    return {
      div: oDiv,
      ul: oUl
    };
  },

  /**
   * @description Create a button element
   * @param buttonClass className in button
   * @param title Title in button
   * @param dataCommand The data-command property of the button
   * @param dataDisplay The data-display property of the button ('dialog', 'submenu')
   * @param innerHTML Html in button
   * @param disabled Button disabled
   */
  _createButton(
    buttonClass: string,
    title: string,
    dataCommand: string,
    dataDisplay: string,
    innerHTML: string,
    disabled: boolean | string
  ) {
    const oLi = utilFunctions.createElement('LI');
    const oButton = utilFunctions.createElement('BUTTON');
    oButton.setAttribute('type', 'button');
    oButton.setAttribute('class', 'ke-btn' + (buttonClass ? ' ' + buttonClass : '') + ' ke-tooltip');
    oButton.setAttribute('data-command', dataCommand);
    oButton.setAttribute('data-display', dataDisplay);
    innerHTML += '<span class="ke-tooltip-inner"><span class="ke-tooltip-text">' + title + '</span></span>';
    if (disabled) { oButton.setAttribute('disabled', 'true'); }
    oButton.innerHTML = innerHTML;
    oLi.appendChild(oButton);
    return {
      li: oLi,
      button: oButton
    };
  },

  /**
   * @description Create editor HTML
   * @param doc document object
   * @param buttonList option.buttonList
   * @param plugins plugins to add
   * @param lang option.lang
   */
  _createToolBar(doc: any, buttonList: any[], plugins: any[], lang: any) {
    const separatorVertical = doc.createElement('DIV');
    separatorVertical.className = 'ke-toolbar-separator-vertical';
    const toolBar = doc.createElement('DIV');
    toolBar.className = 'ke-toolbar keditor-common';
    /** create button list */

    const defaultButtonList = this._defaultButtons(lang);

    const pluginCallButtons = {};
    const pluginsObj = {};

    if (plugins) {
      const pluginsValues = plugins.length ? plugins : Object.keys(plugins).map((name) => plugins[name]);

      for (let i = 0, len = pluginsValues.length; i < len; i++) {
        pluginsObj[pluginsValues[i].name] = pluginsValues[i];
      }
    }

    let module = null;
    let moduleElement = null;
    let buttonElement = null;
    let pluginName = '';
    let vertical = false;
    const oneModule = buttonList.length === 1;

    for (const buttonGroup of buttonList) {
      moduleElement = this._createModuleGroup(oneModule);
      /** button object */

      if (typeof buttonGroup === 'object') {
        for (const button of buttonGroup) {
          if (typeof button === 'object') {
            if (typeof button.add === 'function') {
              pluginName = button.name;
              module = defaultButtonList[pluginName];
              pluginsObj[pluginName] = button;
            } else {
              pluginName = button.name;
              module = [button.buttonClass, button.title, button.dataCommand, button.dataDisplay, button.innerHTML];
            }
          } else {
            module = defaultButtonList[button];
            pluginName = button;
          }

          buttonElement = this._createButton(module[0], module[1], module[2], module[3], module[4], module[5]);
          moduleElement.ul.appendChild(buttonElement.li);

          if (pluginsObj[pluginName]) {
            pluginCallButtons[pluginName] = buttonElement.button;
          }
        }

        if (vertical) { toolBar.appendChild(separatorVertical.cloneNode(false)); }
        toolBar.appendChild(moduleElement.div);
        vertical = true;
      } else if (/^\/$/.test(buttonGroup)) {
          const enterDiv = doc.createElement('DIV');
          enterDiv.className = 'ke-btn-module-enter';
          toolBar.appendChild(enterDiv);
          vertical = false;
        }
    }

    const toolCover = doc.createElement('DIV');
    toolCover.className = 'ke-toolbar-cover';
    toolBar.appendChild(toolCover);
    return {
      element: toolBar,
      plugins: pluginsObj,
      pluginCallButtons
    };
  }
});
// CONCATENATED MODULE: ./src/lib/context.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

/**
 * @description Elements and variables you should have
 * @param element textarea element
 * @param cons Toolbar element you created
 * @param options Inserted options
 * @returns Elements, variables of the editor, option
 */

const _Context = (element: HTMLElement, cons: any, options: any) => {
  return {
    element: {
      originElement: element,
      topArea: cons._top,
      relative: cons._relative,
      toolbar: cons._toolBar,
      resizingBar: cons._resizingBar,
      navigation: cons._navigation,
      charCounter: cons._charCounter,
      editorArea: cons._editorArea,
      wysiwygFrame: cons._wysiwygArea,
      wysiwyg: options.iframe ? cons._wysiwygArea.contentDocument.body : cons._wysiwygArea,
      code: cons._codeArea,
      loading: cons._loading,
      resizeBackground: cons._resizeBack,
      _stickyDummy: cons._stickyDummy,
      _arrow: cons._arrow
    },
    tool: {
      cover: cons._toolBar.querySelector('.ke-toolbar-cover'),
      bold: cons._toolBar.querySelector('._se_command_bold'),
      underline: cons._toolBar.querySelector('._se_command_underline'),
      italic: cons._toolBar.querySelector('._se_command_italic'),
      strike: cons._toolBar.querySelector('._se_command_strike'),
      subscript: cons._toolBar.querySelector('._se_command_subscript'),
      superscript: cons._toolBar.querySelector('._se_command_superscript'),
      font: cons._toolBar.querySelector('._se_command_font_family .txt'),
      fontTooltip: cons._toolBar.querySelector('._se_command_font_family .ke-tooltip-text'),
      format: cons._toolBar.querySelector('._se_command_format'),
      fontSize: cons._toolBar.querySelector('._se_command_font_size'),
      align: cons._toolBar.querySelector('._se_command_align'),
      list: cons._toolBar.querySelector('._se_command_list'),
      undo: cons._toolBar.querySelector('._se_command_undo'),
      redo: cons._toolBar.querySelector('._se_command_redo'),
      save: cons._toolBar.querySelector('._se_command_save'),
      outdent: cons._toolBar.querySelector('._se_command_outdent')
    },
    option: options
  };
};

const libContextObj = _Context;
// CONCATENATED MODULE: ./src/lib/history.js
/*
 * keditor.js
 * Copyright Kothing.
 * MIT license.
 */


const libHistory = (function libHistoryFunc(core, change) {
  if (!core) {
    throw new Error('Missing core object');
  }
  const editor = core.context.element;
  const util = core.util;
  const undo = core.context.tool.undo;
  const redo = core.context.tool.redo;
  let pushDelay = null;
  let stackIndex = 0;
  let stack = [{
    contents: core.getContents(),
    s: {
      path: [0, 0],
      offset: 0
    },
    e: {
      path: [0, 0],
      offset: 0
    }
  }];

  function setContentsFromStack() {
    if (!core) {
      throw new Error('Missing core object');
    }
    const item = stack[stackIndex];
    editor.wysiwyg.innerHTML = item.contents;
    core.setRange(
      util.getNodeFromPath(item.s.path, editor.wysiwyg),
      item.s.offset,
      util.getNodeFromPath(item.e.path, editor.wysiwyg),
      item.e.offset
    );
    core.focus();

    if (stackIndex === 0) {
      if (undo) { undo.setAttribute('disabled', 'true'); }
      if (redo) { redo.removeAttribute('disabled'); }
    } else if (stackIndex === stack.length - 1) {
      if (undo) { undo.removeAttribute('disabled'); }
      if (redo) { redo.setAttribute('disabled', 'true'); }
    } else {
      if (undo) { undo.removeAttribute('disabled'); }
      if (redo) { redo.removeAttribute('disabled'); }
    }

    core._checkComponents();

    core._charCount(0, false);

    core._iframeAutoHeight(); // onChange


    change();
  }

  function pushStack() {
    const current = core.getContents();
    if (current === stack[stackIndex].contents) { return; }
    stackIndex++;
    const range = core.getRange();

    if (stack.length > stackIndex) {
      stack = stack.slice(0, stackIndex);
      if (redo) { redo.setAttribute('disabled', 'true'); }
    }

    stack[stackIndex] = {
      contents: current,
      s: {
        path: util.getNodePath(range.startContainer),
        offset: range.startOffset
      },
      e: {
        path: util.getNodePath(range.endContainer),
        offset: range.endOffset
      }
    };
    if (stackIndex === 1 && undo) { undo.removeAttribute('disabled'); }

    core._checkComponents();

    core._charCount(0, false); // onChange


    change();
  }

  return {
    /**
     * @description Saving the current status to the history object stack
     */
    push() {
      window.setTimeout(core._iframeAutoHeight);

      if (pushDelay) {
        window.clearTimeout(pushDelay);
      }

      pushDelay = window.setTimeout(() => {
        window.clearTimeout(pushDelay);

        pushDelay = null;
        pushStack();
      }, 500);
    },

    /**
     * @description Undo function
     */
    undo() {
      if (stackIndex > 0) {
        stackIndex--;
        setContentsFromStack();
      }
    },

    /**
     * @description Redo function
     */
    redo() {
      if (stack.length - 1 > stackIndex) {
        stackIndex++;
        setContentsFromStack();
      }
    },

    /**
     * @description Reset the history object
     */
    reset() {
      stackIndex = 0;
      stack = stack[stackIndex] as any;
    }
  };
});
// CONCATENATED MODULE: ./src/lib/core.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */

/**
 * @description KothingEditor constuctor function.
 * create core object and event registration.
 * core, event, userFunction
 * @returns UserFunction Object
 */
const libCore = (function autoRunLibCore(context: any, pluginCallButtons: any, plugins: any, lang: any, libCoreOptions: any) {
  // @ts-ignore

  const util = utilFunctions;

  /**
   * @description editor core object
   * should always bind this object when registering an event in the plug-in.
   */
  const core = {
    /**
     * Random temporary variables
     */
    _ww: undefined,
    _wd: undefined,
    _iframeAuto: undefined,

    /**
     * @description Elements and user options parameters of the keditor
     */
    context,

    /**
     * @description loaded plugins
     */
    plugins: plugins || {},

    /**
     * @description Util object
     */
    util,

    /**
     * @description Whether the plugin is initialized
     */
    initPlugins: {},

    /**
     * @description loaded language
     */
    lang,

    /**
     * @description submenu element
     */
    submenu: null,

    /**
     * @description current resizing component name
     */
    _resizingName: '',

    /**
     * @description current subment name
     */
    _submenuName: '',

    /**
     * @description binded submenuOff method
     */
    _bindedSubmenuOff: null,

    /**
     * @description active button element in submenu
     */
    submenuActiveButton: null,

    /**
     * @description The elements array to be processed unvisible when the controllersOff function is executed (resizing, link modified button, table controller)
     */
    controllerArray: [],

    /**
     * @description An array of buttons whose class name is not "code-view-enabled"
     */
    codeViewDisabledButtons: null,

    /**
     * @description History object for undo, redo
     */
    history: null,

    /**
     * @description binded controllersOff method
     */
    _bindControllersOff: null,

    /**
     * @description Is inline mode?
     */
    _isInline: null,

    /**
     * @description Is balloon mode?
     */
    _isBalloon: null,

    /**
     * @description Required value when using inline mode to sticky toolbar
     */
    _inlineToolbarAttr: {
      width: 0,
      height: 0,
      top: undefined,
      isShow: false
    },

    /**
     * @description Variable that controls the "blur" event in the editor of inline or balloon mode when the focus is moved to submenu
     */
    _notHideToolbar: false,

    /**
     * @description Variable value that sticky toolbar mode
     */
    _sticky: false,

    /**
     * @description An user event function when image uploaded success or remove image
     */
    _imageUpload(targetImgElement, index, state, imageInfo, remainingFilesCount) {
      if (typeof userFunction.onImageUpload === 'function') { userFunction.onImageUpload(targetImgElement, index * 1, state, imageInfo, remainingFilesCount); }
    },

    /**
     * @description An user event function when image upload failed
     */
    _imageUploadError(errorMessage, result) {
      if (typeof userFunction.onImageUploadError === 'function') { return userFunction.onImageUploadError(errorMessage, result); }
      return true;
    },

    /**
     * @description Elements that need to change text or className for each selection change
     */
    commandMap: null,

    /**
     * @description Variables used internally in editor operation
     */
    _variable: {
      wysiwygActive: true,
      isFullScreen: false,
      innerHeight_fullScreen: 0,
      resizeClientY: 0,
      tabSize: 4,
      minResizingSize: 65,
      currentNodes: [],
      _range: null,
      _selectionNode: null,
      _originCssText: context.element.topArea.style.cssText,
      _bodyOverflow: '',
      _editorAreaOriginCssText: '',
      _wysiwygOriginCssText: '',
      _codeOriginCssText: '',
      _fullScreenSticky: false,
      _imagesInfo: [],
      _imageIndex: 0,
      _videosCnt: 0
    },

    /**
     * @description If the plugin is not added, add the plugin and call the 'add' function.
     * If the plugin is added call callBack function.
     * @param pluginName The name of the plugin to call
     * @param callBackFunction Optional function to be executed immediately after module call
     */
    callPlugin(pluginName: string, callBackFunction: () => void = null) {
      if (!this.plugins[pluginName]) {
        throw Error('[KEDITOR.core.callPlugin.fail] The called plugin does not exist or is in an invalid format. (pluginName:"' + pluginName + '")');
      } else if (!this.initPlugins[pluginName]) {
        this.plugins[pluginName].add(this, pluginCallButtons[pluginName]);
        this.initPlugins[pluginName] = true;
      }

      if (typeof callBackFunction === 'function') { callBackFunction(); }
    },

    /**
     * @description If the module is not added, add the module and call the 'add' function
     * @param moduleArray module object's Array [dialog, resizing]
     */
    addModule(moduleArray: any[]) {
      for (let i = 0, len = moduleArray.length, moduleName; i < len; i++) {
        moduleName = moduleArray[i].name;

        if (!this.plugins[moduleName]) {
          this.plugins[moduleName] = moduleArray[i];
          if (typeof this.plugins[moduleName].add === 'function') { this.plugins[moduleName].add(this); }
        }
      }
    },

    /**
     * @description Enabled submenu
     * @param element Submenu element to call
     */
    submenuOn(element) {
      if (this._bindedSubmenuOff) { this._bindedSubmenuOff(); }
      const submenuName = this._submenuName = element.getAttribute('data-command');
      this.submenu = element.nextElementSibling;
      this.submenu.style.display = 'block';
      util.addClass(element, 'on');
      this.submenuActiveButton = element;
      const overLeft = this.context.element.toolbar.offsetWidth - (element.parentElement.offsetLeft + this.submenu.offsetWidth);
      if (overLeft < 0) { this.submenu.style.left = overLeft + 'px'; } else { this.submenu.style.left = '1px'; }
      this._bindedSubmenuOff = this.submenuOff.bind(this);
      this.addDocEvent('mousedown', this._bindedSubmenuOff, false);
      if (this.plugins[submenuName].on) { this.plugins[submenuName].on.call(this); }
    },

    /**
     * @description Disable submenu
     */
    submenuOff() {
      this.removeDocEvent('mousedown', this._bindedSubmenuOff);
      this._bindedSubmenuOff = null;

      if (this.submenu) {
        this._submenuName = '';
        this.submenu.style.display = 'none';
        this.submenu = null;
        util.removeClass(this.submenuActiveButton, 'on');
        this.submenuActiveButton = null;
        this._notHideToolbar = false;
      }

      this.focus();
    },

    /**
     * @description Show controller at editor area (link button, image resize button, init function, etc..)
     * @param arguments controller elements, functions..
     */
    controllersOn() {
      if (this._bindControllersOff) { this._bindControllersOff(); }

      for (let i = 0; i < arguments.length; i++) {
        if (arguments[i].style) { arguments[i].style.display = 'block'; }
        this.controllerArray[i] = arguments[i];
      }

      this._bindControllersOff = this.controllersOff.bind(this);
      this.addDocEvent('mousedown', this._bindControllersOff, false);
      if (!this._resizingName) { this.addDocEvent('keydown', this._bindControllersOff, false); }
    },

    /**
     * @description Hide controller at editor area (link button, image resize button..)
     */
    controllersOff() {
      this._resizingName = '';
      if (!this._bindControllersOff) { return; }
      this.removeDocEvent('mousedown', this._bindControllersOff);
      this.removeDocEvent('keydown', this._bindControllersOff);
      this._bindControllersOff = null;
      const len = this.controllerArray.length;

      if (len > 0) {
        for (let i = 0; i < len; i++) {
          if (typeof this.controllerArray[i] === 'function') { this.controllerArray[i](); } else { this.controllerArray[i].style.display = 'none'; }
        }

        this.controllerArray = [];
      }
    },

    /**
     * @description javascript execCommand
     * @param command javascript execCommand function property
     * @param showDefaultUI javascript execCommand function property
     * @param value javascript execCommand function property
     */
    execCommand(command: string, showDefaultUI = false, value: string) {
      this._wd.execCommand(command, showDefaultUI, command === 'formatBlock' ? '<' + value + '>' : value);
      // history stack

      this.history.push();
    },

    /**
     * @description Focus to wysiwyg area
     */
    focus() {
      if (context.element.wysiwygFrame.style.display === 'none') { return; }
      const caption = util.getParentElement(this.getSelectionNode(), 'figcaption');

      if (caption) {
        caption.focus();
      } else {
        context.element.wysiwyg.focus();
      }

      this._editorRange();

      event._findButtonEffectTag();
    },

    /**
     * @description Set current editor's range object
     * @param startCon The startContainer property of the selection object.
     * @param startOff The startOffset property of the selection object.
     * @param endCon The endContainer property of the selection object.
     * @param endOff The endOffset property of the selection object.
     */
    setRange(startCon, startOff: number, endCon, endOff: number) {
      if (!startCon || !endCon) { return; }
      if (startOff > startCon.textContent.length) { startOff = startCon.textContent.length; }
      if (endOff > endCon.textContent.length) { endOff = endCon.textContent.length; }

      const range = this._wd.createRange();

      range.setStart(startCon, startOff);
      range.setEnd(endCon, endOff);
      const selection = this.getSelection();

      if (selection.removeAllRanges) {
        selection.removeAllRanges();
      }

      selection.addRange(range);

      this._editorRange();
    },

    /**
     * @description Get current editor's range object
     */
    getRange() {
      return this._variable._range || this._createDefaultRange();
    },

    /**
     * @description Get window selection obejct
     */
    getSelection() {
      return this._ww.getSelection();
    },

    /**
     * @description Get current select node
     */
    getSelectionNode() {
      if (!this._variable._selectionNode || util.isWysiwygDiv(this._variable._selectionNode)) { this._editorRange(); }
      return this._variable._selectionNode || context.element.wysiwyg.firstChild;
    },

    /**
     * @description Saving the range object and the currently selected node of editor
     */
    _editorRange() {
      const selection = this.getSelection();
      let range = null;
      let selectionNode = null;

      if (selection.rangeCount > 0) {
        range = selection.getRangeAt(0);
      } else {
        range = this._createDefaultRange();
      }

      this._variable._range = range;

      if (range.collapsed) {
        selectionNode = range.commonAncestorContainer;
      } else {
        selectionNode = selection.extentNode || selection.anchorNode;
      }

      this._variable._selectionNode = selectionNode;
    },

    /**
     * @description Return the range object of editor's first child node
     */
    _createDefaultRange() {
      const range = this._wd.createRange();

      if (!context.element.wysiwyg.firstChild) { this.execCommand('formatBlock', false, 'P'); }
      range.setStart(context.element.wysiwyg.firstChild, 0);
      range.setEnd(context.element.wysiwyg.firstChild, 0);
      return range;
    },

    /**
     * @description Returns a "formatElement"(P, DIV, H[1-6], LI) array from the currently selected range.
     * @param validation The validation function. (Replaces the default validation function-util.isFormatElement(current))
     */
    getSelectedElements(validation: (elem: any) => boolean = null) {
      let range = this.getRange();

      if (util.isWysiwygDiv(range.startContainer)) {
        const children = context.element.wysiwyg.children;
        if (children.length === 0) { return null; }
        this.setRange(children[0], 0, children[children.length - 1], children[children.length - 1].textContent.trim().length);
        range = this.getRange();
      }

      const startCon = range.startContainer;
      const endCon = range.endContainer;
      const commonCon = range.commonAncestorContainer; // get line nodes

      const lineNodes = util.getListChildren(commonCon, (current) => validation ? validation(current) : util.isFormatElement(current));
      if (!util.isWysiwygDiv(commonCon) && !util.isRangeFormatElement(commonCon)) {
        lineNodes.unshift(util.getFormatElement(commonCon));
      }
      if (startCon === endCon || lineNodes.length === 1) { return lineNodes; }
      const startLine = util.getFormatElement(startCon);
      const endLine = util.getFormatElement(endCon);
      let startIdx = null;
      let endIdx = null;

      const onlyTable = (current) => {
        return util.isTable(current) ? /^TABLE$/i.test(current.nodeName) : true;
      };

      const startRangeEl = util.getRangeFormatElement(startLine, onlyTable);
      const endRangeEl = util.getRangeFormatElement(endLine, onlyTable);
      const sameRange = startRangeEl === endRangeEl;

      for (let i = 0, len = lineNodes.length, line; i < len; i++) {
        line = lineNodes[i];

        if (startLine === line || !sameRange && line === startRangeEl) {
          startIdx = i;
          continue;
        }

        if (endLine === line || !sameRange && line === endRangeEl) {
          endIdx = i;
          break;
        }
      }

      if (startIdx === null) { startIdx = 0; }
      if (endIdx === null) { endIdx = lineNodes.length - 1; }
      return lineNodes.slice(startIdx, endIdx + 1);
    },

    /**
     * @description Get format elements and components from the selected area. (P, DIV, H[1-6], OL, UL, TABLE..)
     * If some of the component are included in the selection, get the entire that component.
     */
    getSelectedElementsAndComponents() {
      const commonCon = this.getRange().commonAncestorContainer;
      const myComponent = util.getParentElement(commonCon, util.isComponent);
      const selectedLines = util.isTable(commonCon) ? this.getSelectedElements() : this.getSelectedElements(function(current) {
        const component = this.getParentElement(current, this.isComponent);
        return this.isFormatElement(current) && (!component || component === myComponent) || this.isComponent(current) && !this.getFormatElement(current);
      }.bind(util));
      return selectedLines;
    },

    /**
     * @description Determine if this offset is the edge offset of container
     * @param container The container property of the selection object.
     * @param offset The offset property of the selection object.
     */
    isEdgePoint(container: any, offset: number): boolean {
      return offset === 0 || offset === container.nodeValue.length;
    },

    /**
     * @description Show loading box
     */
    showLoading() {
      context.element.loading.style.display = 'block';
    },

    /**
     * @description Close loading box
     */
    closeLoading() {
      context.element.loading.style.display = 'none';
    },

    /**
     * @description Append format element to sibling node of argument element.
     * If the "formatNodeName" argument value is present, the tag of that argument value is inserted,
     * If not, the currently selected format tag is inserted.
     * @param element Insert as siblings of that element
     * @param formatNodeName Node name to be inserted
     */
    appendFormatTag(element, formatNodeName: string = null) {
      const formatEl = element;
      const currentFormatEl = util.getFormatElement(this.getSelectionNode());
      const oFormatName = formatNodeName ? formatNodeName : util.isFormatElement(currentFormatEl) ? currentFormatEl.nodeName : 'P';
      const oFormat = util.createElement(oFormatName);
      oFormat.innerHTML = '<br>';
      if (util.isCell(formatEl)) { formatEl.insertBefore(oFormat, element.nextElementSibling); } else { formatEl.parentNode.insertBefore(oFormat, formatEl.nextElementSibling); }
      return oFormat;
    },

    /**
     * @description The method to insert a element. (used elements : table, hr, image, video)
     * This method is add the element next line and insert the new line.
     * When used in a tag in "LI", it is inserted into the LI tag.
     * Returns the next line added.
     * @param element Element to be inserted
     */
    insertComponent(element) {
      let oNode = null;
      const selectionNode = this.getSelectionNode();
      const formatEl = util.getFormatElement(selectionNode);

      if (util.isListCell(formatEl)) {
        if (/^HR$/i.test(element.nodeName)) {
          const newLi = util.createElement('LI');
          const textNode = util.createTextNode(util.zeroWidthSpace);
          newLi.appendChild(element);
          newLi.appendChild(textNode);
          formatEl.parentNode.insertBefore(newLi, formatEl.nextElementSibling);
          this.setRange(textNode, 1, textNode, 1);
        } else {
          this.insertNode(element, selectionNode === formatEl ? null : selectionNode);
          oNode = util.createElement('LI');
          formatEl.parentNode.insertBefore(oNode, formatEl.nextElementSibling);
        }
      } else {
        this.insertNode(element, formatEl);
        oNode = this.appendFormatTag(element);
      } // history stack


      this.history.push();
      return oNode;
    },

    /**
     * @description Delete selected node and insert argument value node
     * If the "afterNode" exists, it is inserted after the "afterNode"
     * @param oNode Element to be inserted
     * @param afterNode If the node exists, it is inserted after the node
     */
    insertNode(oNode: any, afterNode = null) {
      const range = this.getRange();
      let parentNode = null;

      if (!afterNode) {
        const startCon = range.startContainer;
        const startOff = range.startOffset;
        const endCon = range.endContainer;
        const endOff = range.endOffset;
        const commonCon = range.commonAncestorContainer;
        parentNode = startCon;

        if (startCon.nodeType === 3) {
          parentNode = startCon.parentNode;
        }
        /** No Select range node */


        if (range.collapsed) {
          if (commonCon.nodeType === 3) {
            afterNode = commonCon.splitText(endOff);
          } else {
            if (parentNode.lastChild !== null && util.isBreak(parentNode.lastChild)) {
              parentNode.removeChild(parentNode.lastChild);
            }

            afterNode = null;
          }
        } else {
            const isSameContainer = startCon === endCon;

            if (isSameContainer) {
              if (this.isEdgePoint(endCon, endOff)) { afterNode = endCon.nextSibling; } else { afterNode = endCon.splitText(endOff); }
              let removeNode = startCon;
              if (!this.isEdgePoint(startCon, startOff)) { removeNode = startCon.splitText(startOff); }
              parentNode.removeChild(removeNode);
            } else {
              this.removeNode();
              parentNode = commonCon;
              afterNode = endCon;

              while (afterNode.parentNode !== commonCon) {
                afterNode = afterNode.parentNode;
              }
            }
          }
      } else {
        parentNode = afterNode.parentNode;
        afterNode = afterNode.nextElementSibling;
      }

      try {
        parentNode.insertBefore(oNode, afterNode);
      } catch(e) {
        parentNode.appendChild(oNode);
      } finally {
        // history stack
        this.history.push();
      }
    },

    /**
     * @description Delete the currently selected node
     */
    removeNode() {
      const range = this.getRange();

      if (range.deleteContents) {
        range.deleteContents();
        return;
      }

      const startCon = range.startContainer;
      const startOff = range.startOffset;
      const endCon = range.endContainer;
      const endOff = range.endOffset;
      const commonCon = range.commonAncestorContainer;
      let beforeNode = null;
      let afterNode = null;
      const childNodes = util.getListChildNodes(commonCon);
      let startIndex = util.getArrayIndex(childNodes, startCon);
      let endIndex = util.getArrayIndex(childNodes, endCon);

      for (let i = startIndex + 1, startNode = startCon; i >= 0; i--) {
        if (childNodes[i] === startNode.parentNode && childNodes[i].firstChild === startNode && startOff === 0) {
          startIndex = i;
          startNode = startNode.parentNode;
        }
      }

      for (let i = endIndex - 1, endNode = endCon; i > startIndex; i--) {
        if (childNodes[i] === endNode.parentNode && childNodes[i].nodeType === 1) {
          childNodes.splice(i, 1);
          endNode = endNode.parentNode;
          --endIndex;
        }
      }

      for (let i = startIndex; i <= endIndex; i++) {
        const item = childNodes[i];

        if (item.length === 0 || item.nodeType === 3 && item.data === undefined) {
          util.removeItem(item);
          continue;
        }

        if (item === startCon) {
          if (startCon.nodeType === 1) {
            beforeNode = util.createTextNode(startCon.textContent);
          } else {
            beforeNode = util.createTextNode(startCon.substringData(0, startOff));
          }

          if (beforeNode.length > 0) {
            startCon.data = beforeNode.data;
          } else {
            util.removeItem(startCon);
          }

          continue;
        }

        if (item === endCon) {
          if (endCon.nodeType === 1) {
            afterNode = util.createTextNode(endCon.textContent);
          } else {
            afterNode = util.createTextNode(endCon.substringData(endOff, endCon.length - endOff));
          }

          if (afterNode.length > 0) {
            endCon.data = afterNode.data;
          } else {
            util.removeItem(endCon);
          }

          continue;
        }

        util.removeItem(item); // history stack

        this.history.push();
      }
    },

    /**
     * @description Appended all selected format Element to the argument element and insert
     * @param rangeElement Element of wrap the arguments (PRE, BLOCKQUOTE...)
     */
    applyRangeFormatElement(rangeElement: any) {
      const rangeLines = this.getSelectedElementsAndComponents();
      if (!rangeLines || rangeLines.length === 0) { return; }
      const last = rangeLines[rangeLines.length - 1];
      let standTag;
      let beforeTag;
      let pElement;

      if (util.isRangeFormatElement(last) || util.isFormatElement(last)) {
        standTag = last;
      } else {
        standTag = util.getRangeFormatElement(last) || util.getFormatElement(last);
      }

      if (util.isCell(standTag)) {
        beforeTag = null;
        pElement = standTag;
      } else {
        beforeTag = standTag.nextSibling;
        pElement = standTag.parentNode;
      }

      let parentDepth = util.getElementDepth(standTag);
      let listParent = null;
      const lineArr = [];

      const removeItems = (parent, origin, before = null) => {
        let cc = null;

        if (parent !== origin && !util.isTable(origin)) {
          cc = util.removeItemAllParents(origin);
        }

        return cc ? cc.ec : before;
      };

      for (let i = 0, len = rangeLines.length, line, originParent, depth, before; i < len; i++) {
        line = rangeLines[i];
        originParent = line.parentNode;
        depth = util.getElementDepth(line);

        if (util.isList(originParent)) {
          if (listParent === null) { listParent = util.createElement(originParent.nodeName); }
          listParent.innerHTML += line.outerHTML;
          lineArr.push(line);

          if (i === len - 1 || !this.util.getParentElement(rangeLines[i + 1], (current) => current === originParent)) {
            const internalEdge = this.detachRangeFormatElement(originParent, lineArr, null, true, true);

            if (parentDepth >= depth) {
              parentDepth = depth;
              pElement = internalEdge.cc;
              beforeTag = removeItems(pElement, originParent, internalEdge.ec);
              if (beforeTag) { pElement = beforeTag.parentNode; }
            } else if (pElement === internalEdge.cc) {
              beforeTag = internalEdge.ec;
            }

            if (pElement !== internalEdge.cc) {
              before = removeItems(pElement, internalEdge.cc);
              if (before !== undefined) { beforeTag = before; }
            }

            rangeElement.appendChild(listParent);
            listParent = null;
          }
        } else {
          if (parentDepth >= depth) {
            parentDepth = depth;
            pElement = originParent;
            beforeTag = line.nextSibling;
          }

          rangeElement.appendChild(line);

          if (pElement !== originParent) {
            before = removeItems(pElement, originParent);
            if (before !== undefined) { beforeTag = before; }
          }
        }
      }

      pElement.insertBefore(rangeElement, beforeTag);
      removeItems(rangeElement, beforeTag); // history stack

      this.history.push();
      const edge = this.util.getEdgeChildNodes(rangeElement.firstElementChild, rangeElement.lastElementChild);

      if (rangeLines.length > 1) {
        this.setRange(edge.sc, 0, edge.ec, edge.ec.textContent.length);
      } else {
        this.setRange(edge.ec, edge.ec.textContent.length, edge.ec, edge.ec.textContent.length);
      }
    },

    /**
     * @description The elements of the "selectedFormats" array are detached from the "rangeElement" element.
     * ("LI" tags are converted to "P" tags)
     * When "selectedFormats" is null, all elements are detached and return {cc: parentNode, sc: nextSibling, ec: previousSibling}.
     * @param rangeElement Range format element (PRE, BLOCKQUOTE, OL, UL...)
     * @param selectedFormats Array of format elements (P, DIV, LI...) to remove.
     * If null, Applies to all elements and return {cc: parentNode, sc: nextSibling, ec: previousSibling}
     * @param newRangeElement The node(rangeElement) to replace the currently wrapped node.
     * @param remove Delete without detached.
     * @param notHistory When true, it does not update the history stack and the selection object and return EdgeNodes (util.getEdgeChildNodes)
     */
    detachRangeFormatElement(rangeElement: any, selectedFormats = null, newRangeElement = null, remove = false, notHistory = false) {
      const range = this.getRange();
      const so = range.startOffset;
      const eo = range.endOffset;
      const children = rangeElement.childNodes;
      const parent = rangeElement.parentNode;
      let firstNode = null;
      let lastNode = null;
      let rangeEl = rangeElement.cloneNode(false);
      const newList = util.isList(newRangeElement);
      let insertedNew = false;

      function appendNode(internalParent, insNode, sibling) {
        if (util.onlyZeroWidthSpace(insNode)) {
          insNode.innerHTML = util.zeroWidthSpace;
        }

        if (insNode.nodeType === 3) {
          internalParent.insertBefore(insNode, sibling);
          return insNode;
        }

        const internalChildren = insNode.childNodes;
        let format = insNode.cloneNode(false);
        let first = null;
        let c = null;

        while (internalChildren[0]) {
          c = internalChildren[0];

          if (util.isIgnoreNodeChange(c) && !util.isListCell(format)) {
            if (format.childNodes.length > 0) {
              if (!first) { first = format; }
              internalParent.insertBefore(format, sibling);
              format = insNode.cloneNode(false);
            }

            internalParent.insertBefore(c, sibling);
            if (!first) { first = c; }
          } else {
            format.appendChild(c);
          }
        }

        if (format.childNodes.length > 0) {
          internalParent.insertBefore(format, sibling);
          if (!first) { first = format; }
        }

        return first;
      }

      for (let i = 0, len = children.length, insNode; i < len; i++) {
        insNode = children[i];

        if (remove && i === 0) {
          if (!selectedFormats || selectedFormats.length === len || selectedFormats[0] === insNode) {
            firstNode = rangeElement.previousSibling;
          } else {
            firstNode = rangeEl;
          }
        }

        if (selectedFormats && selectedFormats.indexOf(insNode) === -1) {
          if (!rangeEl) { rangeEl = rangeElement.cloneNode(false); }
          insNode = insNode.cloneNode(true);
          rangeEl.appendChild(insNode);
        } else {
          if (rangeEl && rangeEl.children.length > 0) {
            parent.insertBefore(rangeEl, rangeElement);
            rangeEl = null;
          }

          if (!newList && util.isListCell(insNode)) {
            const inner = insNode.innerHTML;
            insNode = util.isCell(rangeElement.parentNode) ? util.createElement('DIV') : util.createElement('P');
            insNode.innerHTML = inner;
          } else {
            insNode = insNode.cloneNode(true);
          }

          if (!remove) {
            if (newRangeElement) {
              if (!insertedNew) {
                parent.insertBefore(newRangeElement, rangeElement);
                insertedNew = true;
              }

              insNode = appendNode(newRangeElement, insNode, null);
            } else {
              insNode = appendNode(parent, insNode, rangeElement);
            }

            if (selectedFormats) {
              lastNode = insNode;

              if (!firstNode) {
                firstNode = insNode;
              }
            } else if (!firstNode) {
              firstNode = lastNode = insNode;
            }
          }
        }
      }

      const rangeParent = rangeElement.parentNode;
      const rangeRight = rangeElement.nextSibling;

      if (rangeEl && rangeEl.children.length > 0) {
        rangeParent.insertBefore(rangeEl, rangeRight);
      }

      util.removeItem(rangeElement);
      const edge = remove ? {
        cc: rangeParent,
        sc: firstNode,
        ec: firstNode && firstNode.parentNode ? firstNode.nextSibling : rangeEl && rangeEl.children.length > 0 ? rangeEl : rangeRight ? rangeRight : null
      } : this.util.getEdgeChildNodes(firstNode, lastNode);
      if (notHistory) { return edge; } // history stack

      this.history.push();

      if (!remove && edge) {
        if (!selectedFormats) {
          this.setRange(edge.sc, 0, edge.sc, 0);
        } else {
          this.setRange(edge.sc, so, edge.ec, eo);
        }
      }

      event._findButtonEffectTag();
    },

    /**
     * @description Adds a node to the selected region, or deletes the node.
     * 1. If there is a node in the "appendNode" argument, "appendNode" is added to the selection range.
     * 2. If the "appendNode" argument has a null value, the node is modified without adding a new node.
     * 3. Styles such as the style property of the "styleArray" argument will be deleted.
     * 4. If the node is "appendNode" or if "appendNode" is null, Nodes with all styles removed will be deleted.
     * 5. Tags with the same name as the value of the "removeNodeArray" argument will be deleted. Valid only when "appendNode" is null.
     * @param appendNode The element to be added to the selection. If it is null, delete the node.
     * @param styleArray The style attribute name Array to check (['font-size'], ['font-family', 'background-color', 'border']...])
     * @param removeNodeArray An array of node names from which to remove types, Removes all formats when there is an empty array or null value. (['span'], ['b', 'u']...])
     */
    nodeChange(appendNode = null, styleArray = null, removeNodeArray = null) {
      const range = this.getRange();
      styleArray = styleArray && styleArray.length > 0 ? styleArray : false;
      removeNodeArray = removeNodeArray && removeNodeArray.length > 0 ? removeNodeArray : false;
      const isRemoveNode = !appendNode;
      const isRemoveFormat = isRemoveNode && !removeNodeArray && !styleArray;
      let startCon = range.startContainer;
      let startOff = range.startOffset;
      let endCon = range.endContainer;
      let endOff = range.endOffset;
      let tempCon;
      let tempOffset;
      let tempChild;

      if (isRemoveFormat && range.collapsed && util.isFormatElement(startCon.parentNode) && util.isFormatElement(endCon.parentNode)) {
        return;
      }

      if (isRemoveNode) {
        appendNode = this.util.createElement('DIV');
      }
      /* checked same style property */


      if (!isRemoveFormat && startCon === endCon) {
        let sNode = startCon;

        if (isRemoveFormat) {
          if (util.getFormatElement(sNode) === sNode.parentNode) { return; }
        } else if (styleArray.length > 0) {
          let checkCnt = 0;

          for (const styleElem of styleArray) {
            while (!util.isFormatElement(sNode) && !util.isWysiwygDiv(sNode)) {
              if (
                sNode.nodeType === 1 &&
                (isRemoveNode ? sNode.style[styleElem] : sNode.style[styleElem] === appendNode.style[styleElem])
              ) {
                checkCnt++;
              }

              sNode = sNode.parentNode;
            }
          }

          if (!isRemoveNode && checkCnt >= styleArray.length) { return; }
          if (isRemoveNode && checkCnt === 0) { return; }
        }
      }
      /* find text node */
      // startContainer


      tempCon = util.isWysiwygDiv(startCon) ? context.element.wysiwyg.firstChild : startCon;
      tempOffset = startOff;

      if (util.isBreak(tempCon) || tempCon.nodeType === 1 && tempCon.childNodes.length > 0) {
        const onlyBreak = util.isBreak(tempCon);

        if (!onlyBreak) {
          while (tempCon && !util.isBreak(tempCon) && tempCon.nodeType === 1) {
            tempCon = tempCon.childNodes[tempOffset] || tempCon.nextElementSibling || tempCon.nextSibling;
            tempOffset = 0;
          }

          let format = util.getFormatElement(tempCon);

          if (format === util.getRangeFormatElement(format)) {
            format = util.createElement(util.isCell(tempCon) ? 'DIV' : 'P');
            tempCon.parentNode.insertBefore(format, tempCon);
            format.appendChild(tempCon);
          }
        }

        if (util.isBreak(tempCon)) {
          const emptyText = util.createTextNode(util.zeroWidthSpace);
          tempCon.parentNode.insertBefore(emptyText, tempCon);
          tempCon = emptyText;

          if (onlyBreak) {
            if (startCon === endCon) {
              endCon = tempCon;
              endOff = 1;
            }

            util.removeItem(startCon);
          }
        }
      } // set startContainer


      startCon = tempCon;
      startOff = tempOffset; // endContainer

      tempCon = util.isWysiwygDiv(endCon) ? context.element.wysiwyg.lastChild : endCon;
      tempOffset = endOff;

      if (util.isBreak(tempCon) || tempCon.nodeType === 1 && tempCon.childNodes.length > 0) {
        const onlyBreak = util.isBreak(tempCon);

        if (!onlyBreak) {
          while (tempCon && !util.isBreak(tempCon) && tempCon.nodeType === 1) {
            tempChild = tempCon.childNodes;
            tempCon = (
              tempChild[tempOffset > 0 ? tempOffset - 1 : tempOffset] || (
                !/FIGURE/i.test(tempChild[0].nodeName) ? tempChild[0] : (
                  tempCon.previousElementSibling || tempCon.previousSibling || startCon
                )
              )
            );
            tempOffset = tempOffset > 0 ? tempCon.textContent.length : tempOffset;
          }

          let format = util.getFormatElement(tempCon);

          if (format === util.getRangeFormatElement(format)) {
            format = util.createElement(util.isCell(format) ? 'DIV' : 'P');
            tempCon.parentNode.insertBefore(format, tempCon);
            format.appendChild(tempCon);
          }
        }

        if (util.isBreak(tempCon)) {
          const emptyText = util.createTextNode(util.zeroWidthSpace);
          tempCon.parentNode.insertBefore(emptyText, tempCon);
          tempCon = emptyText;
          tempOffset = 0;

          if (onlyBreak) {
            util.removeItem(endCon);
          }
        }
      } // set endContainer


      endCon = tempCon;
      endOff = tempOffset; // set Range

      const newNodeName = appendNode.nodeName;
      this.setRange(startCon, startOff, endCon, endOff);
      let start = {container: undefined, offset: undefined};
      let end = {container: undefined, offset: undefined};
      let newNode;
      let styleRegExp;
      let removeRegExp;

      if (styleArray) {
        styleRegExp = '(?:;|^|\\s)(?:' + styleArray[0];

        for (let i = 1; i < styleArray.length; i++) {
          styleRegExp += '|' + styleArray[i];
        }

        styleRegExp += ')\\s*:[^;]*\\s*(?:;|$)';
        styleRegExp = new RegExp(styleRegExp, 'ig');
      }

      if (removeNodeArray) {
        removeRegExp = '^(?:' + removeNodeArray[0];

        for (let i = 1; i < removeNodeArray.length; i++) {
          removeRegExp += '|' + removeNodeArray[i];
        }

        removeRegExp += ')$';
        removeRegExp = new RegExp(removeRegExp, 'i');
      }

      const validation = (vNode) => {
        // all path
        if (vNode.nodeType === 3 || util.isBreak(vNode)) { return true; } // all remove

        if (isRemoveFormat) { return false; } // style regexp

        const originStyle = vNode.style.cssText;
        let style = '';

        if (styleRegExp && originStyle.length > 0) {
          style = originStyle.replace(styleRegExp, '').trim();
        } // remove


        if (isRemoveNode) {
          if (styleRegExp && removeRegExp) {
            if (!style && removeRegExp.test(vNode.nodeName)) { return false; }
          }

          if (styleRegExp && !style && originStyle) {
            return false;
          }

          if (removeRegExp && removeRegExp.test(vNode.nodeName)) {
            return false;
          }
        } // change


        if (style || vNode.nodeName !== newNodeName) {
          if (styleRegExp && originStyle.length > 0) { vNode.style.cssText = style; }
          return true;
        }

        return false;
      }; // get line nodes


      const lineNodes = this.getSelectedElements();

      if (!util.getFormatElement(startCon)) {
        startCon = util.getChildElement(lineNodes[0], (current) => current.nodeType === 3);
        startOff = 0;
      }

      if (!util.getFormatElement(endCon)) {
        endCon = util.getChildElement(lineNodes[lineNodes.length - 1], (current) => current.nodeType === 3);
        endOff = endCon.textContent.length;
      }

      const oneLine = util.getFormatElement(startCon) === util.getFormatElement(endCon);
      const endLength = lineNodes.length - (oneLine ? 0 : 1); // node Changes

      newNode = appendNode.cloneNode(false); // startCon

      if (oneLine) {
        const newRange = this._nodeChange_oneLine(
          lineNodes[0],
          newNode,
          validation,
          startCon,
          startOff,
          endCon,
          endOff,
          isRemoveFormat,
          isRemoveNode,
          range.collapsed
        );

        start.container = newRange.startContainer;
        start.offset = newRange.startOffset;
        end.container = newRange.endContainer;
        end.offset = newRange.endOffset;
      } else {
        start = this._nodeChange_startLine(lineNodes[0], newNode, validation, startCon, startOff, isRemoveFormat, isRemoveNode);
      } // mid


      for (let i = 1; i < endLength; i++) {
        newNode = appendNode.cloneNode(false);

        this._nodeChange_middleLine(lineNodes[i], newNode, validation, isRemoveFormat, isRemoveNode);
      } // endCon


      if (endLength > 0 && !oneLine) {
        newNode = appendNode.cloneNode(false);
        end = this._nodeChange_endLine(lineNodes[endLength], newNode, validation, endCon, endOff, isRemoveFormat, isRemoveNode);
      } else if (!oneLine) {
        end = start;
      } // set range


      this.setRange(start.container, start.offset, end.container, end.offset); // history stack

      this.history.push();
    },

    /**
     * @description Strip remove node
     * @param element The format node
     * @param removeNode The remove node
     */
    _stripRemoveNode(element: any, removeNode: any) {
      if (!removeNode || removeNode.nodeType === 3) { return; }
      const children = removeNode.childNodes;

      while (children[0]) {
        element.insertBefore(children[0], removeNode);
      }

      element.removeChild(removeNode);
    },

    /**
     * @description wraps text nodes of line selected text.
     * @param element The node of the line that contains the selected text node.
     * @param newInnerNode The dom that will wrap the selected text area
     * @param validation Check if the node should be stripped.
     * @param startCon The startContainer property of the selection object.
     * @param startOff The startOffset property of the selection object.
     * @param endCon The endContainer property of the selection object.
     * @param endOff The endOffset property of the selection object.
     * @param isRemoveFormat Is the remove all formats command?
     * @param isRemoveNode "newInnerNode" is remove node?
     * @param collapsed range.collapsed
     */
    _nodeChange_oneLine(
      element: any | HTMLElement,
      newInnerNode: any | HTMLElement,
      validation: (vNode: any) => boolean,
      startCon: any | HTMLElement,
      startOff: number,
      endCon: any | HTMLElement,
      endOff: number,
      isRemoveFormat: boolean,
      isRemoveNode: boolean,
      collapsed: boolean
    ) {
      const el = element;
      const nNode = newInnerNode;
      const nNodeArray = [newInnerNode];
      const pNode = element.cloneNode(false);
      const isSameNode = startCon === endCon;
      let startContainer = startCon;
      let startOffset = startOff;
      let endContainer = endCon;
      let endOffset = endOff;
      let startPass = false;
      let endPass = false;
      let pCurrent;
      let newNode;
      let appendNode;
      let cssText;

      function checkCss(vNode) {
        const regExp = new RegExp('(?:;|^|\\s)(?:' + cssText + 'null)\\s*:[^;]*\\s*(?:;|$)', 'ig');
        let style = false;

        if (regExp && vNode.style.cssText.length > 0) {
          style = regExp.test(vNode.style.cssText);
        }

        return !style;
      }

      (function recursionFunc(current, node) {
        const childNodes = current.childNodes;

        for (let i = 0, len = childNodes.length; i < len; i++) {
          const child = childNodes[i];
          if (!child) { continue; }
          let coverNode = node;
          let cloneNode; // startContainer

          if (!startPass && child === startContainer) {
            const prevNode = util.createTextNode(startContainer.nodeType === 1 ? '' : startContainer.substringData(0, startOffset));
            const textNode = util.createTextNode(
              startContainer.nodeType === 1 ? '' : startContainer.substringData(
                startOffset,
                isSameNode ? (
                  endOffset >= startOffset ? endOffset - startOffset : startContainer.data.length - startOffset
                ) : (
                  startContainer.data.length - startOffset
                )
              )
            );

            if (prevNode.data.length > 0) {
              node.appendChild(prevNode);
            }

            newNode = child;
            pCurrent = [];
            cssText = '';

            while (newNode !== pNode && newNode !== el && newNode !== null) {
              if (validation(newNode) && newNode.nodeType === 1 && checkCss(newNode)) {
                pCurrent.push(newNode.cloneNode(false));
                cssText += newNode.style.cssText.substr(0, newNode.style.cssText.indexOf(':')) + '|';
              }

              newNode = newNode.parentNode;
            }

            const childNode = pCurrent.pop() || textNode;
            appendNode = newNode = childNode;

            while (pCurrent.length > 0) {
              newNode = pCurrent.pop();
              appendNode.appendChild(newNode);
              appendNode = newNode;
            }

            newInnerNode.appendChild(childNode);
            pNode.appendChild(newInnerNode);
            startContainer = textNode;
            startOffset = 0;
            startPass = true;
            if (newNode !== textNode) { newNode.appendChild(startContainer); }
            if (!isSameNode) { continue; }
          } // endContainer


          if (!endPass && child === endContainer) {
            const afterNode = util.createTextNode(
              endContainer.nodeType === 1 ? '' : endContainer.substringData(endOffset, endContainer.length - endOffset)
            );
            const textNode = util.createTextNode(
              isSameNode || endContainer.nodeType === 1 ? '' : endContainer.substringData(0, endOffset)
            );

            if (afterNode.data.length > 0) {
              newNode = child;
              cssText = '';
              pCurrent = [];

              while (newNode !== pNode && newNode !== el && newNode !== null) {
                if (newNode.nodeType === 1 && checkCss(newNode)) {
                  pCurrent.push(newNode.cloneNode(false));
                  cssText += newNode.style.cssText.substr(0, newNode.style.cssText.indexOf(':')) + '|';
                }

                newNode = newNode.parentNode;
              }

              cloneNode = appendNode = newNode = pCurrent.pop() || afterNode;

              while (pCurrent.length > 0) {
                newNode = pCurrent.pop();
                appendNode.appendChild(newNode);
                appendNode = newNode;
              }

              pNode.appendChild(cloneNode);
              newNode.textContent = afterNode.data;
            }

            newNode = child;
            pCurrent = [];
            cssText = '';

            while (newNode !== pNode && newNode !== el && newNode !== null) {
              if (validation(newNode) && newNode.nodeType === 1 && checkCss(newNode)) {
                pCurrent.push(newNode.cloneNode(false));
                cssText += newNode.style.cssText.substr(0, newNode.style.cssText.indexOf(':')) + '|';
              }

              newNode = newNode.parentNode;
            }

            const childNode = pCurrent.pop() || textNode;
            appendNode = newNode = childNode;

            while (pCurrent.length > 0) {
              newNode = pCurrent.pop();
              appendNode.appendChild(newNode);
              appendNode = newNode;
            }

            newInnerNode.appendChild(childNode);
            endContainer = textNode;
            endOffset = textNode.data.length;
            endPass = true;

            if (!isRemoveFormat && collapsed) {
              newInnerNode = textNode;
              textNode.textContent = util.zeroWidthSpace;
            }

            if (newNode !== textNode) { newNode.appendChild(endContainer); }
            continue;
          } // other


          if (startPass) {
            if (child.nodeType === 1 && !util.isBreak(child)) {
              if (util.isIgnoreNodeChange(child)) {
                newInnerNode = newInnerNode.cloneNode(false);
                pNode.appendChild(child);
                pNode.appendChild(newInnerNode);
                nNodeArray.push(newInnerNode);
                i--;
              } else {
                recursionFunc(child, child);
              }

              continue;
            }

            newNode = child;
            pCurrent = [];
            cssText = '';

            while (newNode.parentNode !== null && newNode !== el && newNode !== newInnerNode) {
              if (newNode.nodeType === 1 && !util.isBreak(child) && (endPass || validation(newNode)) && checkCss(newNode)) {
                pCurrent.push(newNode.cloneNode(false));
                cssText += newNode.style.cssText.substr(0, newNode.style.cssText.indexOf(':')) + '|';
              }

              newNode = newNode.parentNode;
            }

            const childNode = pCurrent.pop() || child;
            appendNode = newNode = childNode;

            while (pCurrent.length > 0) {
              newNode = pCurrent.pop();
              appendNode.appendChild(newNode);
              appendNode = newNode;
            }

            if (childNode === child) {
              if (!endPass) { node = newInnerNode; } else { node = pNode; }
            } else if (endPass) {
              pNode.appendChild(childNode);
              node = newNode;
            } else {
              newInnerNode.appendChild(childNode);
              node = newNode;
            }
          }

          cloneNode = child.cloneNode(false);
          node.appendChild(cloneNode);
          if (child.nodeType === 1 && !util.isBreak(child)) { coverNode = cloneNode; }
          recursionFunc(child, coverNode);
        }
      })(element, pNode);

      isRemoveFormat = isRemoveFormat && isRemoveNode;

      if (isRemoveFormat) {
        for (let i = 0; i < nNodeArray.length; i++) {
          const removeNode = nNodeArray[i];
          const textNode = util.createTextNode(collapsed ? util.zeroWidthSpace : removeNode.textContent);
          pNode.insertBefore(textNode, removeNode);
          pNode.removeChild(removeNode);
          if (i === 0) { startContainer = endContainer = textNode; }
        }
      } else {
        if (isRemoveNode) {
          for (let removeNode of nNodeArray) {
            if (collapsed) {
              while (removeNode !== nNode) {
                removeNode = removeNode.parentNode;
              }
            }

            this._stripRemoveNode(pNode, removeNode);
          }
        }

        if (collapsed) {
          startContainer = endContainer = newInnerNode;
        }
      }

      const preventDelete = util.onlyZeroWidthSpace(newInnerNode.textContent);
      if (preventDelete) { newInnerNode.textContent = ' '; }
      util.removeEmptyNode(pNode);
      if (preventDelete) { newInnerNode.textContent = util.zeroWidthSpace; } // node change

      const endConReset = isRemoveFormat || !endContainer.textContent;
      element.parentNode.insertBefore(pNode, element);
      util.removeItem(element);

      if (collapsed) {
        startOffset = startContainer.textContent.length;
        endOffset = endContainer.textContent.length;
      }

      if (endContainer.textContent.length === 0) {
        util.removeItem(endContainer);
        endContainer = startContainer;
      }

      return {
        startContainer,
        startOffset,
        endContainer,
        endOffset: endConReset ? endContainer.textContent.length : endOffset
      };
    },

    /**
     * @description wraps mid lines selected text.
     * @param element The node of the line that contains the selected text node.
     * @param newInnerNode The dom that will wrap the selected text area
     * @param validation Check if the node should be stripped.
     * @param isRemoveFormat Is the remove all formats command?
     * @param isRemoveNode "newInnerNode" is remove node?
     */
    _nodeChange_middleLine(element: any, newInnerNode: any, validation: (elem: any) => boolean, isRemoveFormat: boolean, isRemoveNode: boolean) {
      const pNode = element.cloneNode(false);
      const nNodeArray = [newInnerNode];
      let noneChange = true;

      (function recursionFunc(current, node) {
        const childNodes = current.childNodes;

        for (let i = 0, len = childNodes.length; i < len; i++) {
          const child = childNodes[i];
          if (!child) { continue; }
          let coverNode = node;

          if (util.isIgnoreNodeChange(child)) {
            pNode.appendChild(newInnerNode);
            newInnerNode = newInnerNode.cloneNode(false);
            pNode.appendChild(child);
            pNode.appendChild(newInnerNode);
            nNodeArray.push(newInnerNode);
            node = newInnerNode;
            i--;
            continue;
          } else if (validation(child)) {
            noneChange = false;
            const cloneNode = child.cloneNode(false);
            node.appendChild(cloneNode);
            if (child.nodeType === 1 && !util.isBreak(child)) { coverNode = cloneNode; }
          }

          recursionFunc(child, coverNode);
        }
      })(element.cloneNode(true), newInnerNode);

      if (noneChange) { return; }
      pNode.appendChild(newInnerNode);

      if (isRemoveFormat && isRemoveNode) {
        for (const removeNode of nNodeArray) {
          const textNode = util.createTextNode(removeNode.textContent);
          pNode.insertBefore(textNode, removeNode);
          pNode.removeChild(removeNode);
        }
      } else if (isRemoveNode) {
        for (const removeNode of nNodeArray) {
          this._stripRemoveNode(pNode, removeNode);
        }
      }

      util.removeEmptyNode(pNode); // node change

      element.parentNode.insertBefore(pNode, element);
      util.removeItem(element);
    },

    /**
     * @description wraps first line selected text.
     * @param element The node of the line that contains the selected text node.
     * @param newInnerNode The dom that will wrap the selected text area
     * @param validation Check if the node should be stripped.
     * @param startCon The startContainer property of the selection object.
     * @param startOff The startOffset property of the selection object.
     * @param isRemoveFormat Is the remove all formats command?
     * @param isRemoveNode "newInnerNode" is remove node?
     */
    _nodeChange_startLine(
      element: any,
      newInnerNode: any,
      validation: (elem: any) => boolean,
      startCon: any,
      startOff: number,
      isRemoveFormat: boolean,
      isRemoveNode: boolean
    ) {
      const el = element;
      const nNodeArray = [newInnerNode];
      const pNode = element.cloneNode(false);
      let container = startCon;
      let offset = startOff;
      let passNode = false;
      let pCurrent;
      let newNode;
      let appendNode;

      (function recursionFunc(current, node) {
        const childNodes = current.childNodes;

        for (let i = 0, len = childNodes.length; i < len; i++) {
          const child = childNodes[i];
          if (!child) { continue; }
          let coverNode = node;

          if (passNode && !util.isBreak(child)) {
            if (child.nodeType === 1) {
              if (util.isIgnoreNodeChange(child)) {
                newInnerNode = newInnerNode.cloneNode(false);
                pNode.appendChild(child);
                pNode.appendChild(newInnerNode);
                nNodeArray.push(newInnerNode);
                i--;
              } else {
                recursionFunc(child, child);
              }

              continue;
            }

            newNode = child;
            pCurrent = [];

            while (newNode.parentNode !== null && newNode !== el && newNode !== newInnerNode) {
              if (newNode.nodeType === 1 && validation(newNode)) {
                pCurrent.push(newNode.cloneNode(false));
              }

              newNode = newNode.parentNode;
            }

            if (pCurrent.length > 0) {
              const childNode = pCurrent.pop();
              appendNode = newNode = childNode;

              while (pCurrent.length > 0) {
                newNode = pCurrent.pop();
                appendNode.appendChild(newNode);
                appendNode = newNode;
              }

              newInnerNode.appendChild(childNode);
              node = newNode;
            } else {
              node = newInnerNode;
            }
          } // startContainer


          if (!passNode && child === container) {
            const prevNode = util.createTextNode(
              container.nodeType === 1 ? '' : container.substringData(0, offset)
            );
            const textNode = util.createTextNode(
              container.nodeType === 1 ? '' : container.substringData(offset, container.length - offset)
            );

            if (prevNode.data.length > 0) {
              node.appendChild(prevNode);
            }

            newNode = node;
            pCurrent = [];

            while (newNode !== pNode && newNode !== null) {
              if (newNode.nodeType === 1 && validation(newNode)) {
                pCurrent.push(newNode.cloneNode(false));
              }

              newNode = newNode.parentNode;
            }

            const childNode = pCurrent.pop() || node;
            appendNode = newNode = childNode;

            while (pCurrent.length > 0) {
              newNode = pCurrent.pop();
              appendNode.appendChild(newNode);
              appendNode = newNode;
            }

            if (childNode !== node) {
              newInnerNode.appendChild(childNode);
              node = newNode;
            } else {
              node = newInnerNode;
            }

            if (util.isBreak(child)) { newInnerNode.appendChild(child.cloneNode(false)); }
            pNode.appendChild(newInnerNode);
            container = textNode;
            offset = 0;
            passNode = true;
            node.appendChild(container);
            continue;
          }

          if (!passNode || validation(child)) {
            const cloneNode = child.cloneNode(false);
            node.appendChild(cloneNode);
            if (child.nodeType === 1 && !util.isBreak(child)) { coverNode = cloneNode; }
          }

          recursionFunc(child, coverNode);
        }
      })(element, pNode);

      isRemoveFormat = isRemoveFormat && isRemoveNode;

      if (isRemoveFormat) {
        for (let i = 0; i < nNodeArray.length; i++) {
          const removeNode = nNodeArray[i];
          const textNode = util.createTextNode(removeNode.textContent);
          pNode.insertBefore(textNode, removeNode);
          pNode.removeChild(removeNode);
          if (i === 0) { container = textNode; }
        }
      } else if (isRemoveNode) {
        for (const removeNode of nNodeArray) {
          this._stripRemoveNode(pNode, removeNode);
        }
      }

      if (!isRemoveFormat && pNode.children.length === 0) {
        if (element.childNodes) {
          container = element.childNodes[0];
        } else {
          container = util.createTextNode(util.zeroWidthSpace);
          element.appendChild(container);
        }
      } else {
        util.removeEmptyNode(pNode);

        if (util.onlyZeroWidthSpace(pNode.textContent)) {
          container = pNode.firstChild;
          offset = 0;
        } // node change


        element.parentNode.insertBefore(pNode, element);
        util.removeItem(element);
      }

      return {
        container,
        offset
      };
    },

    /**
     * @description wraps last line selected text.
     * @param element The node of the line that contains the selected text node.
     * @param newInnerNode The dom that will wrap the selected text area
     * @param validation Check if the node should be stripped.
     * @param endCon The endContainer property of the selection object.
     * @param endOff The endOffset property of the selection object.
     * @param isRemoveFormat Is the remove all formats command?
     * @param isRemoveNode "newInnerNode" is remove node?
     */
    _nodeChange_endLine(
      element: any,
      newInnerNode: any,
      validation: (elem: any) => boolean,
      endCon: any,
      endOff: number,
      isRemoveFormat: boolean,
      isRemoveNode: boolean
    ) {
      const el = element;
      const nNodeArray = [newInnerNode];
      const pNode = element.cloneNode(false);
      let container = endCon;
      let offset = endOff;
      let passNode = false;
      let pCurrent;
      let newNode;
      let appendNode;

      (function recursionFunc(current, node) {
        const childNodes = current.childNodes;

        for (let i = childNodes.length - 1; 0 <= i; i--) {
          const child = childNodes[i];
          if (!child) { continue; }
          let coverNode = node;

          if (passNode && !util.isBreak(child)) {
            if (child.nodeType === 1) {
              if (util.isIgnoreNodeChange(child)) {
                newInnerNode = newInnerNode.cloneNode(false);
                pNode.appendChild(child);
                pNode.appendChild(newInnerNode);
                nNodeArray.push(newInnerNode);
                i--;
              } else {
                recursionFunc(child, child);
              }

              continue;
            }

            newNode = child;
            pCurrent = [];

            while (newNode.parentNode !== null && newNode !== el && newNode !== newInnerNode) {
              if (validation(newNode) && newNode.nodeType === 1) {
                pCurrent.push(newNode.cloneNode(false));
              }

              newNode = newNode.parentNode;
            }

            if (pCurrent.length > 0) {
              const childNode = pCurrent.pop();
              appendNode = newNode = childNode;

              while (pCurrent.length > 0) {
                newNode = pCurrent.pop();
                appendNode.appendChild(newNode);
                appendNode = newNode;
              }

              newInnerNode.insertBefore(childNode, newInnerNode.firstChild);
              node = newNode;
            } else {
              node = newInnerNode;
            }
          } // endContainer


          if (!passNode && child === container) {
            const afterNode = util.createTextNode(
              container.nodeType === 1 ? '' : container.substringData(offset, container.length - offset)
            );
            const textNode = util.createTextNode(
              container.nodeType === 1 ? '' : container.substringData(0, offset)
            );

            if (afterNode.data.length > 0) {
              node.insertBefore(afterNode, node.firstChild);
            }

            newNode = node;
            pCurrent = [];

            while (newNode !== pNode && newNode !== null) {
              if (validation(newNode) && newNode.nodeType === 1) {
                pCurrent.push(newNode.cloneNode(false));
              }

              newNode = newNode.parentNode;
            }

            const childNode = pCurrent.pop() || node;
            appendNode = newNode = childNode;

            while (pCurrent.length > 0) {
              newNode = pCurrent.pop();
              appendNode.appendChild(newNode);
              appendNode = newNode;
            }

            if (childNode !== node) {
              newInnerNode.insertBefore(childNode, newInnerNode.firstChild);
              node = newNode;
            } else {
              node = newInnerNode;
            }

            if (util.isBreak(child)) { newInnerNode.appendChild(child.cloneNode(false)); }
            pNode.insertBefore(newInnerNode, pNode.firstChild);
            container = textNode;
            offset = textNode.data.length;
            passNode = true;
            node.insertBefore(container, node.firstChild);
            continue;
          }

          if (!passNode || validation(child)) {
            const cloneNode = child.cloneNode(false);
            node.insertBefore(cloneNode, node.firstChild);
            if (child.nodeType === 1 && !util.isBreak(child)) { coverNode = cloneNode; }
          }

          recursionFunc(child, coverNode);
        }
      })(element, pNode);

      isRemoveFormat = isRemoveFormat && isRemoveNode;

      if (isRemoveFormat) {
        for (let i = 0; i < nNodeArray.length; i++) {
          const removeNode = nNodeArray[i];
          const textNode = util.createTextNode(removeNode.textContent);
          pNode.insertBefore(textNode, removeNode);
          pNode.removeChild(removeNode);

          if (i === nNodeArray.length - 1) {
            container = textNode;
            offset = textNode.textContent.length;
          }
        }
      } else if (isRemoveNode) {
        for (const nodeElement of nNodeArray) {
          this._stripRemoveNode(pNode, nodeElement);
        }
      }

      if (!isRemoveFormat && pNode.childNodes.length === 0) {
        if (element.childNodes) {
          container = element.childNodes[0];
        } else {
          container = util.createTextNode(util.zeroWidthSpace);
          element.appendChild(container);
        }
      } else {
        util.removeEmptyNode(pNode);

        if (util.onlyZeroWidthSpace(pNode.textContent)) {
          container = pNode.firstChild;
          offset = container.textContent.length;
        } else if (util.onlyZeroWidthSpace(container)) {
          container = pNode;
          offset = 0;
        } // node change


        element.parentNode.insertBefore(pNode, element);
        util.removeItem(element);
      }

      return {
        container,
        offset
      };
    },

    /**
     * @description Execute command of command button(All Buttons except submenu and dialog)
     * Possible Commands:
     * (undo, redo, bold, underline, italic, strikethrough, subscript, superscript,
     * removeFormat, indent, outdent, fullscreen, showBlocks, codeview, preview, print)
     * @param target The element of command button
     * @param command Property of command button (data-value)
     */
    commandHandler(target: HTMLElement | Element, command: string) {
      switch (command) {
        case 'selectAll':
          const wysiwyg = context.element.wysiwyg;
          const first = util.getChildElement(
            wysiwyg.firstChild,
            (current) => current.childNodes.length === 0 || current.nodeType === 3
          ) || wysiwyg.firstChild;
          const last = util.getChildElement(
            wysiwyg.lastChild,
            (current) => current.childNodes.length === 0 || current.nodeType === 3,
            true
          ) || wysiwyg.lastChild;
          this.setRange(first, 0, last, last.textContent.length);
          break;

        case 'codeView':
          this.toggleCodeView();
          util.toggleClass(target, 'active');
          break;

        case 'fullScreen':
          this.toggleFullScreen(target);
          util.toggleClass(target, 'active');
          break;

        case 'indent':
        case 'outdent':
          this.indent(command);
          break;

        case 'undo':
          this.history.undo();
          break;

        case 'redo':
          this.history.redo();
          break;

        case 'removeFormat':
          this.removeFormat();
          this.focus();
          break;

        case 'print':
          this.print();
          break;

        case 'preview':
          this.preview();
          break;

        case 'showBlocks':
          this.toggleDisplayBlocks();
          util.toggleClass(target, 'active');
          break;

        case 'save':
          if (typeof context.option.callBackSave === 'function') {
            context.option.callBackSave(this.getContents());
          } else if (typeof userFunction.save === 'function') {
            userFunction.save();
          } else {
            throw Error(
              '[KEDITOR.core.commandHandler.fail] Please register call back function in creation option. (callBackSave : Function)'
            );
          }

          if (context.tool.save) { context.tool.save.setAttribute('disabled', 'true'); }
          break;

        default:
          // 'STRONG', 'INS', 'EM', 'DEL', 'SUB', 'SUP'
          const on = util.hasClass(this.commandMap[command], 'active');

          if (command === 'SUB' && util.hasClass(this.commandMap.SUP, 'active')) {
            this.nodeChange(null, null, ['SUP']);
          } else if (command === 'SUP' && util.hasClass(this.commandMap.SUB, 'active')) {
            this.nodeChange(null, null, ['SUB']);
          }

          this.nodeChange(on ? null : this.util.createElement(command), null, [command]);
          this.focus();
      }
    },

    /**
     * @description Remove format of the currently selected range
     */
    removeFormat() {
      this.nodeChange();
    },

    /**
     * @description This method implements indentation to selected range.
     * Setted "margin-left" to "25px" in the top "P" tag of the parameter node.
     * @param command Separator ("indent" or "outdent")
     */
    indent(command: 'indent' | 'outdent') {
      const rangeLines = this.getSelectedElements();
      let p;
      let margin: number;

      for (let i = 0, len = rangeLines.length; i < len; i++) {
        p = rangeLines[i];
        margin = /\d+/.test(p.style.marginLeft) ? p.style.marginLeft.match(/\d+/)[0] * 1 : 0;

        if ('indent' === command) {
          margin += 25;
        } else {
          margin -= 25;
        }

        p.style.marginLeft = (margin < 0 ? 0 : margin) + 'px';
      }

      event._findButtonEffectTag(); // history stack


      this.history.push();
    },

    /**
     * @description Add or remove the class name of "body" so that the code block is visible
     */
    toggleDisplayBlocks() {
      util.toggleClass(context.element.wysiwyg, 'ke-show-block');
    },

    /**
     * @description Changes to code view or wysiwyg view
     */
    toggleCodeView() {
      const wysiwygActive = this._variable.wysiwygActive;
      const disButtons = this.codeViewDisabledButtons;

      for (let i = 0, len = disButtons.length; i < len; i++) {
        disButtons[i].disabled = wysiwygActive;
      }

      this.controllersOff();

      if (!wysiwygActive) {
        const codeHtml = this._getCodeView();

        if (context.option.fullPage) {
          const parseDocument = new DOMParser().parseFromString(codeHtml, 'text/html');
          const headChildren = parseDocument.head.children;

          for (let i = 0, len = headChildren.length; i < len; i++) {
            if (/script/i.test(headChildren[i].tagName)) {
              parseDocument.head.removeChild(headChildren[i]);
            }
          }

          this._wd.head.innerHTML = parseDocument.head.innerHTML;
          this._wd.body.innerHTML = util.convertContentsForEditor(parseDocument.body.innerHTML);
          const attrs = parseDocument.body.attributes;

          for (let i = 0, len = attrs.length; i < len; i++) {
            if (attrs[i].name === 'contenteditable') { continue; }

            this._wd.body.setAttribute(attrs[i].name, attrs[i].value);
          }
        } else {
          context.element.wysiwyg.innerHTML = codeHtml.length > 0 ? util.convertContentsForEditor(codeHtml) : '<p><br></p>';
        }

        context.element.wysiwygFrame.scrollTop = 0;
        context.element.code.style.display = 'none';
        context.element.wysiwygFrame.style.display = 'block';
        this._variable._codeOriginCssText = (
          this._variable._codeOriginCssText.replace(/(\s?display(\s+)?:(\s+)?)[a-zA-Z]+(?=;)/, 'display: none')
        );
        this._variable._wysiwygOriginCssText = (
          this._variable._wysiwygOriginCssText.replace(/(\s?display(\s+)?:(\s+)?)[a-zA-Z]+(?=;)/, 'display: block')
        );
        if (context.option.height === 'auto' && !context.option.codeMirrorEditor) {
          context.element.code.style.height = '0px';
        }
        this._variable.wysiwygActive = true;
        this.focus();
      } else {
        let codeValue = '';

        if (context.option.fullPage) {
          const headChildren = this._wd.head.children;
          let headTags = '';

          for (let i = 0, len = headChildren.length; i < len; i++) {
            headTags += headChildren[i].outerHTML + '\n';
          }
          // @ts-ignore
          codeValue = '<!DOCTYPE html>\n<html>\n' + this._wd.head.outerHTML.match(/^<head[^>]*>\B/)[0] + '\n' + headTags + '</head>\n' + this._wd.body.outerHTML.match(/^<body[^>]*>\B/)[0] + '\n' + util.convertHTMLForCodeView(context.element.wysiwyg) + '</body>\n</html>';
        } else {
          codeValue = util.convertHTMLForCodeView(context.element.wysiwyg);
        }

        context.element.code.style.display = 'block';
        context.element.wysiwygFrame.style.display = 'none';

        this._setCodeView(codeValue);

        this._variable._codeOriginCssText = this._variable._codeOriginCssText.replace(/(\s?display(\s+)?:(\s+)?)[a-zA-Z]+(?=;)/, 'display: block');
        this._variable._wysiwygOriginCssText = this._variable._wysiwygOriginCssText.replace(/(\s?display(\s+)?:(\s+)?)[a-zA-Z]+(?=;)/, 'display: none');
        if (context.option.height === 'auto' && !context.option.codeMirrorEditor) { context.element.code.style.height = context.element.code.scrollHeight > 0 ? context.element.code.scrollHeight + 'px' : 'auto'; }
        if (context.option.codeMirrorEditor) { context.option.codeMirrorEditor.refresh(); }
        this._variable.wysiwygActive = false;
        context.element.code.focus();
      }
    },

    /**
     * @description Changes to full screen or default screen
     * @param element full screen button
     */
    toggleFullScreen(element: any) {
      const topArea = context.element.topArea;
      const toolbar = context.element.toolbar;
      const editorArea = context.element.editorArea;
      const wysiwyg = context.element.wysiwyg;
      const code = context.element.code;

      if (!this._variable.isFullScreen) {
        this._variable.isFullScreen = true;
        topArea.style.position = 'fixed';
        topArea.style.top = '0';
        topArea.style.left = '0';
        topArea.style.width = '100%';
        topArea.style.height = '100%';
        topArea.style.zIndex = '2147483647';

        if (context.element._stickyDummy.style.display !== 'none') {
          this._variable._fullScreenSticky = true;
          context.element._stickyDummy.style.display = 'none';
          util.removeClass(toolbar, 'ke-toolbar-sticky');
        }

        this._variable._bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this._variable._editorAreaOriginCssText = editorArea.style.cssText;
        this._variable._wysiwygOriginCssText = wysiwyg.style.cssText;
        this._variable._codeOriginCssText = code.style.cssText;
        editorArea.style.cssText = toolbar.style.cssText = '';
        wysiwyg.style.cssText = wysiwyg.style.cssText.match(/\s?display(\s+)?:(\s+)?[a-zA-Z]+;/)[0];
        code.style.cssText = code.style.cssText.match(/\s?display(\s+)?:(\s+)?[a-zA-Z]+;/)[0];
        toolbar.style.width = wysiwyg.style.height = code.style.height = '100%';
        toolbar.style.position = 'relative';
        this._variable.innerHeight_fullScreen = window.innerHeight - toolbar.offsetHeight;
        editorArea.style.height = this._variable.innerHeight_fullScreen + 'px';
        util.removeClass(element.firstElementChild, 'ke-icon-expansion');
        util.addClass(element.firstElementChild, 'ke-icon-reduction');
      } else {
        this._variable.isFullScreen = false;
        wysiwyg.style.cssText = this._variable._wysiwygOriginCssText;
        code.style.cssText = this._variable._codeOriginCssText;
        toolbar.style.cssText = '';
        editorArea.style.cssText = this._variable._editorAreaOriginCssText;
        topArea.style.cssText = this._variable._originCssText;
        document.body.style.overflow = this._variable._bodyOverflow;

        if (context.option.stickyToolbar > -1) {
          util.removeClass(toolbar, 'ke-toolbar-sticky');
          event.onScroll_window();
        }

        if (this._variable._fullScreenSticky) {
          this._variable._fullScreenSticky = false;
          context.element._stickyDummy.style.display = 'block';
          util.addClass(toolbar, 'ke-toolbar-sticky');
        }

        util.removeClass(element.firstElementChild, 'ke-icon-reduction');
        util.addClass(element.firstElementChild, 'ke-icon-expansion');
      }
    },

    /**
     * @description Prints the current contents of the editor.
     */
    print() {
      const iframe: any = util.createElement('IFRAME');
      iframe.style.display = 'none';
      const contents = util.createElement('DIV');
      const style = util.createElement('STYLE');
      style.innerHTML = util.getPageStyle();
      contents.className = 'keditor-editable';
      contents.innerHTML = this.getContents();

      document.body.appendChild(iframe);

      let printDocument = iframe.contentWindow || iframe.contentDocument;
      if (printDocument.document) { printDocument = printDocument.document; }
      printDocument.head.appendChild(style);
      printDocument.body.appendChild(contents);

      try {
        iframe.focus(); // IE or Edge

        // @ts-ignore
        if (window.navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode || !!window.StyleMedia) {
          try {
            iframe.contentWindow.document.execCommand('print', false, null);
          } catch(e) {
            iframe.contentWindow.print();
          }
        } else {
          // Other browsers
          iframe.contentWindow.print();
        }
      } catch(error) {
        throw Error('[KEDITOR.core.print.fail] error: ' + error);
      } finally {
        util.removeItem(iframe);
      }
    },

    /**
     * @description Open the preview window.
     */
    preview() {
      const cssText = util.getPageStyle();
      const contentsHTML = this.getContents();

      const windowObject = window.open('', '_blank');

      // @ts-ignore
      windowObject.mimeType = 'text/html';

      if (context.option.fullPage) {
        // @ts-ignore
        windowObject.document.write('<!DOCTYPE html><html>' + this._wd.head.outerHTML + this._wd.body.outerHTML + '</html>');
      } else {
        // @ts-ignore
        windowObject.document.write('<!DOCTYPE html><html>' + '<head>' + '<meta charset="utf-8" />' + '<meta name="viewport" content="width=device-width, initial-scale=1">' + '<title>' + lang.toolbar.preview + '</title>' + '<style>' + cssText + '</style>' + '</head>' + '<body class="keditor-editable" style="font: small/ 1.5 Arial,Helvetica,sans-serif;">' + contentsHTML + '</body>' + '</html>');
      }
    },

    /**
     * @description Sets the HTML string
     * @param html HTML string
     */
    setContents(html: string) {
      if (core._variable.wysiwygActive) {
        const cleanHTML = util.convertContentsForEditor(html);

        if (cleanHTML !== context.element.wysiwyg.innerHTML) {
          context.element.wysiwyg.innerHTML = cleanHTML; // history stack

          core.history.push();
        }
      } else {
        const value = util.convertHTMLForCodeView(html);

        if (value !== core._getCodeView()) {
          core._setCodeView(value);
        }
      }
    },

    /**
     * @description Gets the current contents
     * @returns An HTML string
     */
    getContents(): string {
      const contents = context.element.wysiwyg.innerHTML;
      const renderHTML = util.createElement('DIV');
      renderHTML.innerHTML = contents;
      const figcaptions = util.getListChildren(renderHTML, (current) => /FIGCAPTION/i.test(current.nodeName));

      for (let i = 0, len = figcaptions.length; i < len; i++) {
        figcaptions[i].removeAttribute('contenteditable');
      }

      if (context.option.fullPage) {
        return '<!DOCTYPE html><html>' + this._wd.head.outerHTML + this._wd.body.outerHTML + '</html>';
      } else {
        return renderHTML.innerHTML;
      }
    },

    /**
     * @description Add an event to document.
     * When created as an Iframe, the same event is added to the document in the Iframe.
     * @param type Event type
     * @param listener Event listener
     * @param useCapture Use event capture
     */
    addDocEvent(type: string, listener: (event: any) => void, useCapture: boolean) {
      document.addEventListener(type, listener, useCapture);

      if (context.option.iframe) {
        this._wd.addEventListener(type, listener);
      }
    },

    /**
     * @description Remove events from document.
     * When created as an Iframe, the event of the document inside the Iframe is also removed.
     * @param type Event type
     * @param listener Event listener
     */
    removeDocEvent(type: string, listener: (event: any) => void) {
      document.removeEventListener(type, listener);

      if (context.option.iframe) {
        this._wd.removeEventListener(type, listener);
      }
    },

    /**
     * @description The current number of characters is counted and displayed.
     * @param nextCharCount Length of character to be added.
     * @param blink Whether the character count should blink (adds class ke-blink)
     * @returns Whether there are characters to count
     */
    _charCount(nextCharCount: number, blink: boolean) {
      const charCounter = context.element.charCounter;
      if (!charCounter) { return true; }
      if (!nextCharCount || nextCharCount < 0) { nextCharCount = 0; }
      const maxCharCount = context.option.maxCharCount;

      window.setTimeout(() => {
        charCounter.textContent = context.element.wysiwyg.textContent.length;
      }, 10);

      if (maxCharCount > 0) {
        let over = false;
        const count = context.element.wysiwyg.textContent.length;

        if (count > maxCharCount) {
          core._editorRange();

          const range = core.getRange();
          const endOff = range.endOffset - 1;
          const text = core.getSelectionNode().textContent;
          core.getSelectionNode().textContent = text.slice(0, range.endOffset - 1) + text.slice(range.endOffset, text.length);
          core.setRange(range.endContainer, endOff, range.endContainer, endOff);
          over = true;
        } else if (count + nextCharCount > maxCharCount) {
          over = true;
        }

        if (over) {
          if (blink && !util.hasClass(charCounter, 'ke-blink')) {
            util.addClass(charCounter, 'ke-blink');

            window.setTimeout(() => util.removeClass(charCounter, 'ke-blink'), 600);
          }

          return false;
        }
      }

      return true;
    },

    /**
     * @description Check the components such as image and video and modify them according to the format.
     */
    _checkComponents() {
      if (this.plugins.image) {
        if (!this.initPlugins.image) {
          this.callPlugin('image', this.plugins.image.checkImagesInfo.bind(this));
        } else {
          this.plugins.image.checkImagesInfo.call(this);
        }
      }

      if (this.plugins.video) {
        if (!this.initPlugins.video) {
          this.callPlugin('video', this.plugins.video.checkVideosInfo.bind(this));
        } else {
          this.plugins.video.checkVideosInfo.call(this);
        }
      }
    },

    /**
     * @description Set method in the code view area
     * @param value HTML string
     */
    _setCodeView(value: string) {
      if (context.option.codeMirrorEditor) {
        context.option.codeMirrorEditor.getDoc().setValue(value);
      } else {
        context.element.code.value = value;
      }
    },

    /**
     * @description Get method in the code view area
     */
    _getCodeView() {
      return context.option.codeMirrorEditor ? context.option.codeMirrorEditor.getDoc().getValue() : context.element.code.value;
    },

    /**
     * @description Initializ core variable
     */
    _init() {
      core._ww = context.option.iframe ? context.element.wysiwygFrame.contentWindow : window;
      core._wd = document;

      window.setTimeout(() => {
        if (libCoreOptions.iframe) {
          core._wd = context.element.wysiwygFrame.contentDocument;
          context.element.wysiwyg = core._wd.body;

          if (libCoreOptions.height === 'auto') {
            core._iframeAuto = core._wd.body;

            core._iframeAutoHeight();
          }
        }
        /** Excute history function, check components */


        core._checkComponents();

        core.history = libHistory(core, event._onChange_historyStack);
      });

      core.codeViewDisabledButtons = context.element.toolbar.querySelectorAll('.ke-toolbar button:not([class~="code-view-enabled"])');
      core._isInline = /inline/i.test(context.option.mode);
      core._isBalloon = /balloon/i.test(context.option.mode);
      core.commandMap = {
        FORMAT: context.tool.format,
        FONT: context.tool.font,
        FONT_TOOLTIP: context.tool.fontTooltip,
        SIZE: context.tool.fontSize,
        ALIGN: context.tool.align,
        LI: context.tool.list,
        LI_ICON: context.tool.list && context.tool.list.querySelector('i'),
        STRONG: context.tool.bold,
        INS: context.tool.underline,
        EM: context.tool.italic,
        DEL: context.tool.strike,
        SUB: context.tool.subscript,
        SUP: context.tool.superscript,
        OUTDENT: context.tool.outdent
      };
      core._variable._originCssText = context.element.topArea.style.cssText;
    },
    _iframeAutoHeight() {
      if (core._iframeAuto) {
        context.element.wysiwygFrame.style.height = core._iframeAuto.offsetHeight + 'px';
      }
    }
  };
  /**
   * @description event function
   */

  const event = {
    _directionKeyKeyCode: new RegExp('^(8|13|32|46|33|34|35|36|37|38|39|40|46|98|100|102|104)$'),
    _historyIgnoreKeycode: new RegExp('^(9|1[6-8]|20|3[3-9]|40|45|11[2-9]|12[0-3]|144|145)$'),
    _onButtonsCheck: new RegExp('^(STRONG|INS|EM|DEL|SUB|SUP|LI)$'),
    _keyCodeShortcut: {
      65: 'A',
      66: 'B',
      83: 'S',
      85: 'U',
      73: 'I',
      89: 'Y',
      90: 'Z',
      219: '[',
      221: ']'
    },
    _shortcutCommand(keyCode, shift) {
      let command = null;
      const keyStr = event._keyCodeShortcut[keyCode];

      switch (keyStr) {
        case 'A':
          command = 'selectAll';
          break;

        case 'B':
          command = 'STRONG';
          break;

        case 'S':
          if (shift) {
            command = 'DEL';
          }

          break;

        case 'U':
          command = 'INS';
          break;

        case 'I':
          command = 'EM';
          break;

        case 'Z':
          if (shift) {
            command = 'redo';
          } else {
            command = 'undo';
          }

          break;

        case 'Y':
          command = 'redo';
          break;

        case '[':
          command = 'outdent';
          break;

        case ']':
          command = 'indent';
          break;
      }

      if (!command) {
        return false;
      }
      core.commandHandler(core.commandMap[command], command);
      return true;
    },
    _findButtonEffectTag() {
      const commandMap = core.commandMap;
      const classOnCheck = this._onButtonsCheck;
      const commandMapNodes = [];
      const currentNodes = [];
      let findFormat = true;
      let findAlign = true;
      let findList = true;
      let findFont = true;
      let findSize = true;
      let findOutdent = true;
      let findA = true;
      let nodeName = '';

      for (
        let selectionParent = core.getSelectionNode();
        !util.isWysiwygDiv(selectionParent);
        selectionParent = selectionParent.parentNode
      ) {
        if (!selectionParent) { break; }
        if (selectionParent.nodeType !== 1 || util.isBreak(selectionParent)) { continue; }
        nodeName = selectionParent.nodeName.toUpperCase();
        currentNodes.push(nodeName);
        /** Format */

        if (util.isFormatElement(selectionParent)) {
          /* Format block */
          if (findFormat && commandMap.FORMAT) {
            commandMapNodes.push('FORMAT');
            util.changeTxt(commandMap.FORMAT, nodeName);
            commandMap.FORMAT.setAttribute('data-focus', nodeName);
            findFormat = false;
          }
          /* Align */


          const textAlign = selectionParent.style.textAlign;

          if (findAlign && textAlign && commandMap.ALIGN) {
            commandMapNodes.push('ALIGN');
            commandMap.ALIGN.className = 'ke-icon-align-' + textAlign;
            commandMap.ALIGN.setAttribute('data-focus', textAlign);
            findAlign = false;
          }
          /* Outdent */


          if (
            findOutdent &&
            selectionParent.style.marginLeft &&
            (selectionParent.style.marginLeft.match(/\d+/) || [0])[0] * 1 > 0 &&
            commandMap.OUTDENT
          ) {
            commandMapNodes.push('OUTDENT');
            commandMap.OUTDENT.removeAttribute('disabled');
            findOutdent = false;
          }

          continue;
        }
        /* List */


        if (findList && util.isList(nodeName) && commandMap.LI) {
          commandMapNodes.push('LI');
          commandMap.LI.setAttribute('data-focus', nodeName);

          if (/UL/i.test(nodeName)) {
            util.removeClass(commandMap.LI_ICON, 'ke-icon-list-number');
            util.addClass(commandMap.LI_ICON, 'ke-icon-list-bullets');
          } else {
            util.removeClass(commandMap.LI_ICON, 'ke-icon-list-bullets');
            util.addClass(commandMap.LI_ICON, 'ke-icon-list-number');
          }

          findList = false;
        }
        /** Font */


        if (findFont && selectionParent.style.fontFamily.length > 0 && commandMap.FONT) {
          commandMapNodes.push('FONT');
          const selectFont = (selectionParent.style.fontFamily || selectionParent.face || lang.toolbar.font).replace(/["']/g, '');
          util.changeTxt(commandMap.FONT, selectFont);
          util.changeTxt(commandMap.FONT_TOOLTIP, selectFont);
          findFont = false;
        }
        /** Size */


        if (findSize && selectionParent.style.fontSize.length > 0 && commandMap.SIZE) {
          commandMapNodes.push('SIZE');
          util.changeTxt(commandMap.SIZE, selectionParent.style.fontSize);
          findSize = false;
        }
        /** A */


        if (findA && /^A$/.test(nodeName) && selectionParent.getAttribute('data-image-link') === null && core.plugins.link) {
          if (!context.link || core.controllerArray[0] !== context.link.linkBtn) {
            core.callPlugin('link', () => {
              core.plugins.link.call_controller_linkButton.call(core, selectionParent);
            });
          }

          findA = false;
        } else if (findA && context.link && core.controllerArray[0] === context.link.linkBtn) {
          core.controllersOff();
        }
        /** strong, ins, em, del, sub, sup */


        if (classOnCheck.test(nodeName)) {
          commandMapNodes.push(nodeName);
        }
      }
      /** toggle class on */


      for (const internalNode of commandMapNodes) {
        if (classOnCheck.test(internalNode)) {
          util.addClass(commandMap[internalNode], 'active');
        }
      }
      /** remove class, display text */


      for (const key in commandMap) {
        if (commandMapNodes.indexOf(key) > -1) { continue; }

        if (commandMap.FONT && /^FONT$/i.test(key)) {
          util.changeTxt(commandMap.FONT, lang.toolbar.font);
          util.changeTxt(commandMap.FONT_TOOLTIP, lang.toolbar.font);
        } else if (commandMap.SIZE && /^SIZE$/i.test(key)) {
          util.changeTxt(commandMap.SIZE, lang.toolbar.fontSize);
        } else if (commandMap.ALIGN && /^ALIGN$/i.test(key)) {
          commandMap.ALIGN.className = 'ke-icon-align-left';
          commandMap.ALIGN.removeAttribute('data-focus');
        } else if (commandMap.OUTDENT && /^OUTDENT$/i.test(key)) {
          commandMap.OUTDENT.setAttribute('disabled', 'true');
        } else if (commandMap.LI && util.isListCell(key)) {
          commandMap.LI.removeAttribute('data-focus');
          util.removeClass(commandMap.LI_ICON, 'ke-icon-list-bullets');
          util.addClass(commandMap.LI_ICON, 'ke-icon-list-number');
          util.removeClass(commandMap.LI, 'active');
        } else {
          util.removeClass(commandMap[key], 'active');
        }
      }
      /** save current nodes */


      core._variable.currentNodes = currentNodes.reverse();
      /**  Displays the current node structure to resizingBar */
      if (core._variable.currentNodes.includes('APP-KOTHING-HTML-EDITOR')) {
        core._variable.currentNodes = [''];
      }
      if (context.option.showPathLabel) { context.element.navigation.textContent = core._variable.currentNodes.join(' > '); }
    },
    _cancelCaptionEdit() {
      this.setAttribute('contenteditable', false);
      this.removeEventListener('blur', event._cancelCaptionEdit);
    },
    onMouseDown_toolbar(e) {
      let target = e.target;

      if (util.getParentElement(target, '.ke-submenu')) {
        e.stopPropagation();
        core._notHideToolbar = true;
      } else {
        e.preventDefault();
        let command = target.getAttribute('data-command');
        let className = target.className;

        while (!command && !/ke-menu-list/.test(className) && !/ke-toolbar/.test(className)) {
          target = target.parentNode;
          command = target.getAttribute('data-command');
          className = target.className;
        }

        if (command === core._submenuName) {
          e.stopPropagation();
        }
      }
    },
    onClick_toolbar(e) {
      e.preventDefault();
      e.stopPropagation();
      let target = e.target;
      let display = target.getAttribute('data-display');
      let command = target.getAttribute('data-command');
      let className = target.className;

      while (!command && !/ke-menu-list/.test(className) && !/ke-toolbar/.test(className)) {
        target = target.parentNode;
        command = target.getAttribute('data-command');
        display = target.getAttribute('data-display');
        className = target.className;
      }

      if (!command && !display) { return; }
      if (target.disabled) { return; }
      core.focus();
      /** Dialog, Submenu */

      if (display) {
        if (/submenu/.test(display) && (target.nextElementSibling === null || target !== core.submenuActiveButton)) {
          core.callPlugin(command, () => core.submenuOn(target));
          return;
        } else if (/dialog/.test(display)) {
          core.callPlugin(command, () => core.plugins.dialog.open.call(core, command, false));
          return;
        }

        core.submenuOff();
        return;
      }
      /** default command */


      if (command) {
        core.commandHandler(target, command);
      }
    },

    /**
     * @warning Events are registered only when there is a table plugin.
     */
    onMouseDown_wysiwyg(e) {
      if (core._isBalloon) {
        event._hideToolbar();
      }

      const tableCell = util.getParentElement(e.target, util.isCell);
      if (!tableCell) {
        return;
      }
      const tablePlugin = core.plugins.table;

      if (tableCell !== tablePlugin._fixedCell && !tablePlugin._shift) {
        core.callPlugin('table', () => tablePlugin.onTableCellMultiSelect.call(core, tableCell, false));
      }
    },
    onClick_wysiwyg(e) {
      const targetElement = e.target;
      if (context.element.wysiwyg.getAttribute('contenteditable') === 'false') { return; }
      e.stopPropagation();

      if (/^FIGURE$/i.test(targetElement.nodeName)) {
        const imageComponent = targetElement.querySelector('IMG');
        const videoComponent = targetElement.querySelector('IFRAME');

        if (imageComponent) {
          e.preventDefault();
          if (!core.plugins.image) { return; }
          core.callPlugin('image', () => {
            const size = core.plugins.resizing.call_controller_resize.call(core, imageComponent, 'image');
            core.plugins.image.onModifyMode.call(core, imageComponent, size);

            if (!util.getParentElement(imageComponent, '.ke-image-container')) {
              core.plugins.image.openModify.call(core, true);
              core.plugins.image.update_image.call(core, true, true);
            }
          });
          return;
        } else if (videoComponent) {
          e.preventDefault();
          if (!core.plugins.video) { return; }
          core.callPlugin('video', () => {
            const size = core.plugins.resizing.call_controller_resize.call(core, videoComponent, 'video');
            core.plugins.video.onModifyMode.call(core, videoComponent, size);
          });
          return;
        }
      }

      const figcaption = util.getParentElement(targetElement, 'FIGCAPTION');

      if (figcaption && figcaption.getAttribute('contenteditable') !== 'ture') {
        e.preventDefault();
        figcaption.setAttribute('contenteditable', 'true');
        figcaption.focus();

        if (core._isInline && !core._inlineToolbarAttr.isShow) {
          event._showToolbarInline();

          const hideToolbar = () => {
            event._hideToolbar();
            figcaption.removeEventListener('blur', hideToolbar);
          };

          figcaption.addEventListener('blur', hideToolbar);
        }
      }

      const formatEl = util.getFormatElement(core.getSelectionNode());
      const rangeEl = util.getRangeFormatElement(core.getSelectionNode());

      if (core.getRange().collapsed && (!formatEl || formatEl === rangeEl) && targetElement.getAttribute('contenteditable') !== 'false') {
        core.execCommand('formatBlock', false, util.isRangeFormatElement(rangeEl) ? 'DIV' : 'P');
        core.focus();
      }

      core._editorRange();

      event._findButtonEffectTag();

      if (core._isBalloon) {
        const range = core.getRange();
        if (range.collapsed) { event._hideToolbar(); } else { event._showToolbarBalloon(range); }
      }

      if (userFunction.onClick) { userFunction.onClick(e); }
    },
    _showToolbarBalloon(rangeObj) {
      const range = rangeObj || core.getRange();
      const toolbar = context.element.toolbar;
      const selection = core.getSelection();
      let isDirTop;

      if (selection.focusNode === selection.anchorNode) {
        isDirTop = selection.focusOffset < selection.anchorOffset;
      } else {
        const childNodes = util.getListChildNodes(range.commonAncestorContainer);
        isDirTop = util.getArrayIndex(childNodes, selection.focusNode) < util.getArrayIndex(childNodes, selection.anchorNode);
      }

      let rects = range.getClientRects();
      rects = rects[isDirTop ? 0 : rects.length - 1];
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const editorWidth = context.element.topArea.offsetWidth;

      const stickyTop = event._getStickyOffsetTop();

      let editorLeft = 0;
      let topArea = context.element.topArea;

      while (topArea && !/^(BODY|HTML)$/i.test(topArea.nodeName)) {
        editorLeft += topArea.offsetLeft;
        topArea = topArea.offsetParent;
      }

      toolbar.style.visibility = 'hidden';
      toolbar.style.display = 'block';

      const arrowMargin = Math.round(context.element._arrow.offsetWidth / 2);

      const toolbarWidth = toolbar.offsetWidth;
      const toolbarHeight = toolbar.offsetHeight;
      const iframeRects = /iframe/i.test(context.element.wysiwygFrame.nodeName) ? context.element.wysiwygFrame.getClientRects()[0] : null;

      if (iframeRects) {
        rects = {
          left: rects.left + iframeRects.left,
          top: rects.top + iframeRects.top,
          right: rects.right + iframeRects.right - iframeRects.width,
          bottom: rects.bottom + iframeRects.bottom - iframeRects.height
        };
      }

      event._setToolbarOffset(isDirTop, rects, toolbar, editorLeft, editorWidth, scrollLeft, scrollTop, stickyTop, arrowMargin);

      if (toolbarWidth !== toolbar.offsetWidth || toolbarHeight !== toolbar.offsetHeight) {
        event._setToolbarOffset(isDirTop, rects, toolbar, editorLeft, editorWidth, scrollLeft, scrollTop, stickyTop, arrowMargin);
      }

      toolbar.style.visibility = '';
    },
    _setToolbarOffset(isDirTop, rects, toolbar, editorLeft, editorWidth, scrollLeft, scrollTop, stickyTop, arrowMargin) {
      const padding = 1;
      const toolbarWidth = toolbar.offsetWidth;
      const toolbarHeight = toolbar.offsetHeight;
      const absoluteLeft = (isDirTop ? rects.left : rects.right) - editorLeft - toolbarWidth / 2 + scrollLeft;
      const overRight = absoluteLeft + toolbarWidth - editorWidth;
      const t = (isDirTop ? rects.top - toolbarHeight - arrowMargin : rects.bottom + arrowMargin) - stickyTop + scrollTop;
      const l = absoluteLeft < 0 ? padding : overRight < 0 ? absoluteLeft : absoluteLeft - overRight - padding - 1;
      toolbar.style.left = Math.floor(l) + 'px';
      toolbar.style.top = Math.floor(t) + 'px';

      if (isDirTop) {
        util.removeClass(context.element._arrow, 'ke-arrow-up');
        util.addClass(context.element._arrow, 'ke-arrow-down');
        context.element._arrow.style.top = toolbarHeight + 'px';
      } else {
        util.removeClass(context.element._arrow, 'ke-arrow-down');
        util.addClass(context.element._arrow, 'ke-arrow-up');
        context.element._arrow.style.top = -arrowMargin + 'px';
      }

      const arrowLeft = Math.floor(toolbarWidth / 2 + (absoluteLeft - l));

      context.element._arrow.style.left = (
        arrowLeft + arrowMargin > toolbar.offsetWidth ? (
          toolbar.offsetWidth - arrowMargin
        ) : (
          arrowLeft < arrowMargin ? arrowMargin : arrowLeft
        )
      ) + 'px';
    },
    _showToolbarInline() {
      const toolbar = context.element.toolbar;
      toolbar.style.visibility = 'hidden';
      toolbar.style.display = 'block';
      core._inlineToolbarAttr.width = toolbar.style.width = context.option.toolbarWidth;
      core._inlineToolbarAttr.top = toolbar.style.top = -1 - toolbar.offsetHeight + 'px';
      if (typeof userFunction.showInline === 'function') { userFunction.showInline(toolbar, context); }
      event.onScroll_window();
      core._inlineToolbarAttr.isShow = true;
      toolbar.style.visibility = '';
    },
    _hideToolbar() {
      if (!core._notHideToolbar) {
        context.element.toolbar.style.display = 'none';
        core._inlineToolbarAttr.isShow = false;
      }

      core._notHideToolbar = false;
    },
    onKeyDown_wysiwyg(e) {
      const keyCode = e.keyCode;
      const shift = e.shiftKey;
      const ctrl = e.ctrlKey || e.metaKey;
      const alt = e.altKey;

      window.setTimeout(core._iframeAutoHeight);

      if (core._isBalloon) {
        event._hideToolbar();
      }
      /** Shortcuts */


      if (ctrl && event._shortcutCommand(keyCode, shift)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      /** default key action */


      const selectionNode = core.getSelectionNode();
      const range = core.getRange();
      const selectRange = range.startContainer !== range.endContainer;
      const resizingName = core._resizingName;
      let formatEl = util.getFormatElement(selectionNode) || selectionNode;
      let rangeEl = util.getRangeFormatElement(selectionNode);

      switch (keyCode) {
        case 8:
          /** backspace key */
          if (selectRange) { break; }

          if (resizingName) {
            e.preventDefault();
            e.stopPropagation();
            core.plugins[resizingName].destroy.call(core);
            break;
          }

          if (
            util.isWysiwygDiv(selectionNode.parentNode) &&
            !selectionNode.previousSibling &&
            util.isFormatElement(selectionNode) &&
            !util.isListCell(selectionNode)
          ) {
            e.preventDefault();
            e.stopPropagation();
            selectionNode.innerHTML = '<br>';
            return false;
          }

          const commonCon = range.commonAncestorContainer;

          if (range.startOffset === 0 && range.endOffset === 0) {
            if (rangeEl && formatEl && !util.isCell(rangeEl) && !/^FIGCAPTION$/i.test(rangeEl.nodeName)) {
              let detach = true;
              let comm = commonCon;

              while (comm && comm !== rangeEl && !util.isWysiwygDiv(comm)) {
                if (comm.previousSibling) {
                  detach = false;
                  break;
                }

                comm = comm.parentNode;
              }

              if (detach && rangeEl.parentNode) {
                e.preventDefault();
                core.detachRangeFormatElement(rangeEl, util.isListCell(formatEl) ? [formatEl] : null, null, false, false);
                break;
              }
            }

            if (util.isComponent(commonCon.previousSibling)) {
              const previousEl = commonCon.previousSibling;
              util.removeItem(previousEl);
            }
          }

          break;

        case 46:
          /** delete key */
          if (resizingName) {
            e.preventDefault();
            e.stopPropagation();
            core.plugins[resizingName].destroy.call(core);
            break;
          }

          if (
            (util.isFormatElement(selectionNode) || selectionNode.nextSibling === null) &&
            range.startOffset === selectionNode.textContent.length
          ) {
            let nextEl = formatEl.nextElementSibling;

            if (util.isComponent(nextEl)) {
              e.preventDefault();

              if (util.onlyZeroWidthSpace(formatEl)) {
                util.removeItem(formatEl);
              }

              if (util.hasClass(nextEl, 'ke-component') || /^IMG$/i.test(nextEl.nodeName)) {
                e.stopPropagation();

                if (util.hasClass(nextEl, 'ke-image-container') || /^IMG$/i.test(nextEl.nodeName)) {
                  nextEl = /^IMG$/i.test(nextEl.nodeName) ? nextEl : nextEl.querySelector('img');
                  core.callPlugin('image', () => {
                    const size = core.plugins.resizing.call_controller_resize.call(core, nextEl, 'image');
                    core.plugins.image.onModifyMode.call(core, nextEl, size);

                    if (!util.getParentElement(nextEl, '.ke-component')) {
                      core.plugins.image.openModify.call(core, true);
                      core.plugins.image.update_image.call(core, true, true);
                    }
                  });
                } else if (util.hasClass(nextEl, 'ke-video-container')) {
                  e.stopPropagation();
                  core.callPlugin('video', () => {
                    const iframe = nextEl.querySelector('iframe');
                    const size = core.plugins.resizing.call_controller_resize.call(core, iframe, 'video');
                    core.plugins.video.onModifyMode.call(core, iframe, size);
                  });
                } // history stack

                core.history.push();
              }

              break;
            }
          }

          break;

        case 9:
          /** tab key */
          e.preventDefault();
          if (ctrl || alt || util.isWysiwygDiv(selectionNode)) { break; }
          core.controllersOff();
          let currentNode = selectionNode;

          while (!util.isCell(currentNode) && !util.isWysiwygDiv(currentNode)) {
            currentNode = currentNode.parentNode;
          }

          if (currentNode && util.isCell(currentNode)) {
            const internalTable = util.getParentElement(currentNode, 'table');
            const cells = util.getListChildren(internalTable, util.isCell);
            let idx = shift ? util.prevIdx(cells, currentNode) : util.nextIdx(cells, currentNode);
            if (idx === cells.length && !shift) { idx = 0; }
            if (idx === -1 && shift) { idx = cells.length - 1; }
            const moveCell = cells[idx];
            if (!moveCell) { return false; }
            core.setRange(moveCell, 0, moveCell, 0);
            break;
          }

          const lines = core.getSelectedElements();

          if (!shift) {
            const tabText = util.createTextNode(new Array(core._variable.tabSize + 1).join('\u00A0'));

            if (lines.length === 1) {
              core.insertNode(tabText);
              core.setRange(tabText, core._variable.tabSize, tabText, core._variable.tabSize);
            } else {
              for (let i = 0, len = lines.length; i < len; i++) {
                lines[i].insertBefore(tabText.cloneNode(false), lines[i].firstChild);
              }
            }
          } else {
            for (let i = 0, len = lines.length, child; i < len; i++) {
              child = lines[i].firstChild;

              if (/^\s{1,4}$/.test(child.textContent)) {
                util.removeItem(child);
              } else if (/^\s{1,4}/.test(child.textContent)) {
                child.textContent = child.textContent.replace(/^\s{1,4}/, '');
              }
            }
          } // history stack


          core.history.push();
          break;

        case 13:
          /** enter key */
          if (selectRange) { break; }
          formatEl = util.getFormatElement(selectionNode);
          rangeEl = util.getRangeFormatElement(selectionNode);
          const figcaption = util.getParentElement(rangeEl, 'FIGCAPTION');

          if (rangeEl && formatEl && !util.isCell(rangeEl) && !/^FIGCAPTION$/i.test(rangeEl.nodeName)) {
            const internalRange = core.getRange();

            if (!internalRange.commonAncestorContainer.nextElementSibling && util.onlyZeroWidthSpace(formatEl.innerText.trim())) {
              e.preventDefault();
              const newEl = core.appendFormatTag(rangeEl, util.isCell(rangeEl.parentNode) ? 'DIV' : util.isListCell(formatEl) ? 'P' : null);
              util.removeItemAllParents(formatEl);
              core.setRange(newEl, 1, newEl, 1);
              break;
            }
          }

          if (rangeEl && figcaption && util.getParentElement(rangeEl, util.isList)) {
            e.preventDefault();
            formatEl = core.appendFormatTag(formatEl);
            core.setRange(formatEl, 0, formatEl, 0);
          }

          if (resizingName) {
            e.preventDefault();
            e.stopPropagation();
            const compContext = context[resizingName];
            const container = compContext._container;
            const sibling = container.previousElementSibling || container.nextElementSibling;
            let newEl = null;

            if (util.isListCell(container.parentNode)) {
              newEl = util.createElement('BR');
            } else {
              newEl = util.createElement(util.isFormatElement(sibling) ? sibling.nodeName : 'P');
              newEl.innerHTML = '<br>';
            }

            container.parentNode.insertBefore(newEl, container);
            core.callPlugin(resizingName, () => {
              core.controllersOff();
              const size = core.plugins.resizing.call_controller_resize.call(core, compContext._element, resizingName);
              core.plugins[resizingName].onModifyMode.call(core, compContext._element, size);
            }); // history stack

            core.history.push();
          }

          break;
      }

      if (shift && /16/.test(keyCode)) {
        e.preventDefault();
        e.stopPropagation();
        const tablePlugin = core.plugins.table;

        if (tablePlugin && !tablePlugin._shift && !tablePlugin._ref) {
          const cell = util.getParentElement(formatEl, util.isCell);

          if (cell) {
            tablePlugin.onTableCellMultiSelect.call(core, cell, true);
            return;
          }
        }
      }

      const textKey = !ctrl && !alt && e.key.length === 1;

      if (!core._charCount(1, textKey)) {
        if (textKey) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }

      if (userFunction.onKeyDown) { userFunction.onKeyDown(e); }
    },
    onKeyUp_wysiwyg(e) {
      core._editorRange();

      const keyCode = e.keyCode;
      let selectionNode = core.getSelectionNode();

      if (core._isBalloon && !core.getRange().collapsed) {
        event._showToolbarBalloon(undefined);

        return;
      }
      /** when format tag deleted */


      if (keyCode === 8 && util.isWysiwygDiv(selectionNode) && selectionNode.textContent === '') {
        e.preventDefault();
        e.stopPropagation();
        selectionNode.innerHTML = '';
        const oFormatTag = util.createElement(util.isFormatElement(core._variable.currentNodes[0]) ? core._variable.currentNodes[0] : 'P');
        oFormatTag.innerHTML = '<br>';
        selectionNode.appendChild(oFormatTag);
        core.setRange(oFormatTag, 0, oFormatTag, 0);

        event._findButtonEffectTag();

        core._checkComponents();

        return;
      }

      const formatEl = util.getFormatElement(selectionNode);
      const rangeEl = util.getRangeFormatElement(selectionNode);

      if (!formatEl || formatEl === rangeEl) {
        core.execCommand('formatBlock', false, util.isRangeFormatElement(rangeEl) ? 'DIV' : 'P');
        core.focus();
        selectionNode = core.getSelectionNode();
      }

      if (event._directionKeyKeyCode.test(keyCode)) {
        event._findButtonEffectTag();
      }

      core._checkComponents();

      if (!core._charCount(1, e.key.length === 1)) {
        if (e.key.length === 1) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
      // history stack
      if (!event._historyIgnoreKeycode.test(keyCode)) {
        core.history.push();
      }

      if (userFunction.onKeyUp) { userFunction.onKeyUp(e); }
    },
    onScroll_wysiwyg(e) {
      core.controllersOff();
      if (core._isBalloon) { event._hideToolbar(); }
      if (userFunction.onScroll) { userFunction.onScroll(e); }
    },
    onMouseDown_resizingBar(e) {
      e.stopPropagation();
      core._variable.resizeClientY = e.clientY;
      context.element.resizeBackground.style.display = 'block';

      function closureFunc() {
        context.element.resizeBackground.style.display = 'none';

        document.removeEventListener('mousemove', event._resize_editor);

        document.removeEventListener('mouseup', closureFunc);
      }

      document.addEventListener('mousemove', event._resize_editor);

      document.addEventListener('mouseup', closureFunc);
    },
    _resize_editor(e) {
      const resizeInterval = context.element.editorArea.offsetHeight + (e.clientY - core._variable.resizeClientY);
      context.element.wysiwygFrame.style.height = context.element.code.style.height = (
        (resizeInterval < core._variable.minResizingSize ? core._variable.minResizingSize : resizeInterval) + 'px'
      );
      core._variable.resizeClientY = e.clientY;
    },
    onResize_window() {
      core.controllersOff();
      if (context.element.toolbar.offsetWidth === 0) { return; }

      if (core._variable.isFullScreen) {
        core._variable.innerHeight_fullScreen += (
          window.innerHeight -
          context.element.toolbar.offsetHeight -
          core._variable.innerHeight_fullScreen
        );
        context.element.editorArea.style.height = core._variable.innerHeight_fullScreen + 'px';
      } else if (core._sticky) {
        context.element.toolbar.style.width = context.element.topArea.offsetWidth - 2 + 'px';
        event.onScroll_window();
      }
    },
    onScroll_window() {
      if (core._variable.isFullScreen || context.element.toolbar.offsetWidth === 0) { return; }
      const element = context.element;
      const editorHeight = element.editorArea.offsetHeight;
      const y = (this.scrollY || document.documentElement.scrollTop) + context.option.stickyToolbar;
      const editorTop = event._getStickyOffsetTop() - (core._isInline ? element.toolbar.offsetHeight : 0);

      if (y < editorTop) {
        event._offStickyToolbar();
      } else if (y + core._variable.minResizingSize >= editorHeight + editorTop) {
        if (!core._sticky) { event._onStickyToolbar(); }
        element.toolbar.style.top = editorHeight + editorTop + context.option.stickyToolbar - y - core._variable.minResizingSize + 'px';
      } else if (y >= editorTop) {
        event._onStickyToolbar();
      }
    },
    _getStickyOffsetTop() {
      let offsetEl = context.element.topArea;
      let offsetTop = 0;

      while (offsetEl) {
        offsetTop += offsetEl.offsetTop;
        offsetEl = offsetEl.offsetParent;
      }

      return offsetTop;
    },
    _onStickyToolbar() {
      const element = context.element;

      if (!core._isInline) {
        element._stickyDummy.style.height = element.toolbar.offsetHeight + 'px';
        element._stickyDummy.style.display = 'block';
      }

      element.toolbar.style.top = context.option.stickyToolbar + 'px';
      element.toolbar.style.width = core._isInline ? core._inlineToolbarAttr.width : element.toolbar.offsetWidth + 'px';
      util.addClass(element.toolbar, 'ke-toolbar-sticky');
      core._sticky = true;
    },
    _offStickyToolbar() {
      const element = context.element;
      element._stickyDummy.style.display = 'none';
      element.toolbar.style.top = core._isInline ? (core._inlineToolbarAttr as any).top : '';
      element.toolbar.style.width = core._isInline ? core._inlineToolbarAttr.width : '';
      element.editorArea.style.marginTop = '';
      util.removeClass(element.toolbar, 'ke-toolbar-sticky');
      core._sticky = false;
    },
    _codeViewAutoHeight() {
      context.element.code.style.height = context.element.code.scrollHeight + 'px';
    },
    onPaste_wysiwyg(e) {
      const clipboardData = e.clipboardData;
      if (!clipboardData) { return true; }

      const maxCharCount = core._charCount(clipboardData.getData('text/plain').length, true);

      const cleanData = util.cleanHTML(clipboardData.getData('text/html'));

      if (typeof userFunction.onPaste === 'function' && !userFunction.onPaste(e, cleanData, maxCharCount)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      if (!maxCharCount) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      if (cleanData) {
        e.stopPropagation();
        e.preventDefault();
        core.execCommand('insertHTML', false, cleanData);
      }
    },
    onCut_wysiwyg() {
      window.setTimeout(() => {
        core._iframeAutoHeight();

        core._charCount(0, false); // history stack


        core.history.push();
      });
    },
    onDragOver_wysiwyg(e) {
      e.preventDefault();
    },
    onDrop_wysiwyg(e) {
      const dataTransfer = e.dataTransfer;
      if (!dataTransfer) { return true; } // files

      const files = dataTransfer.files;

      if (files.length > 0 && core.plugins.image) {
        event._setDropLocationSelection(e);

        core.callPlugin('image', () => {
          context.image.imgInputFile.files = files;
          core.plugins.image.onRender_imgInput.call(core);
          context.image.imgInputFile.files = null;
        }); // check char count
      } else if (!core._charCount(dataTransfer.getData('text/plain').length, true)) {
        e.preventDefault();
        e.stopPropagation();
        return false; // html paste
      } else {
        const cleanData = util.cleanHTML(dataTransfer.getData('text/html'));

        if (cleanData) {
          event._setDropLocationSelection(e);

          core.execCommand('insertHTML', false, cleanData);
        }
      }

      if (userFunction.onDrop) { userFunction.onDrop(e); }
    },
    _setDropLocationSelection(e) {
      e.stopPropagation();
      e.preventDefault();
      const range = core.getRange();
      core.setRange(range.startContainer, range.startOffset, range.endContainer, range.endOffset);
    },
    _onChange_historyStack() {
      if (context.tool.save) { context.tool.save.removeAttribute('disabled'); }
      if (userFunction.onChange) { userFunction.onChange(core.getContents()); }
    },
    _addEvent() {
      const eventWysiwyg = libCoreOptions.iframe ? (core as any)._ww : context.element.wysiwyg;
      /** toolbar event */

      context.element.toolbar.addEventListener('mousedown', event.onMouseDown_toolbar, false);
      context.element.toolbar.addEventListener('click', event.onClick_toolbar, false);
      /** editor area */

      eventWysiwyg.addEventListener('click', event.onClick_wysiwyg, false);
      eventWysiwyg.addEventListener('keydown', event.onKeyDown_wysiwyg, false);
      eventWysiwyg.addEventListener('keyup', event.onKeyUp_wysiwyg, false);
      eventWysiwyg.addEventListener('paste', event.onPaste_wysiwyg, false);
      eventWysiwyg.addEventListener('cut', event.onCut_wysiwyg, false);
      eventWysiwyg.addEventListener('dragover', event.onDragOver_wysiwyg, false);
      eventWysiwyg.addEventListener('drop', event.onDrop_wysiwyg, false);
      eventWysiwyg.addEventListener('scroll', event.onScroll_wysiwyg, false);
      /** Events are registered only a balloon mode or when there is a table plugin. */

      if (core._isBalloon || core.plugins.table) {
        eventWysiwyg.addEventListener('mousedown', event.onMouseDown_wysiwyg, false);
      }
      /** Events are registered only when there is a table plugin.  */


      if (core.plugins.table) {
        eventWysiwyg.addEventListener('touchstart', event.onMouseDown_wysiwyg, {
          passive: true,
          useCapture: false
        });
      }
      /** code view area auto line */


      if (context.option.height === 'auto' && !context.option.codeMirrorEditor) {
        context.element.code.addEventListener('keydown', event._codeViewAutoHeight, false);
        context.element.code.addEventListener('keyup', event._codeViewAutoHeight, false);
        context.element.code.addEventListener('paste', event._codeViewAutoHeight, false);
      }
      /** resizingBar */


      if (context.element.resizingBar) {
        if (/\d+/.test(context.option.height)) {
          context.element.resizingBar.addEventListener('mousedown', event.onMouseDown_resizingBar, false);
        } else {
          util.addClass(context.element.resizingBar, 'ke-resizing-none');
        }
      }
      /** inline editor */


      if (core._isInline) {
        eventWysiwyg.addEventListener('focus', event._showToolbarInline, false);
      }
      /** inline, balloon editor */


      if (core._isInline || core._isBalloon) {
        eventWysiwyg.addEventListener('blur', event._hideToolbar, false);
      }
      /** window event */


      window.removeEventListener('resize', event.onResize_window);

      window.removeEventListener('scroll', event.onScroll_window);

      window.addEventListener('resize', event.onResize_window, false);

      if (context.option.stickyToolbar > -1) {
        window.addEventListener('scroll', event.onScroll_window, false);
      }
    },
    _removeEvent() {
      const eventWysiwyg = libCoreOptions.iframe ? (core as any)._ww : context.element.wysiwyg;
      context.element.toolbar.removeEventListener('mousedown', event.onMouseDown_toolbar);
      context.element.toolbar.removeEventListener('click', event.onClick_toolbar);
      eventWysiwyg.removeEventListener('click', event.onClick_wysiwyg);
      eventWysiwyg.removeEventListener('keydown', event.onKeyDown_wysiwyg);
      eventWysiwyg.removeEventListener('keyup', event.onKeyUp_wysiwyg);
      eventWysiwyg.removeEventListener('paste', event.onPaste_wysiwyg);
      eventWysiwyg.removeEventListener('cut', event.onCut_wysiwyg);
      eventWysiwyg.removeEventListener('dragover', event.onDragOver_wysiwyg);
      eventWysiwyg.removeEventListener('drop', event.onDrop_wysiwyg);
      eventWysiwyg.removeEventListener('scroll', event.onScroll_wysiwyg);
      eventWysiwyg.removeEventListener('mousedown', event.onMouseDown_wysiwyg);
      eventWysiwyg.removeEventListener('touchstart', event.onMouseDown_wysiwyg, {
        passive: true,
        useCapture: false
      });
      eventWysiwyg.removeEventListener('focus', event._showToolbarInline);
      eventWysiwyg.removeEventListener('blur', event._hideToolbar);
      context.element.code.removeEventListener('keydown', event._codeViewAutoHeight);
      context.element.code.removeEventListener('keyup', event._codeViewAutoHeight);
      context.element.code.removeEventListener('paste', event._codeViewAutoHeight);

      if (context.element.resizingBar) {
        context.element.resizingBar.removeEventListener('mousedown', event.onMouseDown_resizingBar);
      }

      window.removeEventListener('resize', event.onResize_window);

      window.removeEventListener('scroll', event.onScroll_window);
    }
  };
  /** User function */

  const userFunction = {
    /**
     * @description Event functions
     * @param event Event Object
     */
    onScroll: null as (event: any) => void,
    onClick: null as (event: any) => void,
    onKeyDown: null as (event: any) => void,
    onKeyUp: null as (event: any) => void,
    onDrop: null as (event: any) => void,
    onChange: null as (event: any) => void,
    onPaste: null as (event: any, cleanData: string, maxCharCount: boolean) => boolean,
    showInline: null as (event: any, context: any) => void,

    /**
     * @description Called when the image is uploaded or the uploaded image is deleted
     * @param targetImgElement Current img element
     * @param index Uploaded index
     * @param isDelete Whether or not it was called after the delete operation
     * @param imageInfo Image info object
     * @param remainingFilesCount The number of images remaining or null/zero if there are no remaining files
     */
    onImageUpload: null as (
      targetImgElement: HTMLImageElement,
      index: number,
      isDelete: boolean,
      imageInfo: any,
      remainingFilesCount: number | null
    ) => void,

    /**
     * @description Called when the image is upload failed
     * @param errorMessage Error message
     * @param result Result info Object
     */
    onImageUploadError: null as (errorMessage: string, result: any) => void,

    /**
     * @description Add or reset option property
     * @param options Options
     */
    setOptions(options: any) {
      event._removeEvent();

      core.plugins = options.plugins || core.plugins;
      const mergeOptions = [context.option, options].reduce((init, option) => {
        Object.keys(option).forEach((key) => {
          init[key] = option[key];
        });
        return init;
      }, {});

      const cons = libConstructor._setOptions(mergeOptions, context, core.plugins, context.option);

      if (cons.callButtons) {
        pluginCallButtons = cons.callButtons;
        core.initPlugins = {};
      }

      if (cons.plugins) {
        core.plugins = plugins = cons.plugins;
      } // reset context


      const el = context.element;
      const constructed = {
        _top: el.topArea,
        _relative: el.relative,
        _toolBar: el.toolbar,
        _editorArea: el.editorArea,
        _wysiwygArea: el.wysiwygFrame,
        _codeArea: el.code,
        _resizingBar: el.resizingBar,
        _navigation: el.navigation,
        _charCounter: el.charCounter,
        _loading: el.loading,
        _resizeBack: el.resizeBackground,
        _stickyDummy: el._stickyDummy,
        _arrow: el._arrow
      };
      libCoreOptions = mergeOptions;
      core.lang = lang = libCoreOptions.lang;
      core.context = context = libContextObj(context.element.originElement, constructed, libCoreOptions);

      core._init();

      event._addEvent();

      event._offStickyToolbar();

      event.onResize_window();

      core._checkComponents();

      core.history = libHistory(core, event._onChange_historyStack);

      core._charCount(0, false);

      core.focus();
    },

    /**
     * @description Open a notice area
     * @param message Notice message
     */
    noticeOpen(message: string) {
      core.addModule([notice]);
      notice.open.call(core, message);
    },

    /**
     * @description Close a notice area
     */
    noticeClose() {
      core.addModule([notice]);
      notice.close.call(core);
    },

    /**
     * @description Copying the contents of the editor to the original textarea
     */
    save() {
      context.element.originElement.value = core.getContents();
    },

    /**
     * @description Gets the keditor's context object. Contains settings, plugins, and cached element objects
     */
    getContext(): any {
      return context;
    },

    /**
     * @description Gets the contents of the keditor
     */
    getContents(): string {
      return core.getContents();
    },

    /**
     * @description Gets uploaded images informations
     */
    getImagesInfo(): any[] {
      return core._variable._imagesInfo;
    },

    /**
     * @description Upload images using image plugin
     * @param files The FileList containing the files to be inserted
     */
    insertImage(files: FileList = null) {
      if (!core.plugins.image || !files) { return; }
      if (!(core.initPlugins as any).image) {
        core.callPlugin('image', core.plugins.image.submitAction.bind(core, files));
      } else {
        core.plugins.image.submitAction.call(core, files);
      }
      core.focus();
    },

    /**
     * @description Inserts an HTML element or HTML string or plain string at the current cursor position
     * @param html HTML Element or HTML string or plain string
     */
    insertHTML(html: HTMLElement | string) {
      if (typeof html === 'string' || !html.nodeType || html.nodeType !== 1) {
        const innerTemplate: any = util.createElement('DIV');
        innerTemplate.innerHTML = html.toString();
        html = (innerTemplate.firstChild || innerTemplate.content.firstChild) as HTMLElement;
      }

      let afterNode = null;

      if (util.isFormatElement(html) || /^(IMG|IFRAME)$/i.test(html.nodeName)) {
        afterNode = util.getFormatElement(core.getSelectionNode());
      }

      core.insertNode(html, afterNode);
      core.focus();
    },

    /**
     * @description Change the contents of the keditor
     * @param contents Contents to Input
     */
    setContents(contents: string) {
      core.setContents(contents);
    },

    /**
     * @description Add contents to the keditor
     * @param contents Contents to Input
     */
    appendContents(contents: string) {
      if (core._variable.wysiwygActive) {
        context.element.wysiwyg.innerHTML += util.convertContentsForEditor(contents);
      } else {
        core._setCodeView(core._getCodeView() + util.convertHTMLForCodeView(contents));
      } // history stack


      core.history.push();
    },

    /**
     * @description Disable the keditor
     */
    disabled() {
      context.tool.cover.style.display = 'block';
      context.element.wysiwyg.setAttribute('contenteditable', false);

      if (context.option.codeMirrorEditor) {
        context.option.codeMirrorEditor.setOption('readOnly', true);
      } else {
        context.element.code.setAttribute('disabled', 'disabled');
      }
    },

    /**
     * @description Enabled the keditor
     */
    enabled() {
      context.tool.cover.style.display = 'none';
      context.element.wysiwyg.setAttribute('contenteditable', true);

      if (context.option.codeMirrorEditor) {
        context.option.codeMirrorEditor.setOption('readOnly', false);
      } else {
        context.element.code.removeAttribute('disabled');
      }
    },

    /**
     * @description Show the keditor
     */
    show() {
      const topAreaStyle = context.element.topArea.style;
      if (topAreaStyle.display === 'none') { topAreaStyle.display = context.option.display; }
    },

    /**
     * @description Hide the keditor
     */
    hide() {
      context.element.topArea.style.display = 'none';
    },

    /**
     * @description Destroy the keditor
     */
    destroy() {
      /** remove event listeners */
      event._removeEvent();
      /** remove element */


      util.removeItem(context.element.topArea);
      /** remove object reference */

      Object.keys(core).forEach((key) => {
        delete core[key];
      });

      Object.keys(event).forEach((key) => {
        delete event[key];
      });

      Object.keys(context).forEach((key) => {
        delete context[key];
      });

      Object.keys(pluginCallButtons).forEach((key) => {
        delete pluginCallButtons[key];
      });
      /** remove user object */

      Object.keys(this).forEach(function(key) {
        delete this[key];
      }.bind(this));
    }
  };
  /** initialize core and add event listeners */

  core._init();

  event._addEvent();

  core._charCount(0, false);

  return userFunction;
});

// CONCATENATED MODULE: ./src/keditor.js
/*
 * keditor.js
 * Copyright Kothing
 * MIT license.
 */
const srcKeditor = ({
  /**
   * @description Returns the create function with preset options.
   * If the options overlap, the options of the 'create' function take precedence.
   * @param srcInitOptions Initialization options
   * @returns An object with a function at the 'create' property to create the editor
   */
  init(srcInitOptions: any) {
    return {
      create(idOrElement, options) {
        return srcKeditor.create(srcInitOptions, idOrElement, options);
      }
    };
  },

  /**
   * @description Create the keditor
   * @param initCreateOptions The initial default options object
   * @param idOrElement Textarea Id or textarea element
   * @param options User options to overwrite default values
   * @returns The KInterface with callbacks properties and manipulation functions
   */
  create(initCreateOptions, idOrElement: HTMLElement | string, options = null) {
    if (typeof options !== 'object') { options = {}; }

    if (initCreateOptions) {
      options = [initCreateOptions, options].reduce((init, option) => {
        Object.keys(option).forEach((key) => {
          init[key] = option[key];
        });
        return init;
      }, {});
    }

    const element = typeof idOrElement === 'string' ? document.getElementById(idOrElement) : idOrElement;

    if (!element) {
      if (typeof idOrElement === 'string') {
        throw Error('[KEDITOR.create.fail] The element for that id was not found (ID:"' + idOrElement + '")');
      }

      throw Error('[KEDITOR.create.fail] keditor requires textarea\'s element or id value');
    }

    const cons = libConstructor.init(element, options);

    if (cons.constructed._top.id && document.getElementById(cons.constructed._top.id)) {
      throw Error(
        '[KEDITOR.create.fail]' +
        'The ID of the keditor you are trying to create already exists (ID:"' + cons.constructed._top.id + '")'
      );
    }

    element.style.display = 'none';
    cons.constructed._top.style.display = 'block';
    /** Create to sibling node */

    if (typeof element.nextElementSibling === 'object') {
      element.parentNode.insertBefore(cons.constructed._top, element.nextElementSibling);
    } else {
      element.parentNode.appendChild(cons.constructed._top);
    }

    return libCore(
      libContextObj(element, cons.constructed, cons.options),
      cons.pluginCallButtons,
      cons.plugins,
      cons.options.lang,
      options
    );
  }
});
// CONCATENATED MODULE: ./src/index.js

const KEDITOR = srcKeditor.init({
  plugins: srcPlugins
});

export interface KInterface {
  /**
   * @description Event functions which will be called on each situation
   * @param event Event Object
   */
  onScroll?: (event: any) => void;
  onClick?: (event: any) => void;
  onKeyDown?: (event: any) => void;
  onKeyUp?: (event: any) => void;
  onDrop?: (event: any) => void;
  onChange?: (event: any) => void;
  onPaste?: (event: any, cleanData: string, maxCharCount: boolean) => boolean;
  showInline?: (event: any, context: any) => void;

  /**
   * @description Will be called when the image is uploaded or the uploaded image is deleted
   * @param targetImgElement Current img element
   * @param index Uploaded index
   * @param isDelete Whether or not it was called after the delete operation
   * @param imageInfo Image info object
   */
  onImageUpload?: (
    targetImgElement: HTMLImageElement,
    index: number,
    isDelete: boolean,
    imageInfo: any,
    remainingFilesCount: number | null
  ) => void;

  /**
   * @description Will be called when the image is upload failed
   * @param errorMessage Error message
   * @param result Result info Object
   */
  onImageUploadError?: (errorMessage: string, result: any) => void;

  /**
   * @description Add or reset option property
   * @param options Options
   */
  setOptions: (options: any) => void;

  /**
   * @description Open a notice area
   * @param message Notice message
   */
  noticeOpen: (message: string) => void;

  /**
   * @description Close a notice area
   */
  noticeClose: () => void;

  /**
   * @description Copying the contents of the editor to the original textarea
   */
  save: () => void;

  /**
   * @description Gets the keditor's context object. Contains settings, plugins, and cached element objects
   * @returns The keditor context object
   */
  getContext: () => any;

  /**
   * @description Gets the contents of the keditor
   * @returns The content as raw HTML (might contain javascript when the user adds it)
   */
  getContents: () => string;

  /**
   * @description Gets uploaded images informations
   * @returns The list of information of uploaded images
   */
  getImagesInfo: () => any[];

  /**
   * @description Upload images using image plugin
   * @param files FileList
   */
  insertImage: (files: FileList) => void;

  /**
   * @description Inserts an HTML element or HTML string or plain string at the current cursor position
   * @param html HTML Element or HTML string or plain string
   */
  insertHTML: (html: HTMLElement | string) => void;

  /**
   * @description Change the contents of the keditor
   * @param contents Contents to Input
   */
  setContents: (contents: string) => void;

  /**
   * @description Add contents to the keditor
   * @param contents Contents to Input
   */
  appendContents: (contents: string) => void;

  /**
   * @description Disable the keditor
   */
  disabled: () => void;

  /**
   * @description Enabled the keditor
   */
  enabled: () => void;

  /**
   * @description Show the keditor
   */
  show: () => void;

  /**
   * @description Hide the keditor
   */
  hide: () => void;

  /**
   * @description Destroy the keditor
   */
  destroy: () => void;
}

export default KEDITOR;
